const playersAndStats18 = {
  "Joe Flacco": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 5,
    "full_name": "joeflacco",
    "first_name": "Joe",
    "last_name": "Flacco",
    "position": "QB",
    "age": 34,
    "team": "DEN",
    "player_id": "19",
    "my_id": 19,
    "gp": 9,
    "gs": 9,
    "pts_ppr": 137.1,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 19,
    "rush_td": 0,
    "rush_yd": 45,
    "td": 0,
    "pass_td": 12,
    "pass_int": 6,
    "pass_cmp": 232,
    "pass_att": 379,
    "pass_yd": 2465,
    "pass_inc": 147,
    "fum_lost": 1
  },
  "Matt Ryan": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 2,
    "full_name": "mattryan",
    "first_name": "Matt",
    "last_name": "Ryan",
    "position": "QB",
    "age": 34,
    "team": "ATL",
    "player_id": "24",
    "my_id": 24,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 354.96,
    "rec": 1,
    "rec_yd": 5,
    "rec_td": 1,
    "rec_tgt": 1,
    "rush_att": 33,
    "rush_td": 3,
    "rush_yd": 125,
    "td": 4,
    "pass_td": 35,
    "pass_int": 7,
    "pass_cmp": 422,
    "pass_att": 608,
    "pass_yd": 4924,
    "pass_inc": 186,
    "fum_lost": 5
  },
  "Greg Olsen": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 88,
    "full_name": "gregolsen",
    "first_name": "Greg",
    "last_name": "Olsen",
    "position": "TE",
    "age": 34,
    "team": "CAR",
    "player_id": "58",
    "my_id": 58,
    "gp": 9,
    "gs": 9,
    "pts_ppr": 80.1,
    "rec": 27,
    "rec_yd": 291,
    "rec_td": 4,
    "rec_tgt": 38,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Chad Henne": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 4,
    "full_name": "chadhenne",
    "first_name": "Chad",
    "last_name": "Henne",
    "position": "QB",
    "age": 34,
    "team": "KC",
    "player_id": "89",
    "my_id": 89,
    "gp": 1,
    "gs": 0,
    "pts_ppr": 1.46,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 3,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 2,
    "pass_att": 3,
    "pass_yd": 29,
    "pass_inc": 1,
    "fum_lost": 0
  },
  "Aaron Rodgers": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 12,
    "full_name": "aaronrodgers",
    "first_name": "Aaron",
    "last_name": "Rodgers",
    "position": "QB",
    "age": 35,
    "team": "GB",
    "player_id": "96",
    "my_id": 96,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 312.58,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 43,
    "rush_td": 2,
    "rush_yd": 269,
    "td": 2,
    "pass_td": 25,
    "pass_int": 2,
    "pass_cmp": 372,
    "pass_att": 597,
    "pass_yd": 4442,
    "pass_inc": 225,
    "fum_lost": 3
  },
  "Marcedes Lewis": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 89,
    "full_name": "marcedeslewis",
    "first_name": "Marcedes",
    "last_name": "Lewis",
    "position": "TE",
    "age": 35,
    "team": "GB",
    "player_id": "111",
    "my_id": 111,
    "gp": 16,
    "gs": 4,
    "pts_ppr": 6.9,
    "rec": 3,
    "rec_yd": 39,
    "rec_td": 0,
    "rec_tgt": 4,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Ben Roethlisberger": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 7,
    "full_name": "benroethlisberger",
    "first_name": "Ben",
    "last_name": "Roethlisberger",
    "position": "QB",
    "age": 37,
    "team": "PIT",
    "player_id": "138",
    "my_id": 138,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 341.86,
    "rec": 1,
    "rec_yd": -1,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 31,
    "rush_td": 3,
    "rush_yd": 98,
    "td": 3,
    "pass_td": 34,
    "pass_int": 16,
    "pass_cmp": 452,
    "pass_att": 675,
    "pass_yd": 5129,
    "pass_inc": 223,
    "fum_lost": 2
  },
  "DeSean Jackson": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 10,
    "full_name": "deseanjackson",
    "first_name": "DeSean",
    "last_name": "Jackson",
    "position": "WR",
    "age": 32,
    "team": "PHI",
    "player_id": "147",
    "my_id": 147,
    "gp": 12,
    "gs": 10,
    "pts_ppr": 151.3,
    "rec": 41,
    "rec_yd": 774,
    "rec_td": 4,
    "rec_tgt": 74,
    "rush_att": 6,
    "rush_td": 1,
    "rush_yd": 29,
    "td": 5,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Tom Brady": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 12,
    "full_name": "tombrady",
    "first_name": "Tom",
    "last_name": "Brady",
    "position": "QB",
    "age": 42,
    "team": "NE",
    "player_id": "167",
    "my_id": 167,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 281.3,
    "rec": 1,
    "rec_yd": 6,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 23,
    "rush_td": 2,
    "rush_yd": 35,
    "td": 2,
    "pass_td": 29,
    "pass_int": 11,
    "pass_cmp": 375,
    "pass_att": 570,
    "pass_yd": 4355,
    "pass_inc": 195,
    "fum_lost": 2
  },
  "Jordy Nelson": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 82,
    "full_name": "jordynelson",
    "first_name": "Jordy",
    "last_name": "Nelson",
    "position": "WR",
    "age": 34,
    "team": null,
    "player_id": "175",
    "my_id": 175,
    "gp": 15,
    "gs": 14,
    "pts_ppr": 156.7,
    "rec": 63,
    "rec_yd": 739,
    "rec_td": 3,
    "rec_tgt": 88,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": -2,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Matt Schaub": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 8,
    "full_name": "mattschaub",
    "first_name": "Matt",
    "last_name": "Schaub",
    "position": "QB",
    "age": 38,
    "team": "ATL",
    "player_id": "178",
    "my_id": 178,
    "gp": 3,
    "gs": 0,
    "pts_ppr": 1.1,
    "rec": 1,
    "rec_yd": -7,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 5,
    "pass_att": 7,
    "pass_yd": 20,
    "pass_inc": 2,
    "fum_lost": 0
  },
  "Adrian Peterson": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 26,
    "full_name": "adrianpeterson",
    "first_name": "Adrian",
    "last_name": "Peterson",
    "position": "RB",
    "age": 34,
    "team": "WAS",
    "player_id": "184",
    "my_id": 184,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 189,
    "rec": 20,
    "rec_yd": 208,
    "rec_td": 1,
    "rec_tgt": 26,
    "rush_att": 251,
    "rush_td": 7,
    "rush_yd": 1042,
    "td": 8,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 2
  },
  "Eli Manning": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 10,
    "full_name": "elimanning",
    "first_name": "Eli",
    "last_name": "Manning",
    "position": "QB",
    "age": 38,
    "team": "NYG",
    "player_id": "188",
    "my_id": 188,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 239.96,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 15,
    "rush_td": 1,
    "rush_yd": 20,
    "td": 1,
    "pass_td": 21,
    "pass_int": 11,
    "pass_cmp": 380,
    "pass_att": 576,
    "pass_yd": 4299,
    "pass_inc": 196,
    "fum_lost": 4
  },
  "Vernon Davis": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 85,
    "full_name": "vernondavis",
    "first_name": "Vernon",
    "last_name": "Davis",
    "position": "TE",
    "age": 35,
    "team": "WAS",
    "player_id": "200",
    "my_id": 200,
    "gp": 14,
    "gs": 8,
    "pts_ppr": 75.7,
    "rec": 25,
    "rec_yd": 367,
    "rec_td": 2,
    "rec_tgt": 36,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Josh McCown": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 18,
    "full_name": "joshmccown",
    "first_name": "Josh",
    "last_name": "McCown",
    "position": "QB",
    "age": 40,
    "team": "PHI",
    "player_id": "208",
    "my_id": 208,
    "gp": 4,
    "gs": 3,
    "pts_ppr": 20.76,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 5,
    "rush_td": 0,
    "rush_yd": 32,
    "td": 0,
    "pass_td": 1,
    "pass_int": 4,
    "pass_cmp": 60,
    "pass_att": 110,
    "pass_yd": 539,
    "pass_inc": 49,
    "fum_lost": 0
  },
  "Jonathan Stewart": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 28,
    "full_name": "jonathanstewart",
    "first_name": "Jonathan",
    "last_name": "Stewart",
    "position": "RB",
    "age": 32,
    "team": null,
    "player_id": "218",
    "my_id": 218,
    "gp": 3,
    "gs": 0,
    "pts_ppr": 1.7,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 6,
    "rush_td": 0,
    "rush_yd": 17,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Larry Fitzgerald": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 11,
    "full_name": "larryfitzgerald",
    "first_name": "Larry",
    "last_name": "Fitzgerald",
    "position": "WR",
    "age": 36,
    "team": "ARI",
    "player_id": "223",
    "my_id": 223,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 185.68,
    "rec": 69,
    "rec_yd": 734,
    "rec_td": 6,
    "rec_tgt": 112,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 6,
    "pass_td": 1,
    "pass_int": 0,
    "pass_cmp": 1,
    "pass_att": 1,
    "pass_yd": 32,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Frank Gore": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 20,
    "full_name": "frankgore",
    "first_name": "Frank",
    "last_name": "Gore",
    "position": "RB",
    "age": 36,
    "team": "BUF",
    "player_id": "232",
    "my_id": 232,
    "gp": 14,
    "gs": 13,
    "pts_ppr": 102.6,
    "rec": 12,
    "rec_yd": 124,
    "rec_td": 1,
    "rec_tgt": 16,
    "rush_att": 156,
    "rush_td": 0,
    "rush_yd": 722,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Darren Sproles": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 43,
    "full_name": "darrensproles",
    "first_name": "Darren",
    "last_name": "Sproles",
    "position": "RB",
    "age": 36,
    "team": "PHI",
    "player_id": "246",
    "my_id": 246,
    "gp": 6,
    "gs": 2,
    "pts_ppr": 61,
    "rec": 15,
    "rec_yd": 160,
    "rec_td": 2,
    "rec_tgt": 23,
    "rush_att": 29,
    "rush_td": 1,
    "rush_yd": 120,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Josh Johnson": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 8,
    "full_name": "joshjohnson",
    "first_name": "Josh",
    "last_name": "Johnson",
    "position": "QB",
    "age": 33,
    "team": null,
    "player_id": "260",
    "my_id": 260,
    "gp": 4,
    "gs": 3,
    "pts_ppr": 49.6,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 23,
    "rush_td": 1,
    "rush_yd": 120,
    "td": 1,
    "pass_td": 3,
    "pass_int": 4,
    "pass_cmp": 52,
    "pass_att": 91,
    "pass_yd": 590,
    "pass_inc": 39,
    "fum_lost": 0
  },
  "Alex Smith": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 11,
    "full_name": "alexsmith",
    "first_name": "Alex",
    "last_name": "Smith",
    "position": "QB",
    "age": 35,
    "team": "WAS",
    "player_id": "268",
    "my_id": 268,
    "gp": 10,
    "gs": 10,
    "pts_ppr": 138,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 41,
    "rush_td": 1,
    "rush_yd": 168,
    "td": 1,
    "pass_td": 10,
    "pass_int": 5,
    "pass_cmp": 205,
    "pass_att": 328,
    "pass_yd": 2180,
    "pass_inc": 123,
    "fum_lost": 1
  },
  "Pierre Garcon": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 15,
    "full_name": "pierregarcon",
    "first_name": "Pierre",
    "last_name": "Garcon",
    "position": "WR",
    "age": 33,
    "team": null,
    "player_id": "269",
    "my_id": 269,
    "gp": 8,
    "gs": 8,
    "pts_ppr": 58.6,
    "rec": 24,
    "rec_yd": 286,
    "rec_td": 1,
    "rec_tgt": 45,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Delanie Walker": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 82,
    "full_name": "delaniewalker",
    "first_name": "Delanie",
    "last_name": "Walker",
    "position": "TE",
    "age": 35,
    "team": "TEN",
    "player_id": "284",
    "my_id": 284,
    "gp": 1,
    "gs": 1,
    "pts_ppr": 9.2,
    "rec": 4,
    "rec_yd": 52,
    "rec_td": 0,
    "rec_tgt": 7,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Drew Brees": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 9,
    "full_name": "drewbrees",
    "first_name": "Drew",
    "last_name": "Brees",
    "position": "QB",
    "age": 40,
    "team": "NO",
    "player_id": "289",
    "my_id": 289,
    "gp": 15,
    "gs": 15,
    "pts_ppr": 304.98,
    "rec": 1,
    "rec_yd": 1,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 31,
    "rush_td": 4,
    "rush_yd": 22,
    "td": 4,
    "pass_td": 32,
    "pass_int": 5,
    "pass_cmp": 364,
    "pass_att": 489,
    "pass_yd": 3992,
    "pass_inc": 125,
    "fum_lost": 1
  },
  "Matthew Slater": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 18,
    "full_name": "matthewslater",
    "first_name": "Matthew",
    "last_name": "Slater",
    "position": "WR",
    "age": 34,
    "team": "NE",
    "player_id": "312",
    "my_id": 312,
    "gp": 16,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Antonio Gates": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 85,
    "full_name": "antoniogates",
    "first_name": "Antonio",
    "last_name": "Gates",
    "position": "TE",
    "age": 39,
    "team": null,
    "player_id": "322",
    "my_id": 322,
    "gp": 16,
    "gs": 1,
    "pts_ppr": 75.3,
    "rec": 28,
    "rec_yd": 333,
    "rec_td": 2,
    "rec_tgt": 46,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Jamaal Charles": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 31,
    "full_name": "jamaalcharles",
    "first_name": "Jamaal",
    "last_name": "Charles",
    "position": "RB",
    "age": 32,
    "team": null,
    "player_id": "323",
    "my_id": 323,
    "gp": 2,
    "gs": 0,
    "pts_ppr": 3.4,
    "rec": 2,
    "rec_yd": 7,
    "rec_td": 0,
    "rec_tgt": 3,
    "rush_att": 6,
    "rush_td": 0,
    "rush_yd": 7,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Philip Rivers": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 17,
    "full_name": "philiprivers",
    "first_name": "Philip",
    "last_name": "Rivers",
    "position": "QB",
    "age": 37,
    "team": "LAC",
    "player_id": "331",
    "my_id": 331,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 285.02,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 18,
    "rush_td": 0,
    "rush_yd": 7,
    "td": 0,
    "pass_td": 32,
    "pass_int": 12,
    "pass_cmp": 347,
    "pass_att": 508,
    "pass_yd": 4308,
    "pass_inc": 161,
    "fum_lost": 1
  },
  "Ryan Fitzpatrick": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 14,
    "full_name": "ryanfitzpatrick",
    "first_name": "Ryan",
    "last_name": "Fitzpatrick",
    "position": "QB",
    "age": 36,
    "team": "MIA",
    "player_id": "333",
    "my_id": 333,
    "gp": 8,
    "gs": 7,
    "pts_ppr": 165.84,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 36,
    "rush_td": 2,
    "rush_yd": 152,
    "td": 2,
    "pass_td": 17,
    "pass_int": 12,
    "pass_cmp": 164,
    "pass_att": 246,
    "pass_yd": 2366,
    "pass_inc": 82,
    "fum_lost": 1
  },
  "Julian Edelman": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 11,
    "full_name": "julianedelman",
    "first_name": "Julian",
    "last_name": "Edelman",
    "position": "WR",
    "age": 33,
    "team": "NE",
    "player_id": "344",
    "my_id": 344,
    "gp": 12,
    "gs": 12,
    "pts_ppr": 207.42,
    "rec": 74,
    "rec_yd": 850,
    "rec_td": 6,
    "rec_tgt": 108,
    "rush_att": 9,
    "rush_td": 0,
    "rush_yd": 107,
    "td": 6,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 2,
    "pass_att": 2,
    "pass_yd": 43,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Brian Hoyer": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 2,
    "full_name": "brianhoyer",
    "first_name": "Brian",
    "last_name": "Hoyer",
    "position": "QB",
    "age": 34,
    "team": "IND",
    "player_id": "345",
    "my_id": 345,
    "gp": 5,
    "gs": 0,
    "pts_ppr": -0.52,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 11,
    "rush_td": 0,
    "rush_yd": -8,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 1,
    "pass_att": 2,
    "pass_yd": 7,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Brandon Tate": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 87,
    "full_name": "brandontate",
    "first_name": "Brandon",
    "last_name": "Tate",
    "position": "WR",
    "age": 32,
    "team": null,
    "player_id": "346",
    "my_id": 346,
    "gp": 1,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Mark Sanchez": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 6,
    "full_name": "marksanchez",
    "first_name": "Mark",
    "last_name": "Sanchez",
    "position": "QB",
    "age": 32,
    "team": null,
    "player_id": "350",
    "my_id": 350,
    "gp": 2,
    "gs": 1,
    "pts_ppr": 0.32,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 8,
    "td": 0,
    "pass_td": 0,
    "pass_int": 3,
    "pass_cmp": 19,
    "pass_att": 35,
    "pass_yd": 138,
    "pass_inc": 16,
    "fum_lost": 0
  },
  "Mike Wallace": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 14,
    "full_name": "mikewallace",
    "first_name": "Mike",
    "last_name": "Wallace",
    "position": "WR",
    "age": 33,
    "team": null,
    "player_id": "365",
    "my_id": 365,
    "gp": 2,
    "gs": 2,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 3,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jared Cook": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 87,
    "full_name": "jaredcook",
    "first_name": "Jared",
    "last_name": "Cook",
    "position": "TE",
    "age": 32,
    "team": "NO",
    "player_id": "367",
    "my_id": 367,
    "gp": 16,
    "gs": 14,
    "pts_ppr": 193.6,
    "rec": 68,
    "rec_yd": 896,
    "rec_td": 6,
    "rec_tgt": 101,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 6,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Matt Cassel": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 8,
    "full_name": "mattcassel",
    "first_name": "Matt",
    "last_name": "Cassel",
    "position": "QB",
    "age": 37,
    "team": null,
    "player_id": "389",
    "my_id": 389,
    "gp": 2,
    "gs": 0,
    "pts_ppr": 1.66,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 2,
    "rush_td": 0,
    "rush_yd": 13,
    "td": 0,
    "pass_td": 0,
    "pass_int": 1,
    "pass_cmp": 7,
    "pass_att": 17,
    "pass_yd": 59,
    "pass_inc": 10,
    "fum_lost": 0
  },
  "Darrius Heyward-Bey": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 88,
    "full_name": "darriusheywardbey",
    "first_name": "Darrius",
    "last_name": "Heyward-Bey",
    "position": "WR",
    "age": 32,
    "team": null,
    "player_id": "394",
    "my_id": 394,
    "gp": 14,
    "gs": 2,
    "pts_ppr": 1.2,
    "rec": 1,
    "rec_yd": 9,
    "rec_td": 0,
    "rec_tgt": 2,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": -7,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "John Phillips": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 82,
    "full_name": "johnphillips",
    "first_name": "John",
    "last_name": "Phillips",
    "position": "TE",
    "age": 32,
    "team": null,
    "player_id": "406",
    "my_id": 406,
    "gp": 8,
    "gs": 4,
    "pts_ppr": 6.8,
    "rec": 3,
    "rec_yd": 38,
    "rec_td": 0,
    "rec_tgt": 3,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Matthew Stafford": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 9,
    "full_name": "matthewstafford",
    "first_name": "Matthew",
    "last_name": "Stafford",
    "position": "QB",
    "age": 31,
    "team": "DET",
    "player_id": "421",
    "my_id": 421,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 212.18,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 25,
    "rush_td": 0,
    "rush_yd": 71,
    "td": 0,
    "pass_td": 21,
    "pass_int": 11,
    "pass_cmp": 367,
    "pass_att": 555,
    "pass_yd": 3777,
    "pass_inc": 188,
    "fum_lost": 4
  },
  "Michael Crabtree": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 15,
    "full_name": "michaelcrabtree",
    "first_name": "Michael",
    "last_name": "Crabtree",
    "position": "WR",
    "age": 32,
    "team": null,
    "player_id": "455",
    "my_id": 455,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 132.7,
    "rec": 54,
    "rec_yd": 607,
    "rec_td": 3,
    "rec_tgt": 100,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Chase Daniel": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 4,
    "full_name": "chasedaniel",
    "first_name": "Chase",
    "last_name": "Daniel",
    "position": "QB",
    "age": 33,
    "team": "CHI",
    "player_id": "490",
    "my_id": 490,
    "gp": 5,
    "gs": 2,
    "pts_ppr": 30.7,
    "rec": 1,
    "rec_yd": 8,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 13,
    "rush_td": 0,
    "rush_yd": 3,
    "td": 0,
    "pass_td": 3,
    "pass_int": 2,
    "pass_cmp": 53,
    "pass_att": 76,
    "pass_yd": 515,
    "pass_inc": 23,
    "fum_lost": 0
  },
  "Danny Amendola": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 80,
    "full_name": "dannyamendola",
    "first_name": "Danny",
    "last_name": "Amendola",
    "position": "WR",
    "age": 33,
    "team": "DET",
    "player_id": "491",
    "my_id": 491,
    "gp": 15,
    "gs": 15,
    "pts_ppr": 127.42,
    "rec": 59,
    "rec_yd": 575,
    "rec_td": 1,
    "rec_tgt": 79,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": -2,
    "td": 1,
    "pass_td": 1,
    "pass_int": 0,
    "pass_cmp": 1,
    "pass_att": 1,
    "pass_yd": 28,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Rob Gronkowski": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 87,
    "full_name": "robgronkowski",
    "first_name": "Rob",
    "last_name": "Gronkowski",
    "position": "TE",
    "age": 30,
    "team": null,
    "player_id": "515",
    "my_id": 515,
    "gp": 13,
    "gs": 11,
    "pts_ppr": 131.2,
    "rec": 47,
    "rec_yd": 682,
    "rec_td": 3,
    "rec_tgt": 72,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Jermaine Gresham": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 84,
    "full_name": "jermainegresham",
    "first_name": "Jermaine",
    "last_name": "Gresham",
    "position": "TE",
    "age": 31,
    "team": null,
    "player_id": "530",
    "my_id": 530,
    "gp": 13,
    "gs": 11,
    "pts_ppr": 16.4,
    "rec": 9,
    "rec_yd": 94,
    "rec_td": 0,
    "rec_tgt": 12,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Colt McCoy": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 12,
    "full_name": "coltmccoy",
    "first_name": "Colt",
    "last_name": "McCoy",
    "position": "QB",
    "age": 33,
    "team": "WAS",
    "player_id": "533",
    "my_id": 533,
    "gp": 3,
    "gs": 2,
    "pts_ppr": 27.18,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 10,
    "rush_td": 0,
    "rush_yd": 63,
    "td": 0,
    "pass_td": 3,
    "pass_int": 3,
    "pass_cmp": 34,
    "pass_att": 54,
    "pass_yd": 372,
    "pass_inc": 20,
    "fum_lost": 0
  },
  "Antonio Brown": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 17,
    "full_name": "antoniobrown",
    "first_name": "Antonio",
    "last_name": "Brown",
    "position": "WR",
    "age": 31,
    "team": null,
    "player_id": "536",
    "my_id": 536,
    "gp": 15,
    "gs": 15,
    "pts_ppr": 323.7,
    "rec": 104,
    "rec_yd": 1297,
    "rec_td": 15,
    "rec_tgt": 168,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 15,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 1,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Emmanuel Sanders": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 10,
    "full_name": "emmanuelsanders",
    "first_name": "Emmanuel",
    "last_name": "Sanders",
    "position": "WR",
    "age": 32,
    "team": "DEN",
    "player_id": "538",
    "my_id": 538,
    "gp": 12,
    "gs": 12,
    "pts_ppr": 198.22,
    "rec": 71,
    "rec_yd": 868,
    "rec_td": 4,
    "rec_tgt": 98,
    "rush_att": 4,
    "rush_td": 1,
    "rush_yd": 53,
    "td": 5,
    "pass_td": 1,
    "pass_int": 0,
    "pass_cmp": 1,
    "pass_att": 1,
    "pass_yd": 28,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Demaryius Thomas": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 18,
    "full_name": "demaryiusthomas",
    "first_name": "Demaryius",
    "last_name": "Thomas",
    "position": "WR",
    "age": 31,
    "team": "NYJ",
    "player_id": "560",
    "my_id": 560,
    "gp": 15,
    "gs": 15,
    "pts_ppr": 156.7,
    "rec": 59,
    "rec_yd": 677,
    "rec_td": 5,
    "rec_tgt": 89,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 5,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Logan Paulsen": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 82,
    "full_name": "loganpaulsen",
    "first_name": "Logan",
    "last_name": "Paulsen",
    "position": "TE",
    "age": 32,
    "team": "HOU",
    "player_id": "587",
    "my_id": 587,
    "gp": 15,
    "gs": 10,
    "pts_ppr": 24.1,
    "rec": 9,
    "rec_yd": 91,
    "rec_td": 1,
    "rec_tgt": 9,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Joe Webb": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 5,
    "full_name": "joewebb",
    "first_name": "Joe",
    "last_name": "Webb",
    "position": "QB",
    "age": 32,
    "team": "HOU",
    "player_id": "606",
    "my_id": 606,
    "gp": 16,
    "gs": 0,
    "pts_ppr": 3.3,
    "rec": 2,
    "rec_yd": 13,
    "rec_td": 0,
    "rec_tgt": 3,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Brandon LaFell": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 19,
    "full_name": "brandonlafell",
    "first_name": "Brandon",
    "last_name": "LaFell",
    "position": "WR",
    "age": 32,
    "team": null,
    "player_id": "613",
    "my_id": 613,
    "gp": 6,
    "gs": 5,
    "pts_ppr": 37.5,
    "rec": 12,
    "rec_yd": 135,
    "rec_td": 2,
    "rec_tgt": 16,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jimmy Graham": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 80,
    "full_name": "jimmygraham",
    "first_name": "Jimmy",
    "last_name": "Graham",
    "position": "TE",
    "age": 32,
    "team": "GB",
    "player_id": "616",
    "my_id": 616,
    "gp": 16,
    "gs": 12,
    "pts_ppr": 130.6,
    "rec": 55,
    "rec_yd": 636,
    "rec_td": 2,
    "rec_tgt": 90,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Sam Bradford": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 9,
    "full_name": "sambradford",
    "first_name": "Sam",
    "last_name": "Bradford",
    "position": "QB",
    "age": 31,
    "team": null,
    "player_id": "621",
    "my_id": 621,
    "gp": 3,
    "gs": 3,
    "pts_ppr": 12.7,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 2,
    "rush_td": 0,
    "rush_yd": 7,
    "td": 0,
    "pass_td": 2,
    "pass_int": 4,
    "pass_cmp": 50,
    "pass_att": 80,
    "pass_yd": 400,
    "pass_inc": 30,
    "fum_lost": 2
  },
  "Andre Roberts": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 18,
    "full_name": "andreroberts",
    "first_name": "Andre",
    "last_name": "Roberts",
    "position": "WR",
    "age": 31,
    "team": "BUF",
    "player_id": "627",
    "my_id": 627,
    "gp": 16,
    "gs": 1,
    "pts_ppr": 23.9,
    "rec": 10,
    "rec_yd": 79,
    "rec_td": 1,
    "rec_tgt": 18,
    "rush_att": 2,
    "rush_td": 0,
    "rush_yd": 20,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Golden Tate": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 15,
    "full_name": "goldentate",
    "first_name": "Golden",
    "last_name": "Tate",
    "position": "WR",
    "age": 31,
    "team": "NYG",
    "player_id": "642",
    "my_id": 642,
    "gp": 15,
    "gs": 7,
    "pts_ppr": 182.9,
    "rec": 74,
    "rec_yd": 795,
    "rec_td": 4,
    "rec_tgt": 113,
    "rush_att": 4,
    "rush_td": 0,
    "rush_yd": 34,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Brandon Marshall": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 15,
    "full_name": "brandonmarshall",
    "first_name": "Brandon",
    "last_name": "Marshall",
    "position": "WR",
    "age": 35,
    "team": null,
    "player_id": "648",
    "my_id": 648,
    "gp": 7,
    "gs": 2,
    "pts_ppr": 30.6,
    "rec": 11,
    "rec_yd": 136,
    "rec_td": 1,
    "rec_tgt": 23,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Benjamin Watson": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 84,
    "full_name": "benjaminwatson",
    "first_name": "Benjamin",
    "last_name": "Watson",
    "position": "TE",
    "age": 38,
    "team": "NE",
    "player_id": "663",
    "my_id": 663,
    "gp": 16,
    "gs": 4,
    "pts_ppr": 87,
    "rec": 35,
    "rec_yd": 400,
    "rec_td": 2,
    "rec_tgt": 46,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "LeSean McCoy": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 25,
    "full_name": "leseanmccoy",
    "first_name": "LeSean",
    "last_name": "McCoy",
    "position": "RB",
    "age": 31,
    "team": "KC",
    "player_id": "676",
    "my_id": 676,
    "gp": 14,
    "gs": 13,
    "pts_ppr": 127.2,
    "rec": 34,
    "rec_yd": 238,
    "rec_td": 0,
    "rec_tgt": 46,
    "rush_att": 161,
    "rush_td": 3,
    "rush_yd": 514,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Derek Anderson": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 3,
    "full_name": "derekanderson",
    "first_name": "Derek",
    "last_name": "Anderson",
    "position": "QB",
    "age": 36,
    "team": null,
    "player_id": "691",
    "my_id": 691,
    "gp": 2,
    "gs": 2,
    "pts_ppr": 6.5,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": -1,
    "td": 0,
    "pass_td": 0,
    "pass_int": 4,
    "pass_cmp": 42,
    "pass_att": 70,
    "pass_yd": 465,
    "pass_inc": 28,
    "fum_lost": 2
  },
  "Ted Ginn": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 19,
    "full_name": "tedginn",
    "first_name": "Ted",
    "last_name": "Ginn",
    "position": "WR",
    "age": 34,
    "team": "NO",
    "player_id": "695",
    "my_id": 695,
    "gp": 5,
    "gs": 3,
    "pts_ppr": 52.5,
    "rec": 17,
    "rec_yd": 209,
    "rec_td": 2,
    "rec_tgt": 30,
    "rush_att": 3,
    "rush_td": 0,
    "rush_yd": 26,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Ed Dickson": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 84,
    "full_name": "eddickson",
    "first_name": "Ed",
    "last_name": "Dickson",
    "position": "TE",
    "age": 32,
    "team": "SEA",
    "player_id": "701",
    "my_id": 701,
    "gp": 10,
    "gs": 1,
    "pts_ppr": 45.2,
    "rec": 12,
    "rec_yd": 143,
    "rec_td": 3,
    "rec_tgt": 13,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 9,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Chris Ivory": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 33,
    "full_name": "chrisivory",
    "first_name": "Chris",
    "last_name": "Ivory",
    "position": "RB",
    "age": 31,
    "team": null,
    "player_id": "717",
    "my_id": 717,
    "gp": 13,
    "gs": 1,
    "pts_ppr": 78,
    "rec": 13,
    "rec_yd": 205,
    "rec_td": 0,
    "rec_tgt": 21,
    "rush_att": 115,
    "rush_td": 1,
    "rush_yd": 385,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "LeGarrette Blount": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 29,
    "full_name": "legarretteblount",
    "first_name": "LeGarrette",
    "last_name": "Blount",
    "position": "RB",
    "age": 32,
    "team": null,
    "player_id": "730",
    "my_id": 730,
    "gp": 16,
    "gs": 8,
    "pts_ppr": 86.5,
    "rec": 10,
    "rec_yd": 67,
    "rec_td": 0,
    "rec_tgt": 15,
    "rush_att": 154,
    "rush_td": 5,
    "rush_yd": 418,
    "td": 5,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Marshawn Lynch": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 24,
    "full_name": "marshawnlynch",
    "first_name": "Marshawn",
    "last_name": "Lynch",
    "position": "RB",
    "age": 33,
    "team": null,
    "player_id": "745",
    "my_id": 745,
    "gp": 6,
    "gs": 6,
    "pts_ppr": 79,
    "rec": 15,
    "rec_yd": 84,
    "rec_td": 0,
    "rec_tgt": 20,
    "rush_att": 90,
    "rush_td": 3,
    "rush_yd": 376,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Dion Lewis": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 33,
    "full_name": "dionlewis",
    "first_name": "Dion",
    "last_name": "Lewis",
    "position": "RB",
    "age": 29,
    "team": "TEN",
    "player_id": "788",
    "my_id": 788,
    "gp": 16,
    "gs": 7,
    "pts_ppr": 160.7,
    "rec": 59,
    "rec_yd": 400,
    "rec_td": 1,
    "rec_tgt": 67,
    "rush_att": 155,
    "rush_td": 1,
    "rush_yd": 517,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Kamar Aiken": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 81,
    "full_name": "kamaraiken",
    "first_name": "Kamar",
    "last_name": "Aiken",
    "position": "WR",
    "age": 30,
    "team": null,
    "player_id": "794",
    "my_id": 794,
    "gp": 5,
    "gs": 1,
    "pts_ppr": 11.3,
    "rec": 6,
    "rec_yd": 53,
    "rec_td": 0,
    "rec_tgt": 7,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Charles Clay": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 85,
    "full_name": "charlesclay",
    "first_name": "Charles",
    "last_name": "Clay",
    "position": "TE",
    "age": 30,
    "team": "ARI",
    "player_id": "801",
    "my_id": 801,
    "gp": 13,
    "gs": 12,
    "pts_ppr": 37.4,
    "rec": 21,
    "rec_yd": 184,
    "rec_td": 0,
    "rec_tgt": 36,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Stevan Ridley": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 22,
    "full_name": "stevanridley",
    "first_name": "Stevan",
    "last_name": "Ridley",
    "position": "RB",
    "age": 30,
    "team": null,
    "player_id": "811",
    "my_id": 811,
    "gp": 10,
    "gs": 0,
    "pts_ppr": 14.8,
    "rec": 3,
    "rec_yd": 18,
    "rec_td": 0,
    "rec_tgt": 4,
    "rush_att": 29,
    "rush_td": 1,
    "rush_yd": 80,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 2
  },
  "Lee Smith": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 85,
    "full_name": "leesmith",
    "first_name": "Lee",
    "last_name": "Smith",
    "position": "TE",
    "age": 31,
    "team": "BUF",
    "player_id": "812",
    "my_id": 812,
    "gp": 16,
    "gs": 4,
    "pts_ppr": 35.3,
    "rec": 10,
    "rec_yd": 73,
    "rec_td": 3,
    "rec_tgt": 11,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Nick Bellore": {
    "fantasy_positions": [
      "RB",
      "LB"
    ],
    "year": 2018,
    "number": 44,
    "full_name": "nickbellore",
    "first_name": "Nick",
    "last_name": "Bellore",
    "position": "RB",
    "age": 30,
    "team": "SEA",
    "player_id": "815",
    "my_id": 815,
    "gp": 14,
    "gs": 4,
    "pts_ppr": 5.5,
    "rec": 4,
    "rec_yd": 15,
    "rec_td": 0,
    "rec_tgt": 4,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jeremy Kerley": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 10,
    "full_name": "jeremykerley",
    "first_name": "Jeremy",
    "last_name": "Kerley",
    "position": "WR",
    "age": 30,
    "team": null,
    "player_id": "817",
    "my_id": 817,
    "gp": 1,
    "gs": 1,
    "pts_ppr": 2.7,
    "rec": 2,
    "rec_yd": 7,
    "rec_td": 0,
    "rec_tgt": 4,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Bilal Powell": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 29,
    "full_name": "bilalpowell",
    "first_name": "Bilal",
    "last_name": "Powell",
    "position": "RB",
    "age": 31,
    "team": "NYJ",
    "player_id": "818",
    "my_id": 818,
    "gp": 7,
    "gs": 7,
    "pts_ppr": 60.3,
    "rec": 11,
    "rec_yd": 110,
    "rec_td": 1,
    "rec_tgt": 18,
    "rush_att": 80,
    "rush_td": 0,
    "rush_yd": 343,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Torrey Smith": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 11,
    "full_name": "torreysmith",
    "first_name": "Torrey",
    "last_name": "Smith",
    "position": "WR",
    "age": 30,
    "team": null,
    "player_id": "826",
    "my_id": 826,
    "gp": 11,
    "gs": 6,
    "pts_ppr": 50,
    "rec": 17,
    "rec_yd": 190,
    "rec_td": 2,
    "rec_tgt": 31,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Tyrod Taylor": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 5,
    "full_name": "tyrodtaylor",
    "first_name": "Tyrod",
    "last_name": "Taylor",
    "position": "QB",
    "age": 30,
    "team": "LAC",
    "player_id": "827",
    "my_id": 827,
    "gp": 4,
    "gs": 3,
    "pts_ppr": 41.42,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 16,
    "rush_td": 1,
    "rush_yd": 125,
    "td": 1,
    "pass_td": 2,
    "pass_int": 2,
    "pass_cmp": 42,
    "pass_att": 85,
    "pass_yd": 473,
    "pass_inc": 43,
    "fum_lost": 0
  },
  "Andy Dalton": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 14,
    "full_name": "andydalton",
    "first_name": "Andy",
    "last_name": "Dalton",
    "position": "QB",
    "age": 31,
    "team": "CIN",
    "player_id": "829",
    "my_id": 829,
    "gp": 11,
    "gs": 11,
    "pts_ppr": 174.54,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 16,
    "rush_td": 0,
    "rush_yd": 99,
    "td": 0,
    "pass_td": 21,
    "pass_int": 11,
    "pass_cmp": 226,
    "pass_att": 365,
    "pass_yd": 2566,
    "pass_inc": 139,
    "fum_lost": 0
  },
  "AJ Green": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 18,
    "full_name": "ajgreen",
    "first_name": "AJ",
    "last_name": "Green",
    "position": "WR",
    "age": 31,
    "team": "CIN",
    "player_id": "830",
    "my_id": 830,
    "gp": 9,
    "gs": 9,
    "pts_ppr": 149.4,
    "rec": 46,
    "rec_yd": 694,
    "rec_td": 6,
    "rec_tgt": 77,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 6,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Blaine Gabbert": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 11,
    "full_name": "blainegabbert",
    "first_name": "Blaine",
    "last_name": "Gabbert",
    "position": "QB",
    "age": 30,
    "team": "TB",
    "player_id": "862",
    "my_id": 862,
    "gp": 8,
    "gs": 3,
    "pts_ppr": 33.04,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 6,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 4,
    "pass_int": 4,
    "pass_cmp": 61,
    "pass_att": 101,
    "pass_yd": 626,
    "pass_inc": 40,
    "fum_lost": 0
  },
  "Virgil Green": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 88,
    "full_name": "virgilgreen",
    "first_name": "Virgil",
    "last_name": "Green",
    "position": "TE",
    "age": 31,
    "team": "LAC",
    "player_id": "868",
    "my_id": 868,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 46,
    "rec": 19,
    "rec_yd": 210,
    "rec_td": 1,
    "rec_tgt": 27,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Taiwan Jones": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 34,
    "full_name": "taiwanjones",
    "first_name": "Taiwan",
    "last_name": "Jones",
    "position": "RB",
    "age": 31,
    "team": "HOU",
    "player_id": "886",
    "my_id": 886,
    "gp": 6,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 2,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Dwayne Harris": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 17,
    "full_name": "dwayneharris",
    "first_name": "Dwayne",
    "last_name": "Harris",
    "position": "WR",
    "age": 32,
    "team": "OAK",
    "player_id": "902",
    "my_id": 902,
    "gp": 15,
    "gs": 1,
    "pts_ppr": 11.2,
    "rec": 6,
    "rec_yd": 40,
    "rec_td": 0,
    "rec_tgt": 6,
    "rush_att": 2,
    "rush_td": 0,
    "rush_yd": 12,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Niles Paul": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 43,
    "full_name": "nilespaul",
    "first_name": "Niles",
    "last_name": "Paul",
    "position": "TE",
    "age": 30,
    "team": null,
    "player_id": "918",
    "my_id": 918,
    "gp": 6,
    "gs": 1,
    "pts_ppr": 19.5,
    "rec": 10,
    "rec_yd": 98,
    "rec_td": 0,
    "rec_tgt": 13,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": -3,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Aldrick Robinson": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 8,
    "full_name": "aldrickrobinson",
    "first_name": "Aldrick",
    "last_name": "Robinson",
    "position": "WR",
    "age": 30,
    "team": null,
    "player_id": "919",
    "my_id": 919,
    "gp": 14,
    "gs": 0,
    "pts_ppr": 70.1,
    "rec": 17,
    "rec_yd": 231,
    "rec_td": 5,
    "rec_tgt": 35,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 5,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Randall Cobb": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 18,
    "full_name": "randallcobb",
    "first_name": "Randall",
    "last_name": "Cobb",
    "position": "WR",
    "age": 29,
    "team": "DAL",
    "player_id": "928",
    "my_id": 928,
    "gp": 9,
    "gs": 6,
    "pts_ppr": 86.3,
    "rec": 38,
    "rec_yd": 383,
    "rec_td": 2,
    "rec_tgt": 61,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Andre Holmes": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 19,
    "full_name": "andreholmes",
    "first_name": "Andre",
    "last_name": "Holmes",
    "position": "WR",
    "age": 31,
    "team": null,
    "player_id": "940",
    "my_id": 940,
    "gp": 15,
    "gs": 3,
    "pts_ppr": 29.2,
    "rec": 13,
    "rec_yd": 162,
    "rec_td": 0,
    "rec_tgt": 24,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Kyle Rudolph": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 82,
    "full_name": "kylerudolph",
    "first_name": "Kyle",
    "last_name": "Rudolph",
    "position": "TE",
    "age": 29,
    "team": "MIN",
    "player_id": "943",
    "my_id": 943,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 151.4,
    "rec": 64,
    "rec_yd": 634,
    "rec_td": 4,
    "rec_tgt": 81,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Julio Jones": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 11,
    "full_name": "juliojones",
    "first_name": "Julio",
    "last_name": "Jones",
    "position": "WR",
    "age": 30,
    "team": "ATL",
    "player_id": "947",
    "my_id": 947,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 325.9,
    "rec": 113,
    "rec_yd": 1677,
    "rec_td": 8,
    "rec_tgt": 170,
    "rush_att": 2,
    "rush_td": 0,
    "rush_yd": 12,
    "td": 8,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 2
  },
  "Jacquizz Rodgers": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 37,
    "full_name": "jacquizzrodgers",
    "first_name": "Jacquizz",
    "last_name": "Rodgers",
    "position": "RB",
    "age": 29,
    "team": null,
    "player_id": "949",
    "my_id": 949,
    "gp": 16,
    "gs": 0,
    "pts_ppr": 83,
    "rec": 38,
    "rec_yd": 304,
    "rec_td": 0,
    "rec_tgt": 45,
    "rush_att": 33,
    "rush_td": 1,
    "rush_yd": 106,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Cam Newton": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 1,
    "full_name": "camnewton",
    "first_name": "Cam",
    "last_name": "Newton",
    "position": "QB",
    "age": 30,
    "team": "CAR",
    "player_id": "954",
    "my_id": 954,
    "gp": 14,
    "gs": 14,
    "pts_ppr": 282.6,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 101,
    "rush_td": 4,
    "rush_yd": 488,
    "td": 4,
    "pass_td": 24,
    "pass_int": 13,
    "pass_cmp": 320,
    "pass_att": 471,
    "pass_yd": 3395,
    "pass_inc": 151,
    "fum_lost": 0
  },
  "Mark Ingram": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 21,
    "full_name": "markingram",
    "first_name": "Mark",
    "last_name": "Ingram",
    "position": "RB",
    "age": 29,
    "team": "BAL",
    "player_id": "956",
    "my_id": 956,
    "gp": 12,
    "gs": 6,
    "pts_ppr": 142.5,
    "rec": 21,
    "rec_yd": 170,
    "rec_td": 1,
    "rec_tgt": 27,
    "rush_att": 138,
    "rush_td": 6,
    "rush_yd": 645,
    "td": 7,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Luke Stocker": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 80,
    "full_name": "lukestocker",
    "first_name": "Luke",
    "last_name": "Stocker",
    "position": "TE",
    "age": 31,
    "team": "ATL",
    "player_id": "963",
    "my_id": 963,
    "gp": 16,
    "gs": 11,
    "pts_ppr": 43.5,
    "rec": 15,
    "rec_yd": 165,
    "rec_td": 2,
    "rec_tgt": 21,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Lance Kendricks": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 87,
    "full_name": "lancekendricks",
    "first_name": "Lance",
    "last_name": "Kendricks",
    "position": "TE",
    "age": 31,
    "team": "LAC",
    "player_id": "964",
    "my_id": 964,
    "gp": 16,
    "gs": 3,
    "pts_ppr": 42,
    "rec": 19,
    "rec_yd": 170,
    "rec_td": 1,
    "rec_tgt": 25,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Doug Baldwin": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 89,
    "full_name": "dougbaldwin",
    "first_name": "Doug",
    "last_name": "Baldwin",
    "position": "WR",
    "age": 31,
    "team": null,
    "player_id": "988",
    "my_id": 988,
    "gp": 13,
    "gs": 13,
    "pts_ppr": 141.8,
    "rec": 50,
    "rec_yd": 618,
    "rec_td": 5,
    "rec_tgt": 73,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 5,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Terrelle Pryor": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 10,
    "full_name": "terrellepryor",
    "first_name": "Terrelle",
    "last_name": "Pryor",
    "position": "WR",
    "age": 30,
    "team": null,
    "player_id": "1020",
    "my_id": 1020,
    "gp": 8,
    "gs": 1,
    "pts_ppr": 53.1,
    "rec": 16,
    "rec_yd": 252,
    "rec_td": 2,
    "rec_tgt": 30,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": -1,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Nick Foles": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 7,
    "full_name": "nickfoles",
    "first_name": "Nick",
    "last_name": "Foles",
    "position": "QB",
    "age": 30,
    "team": "JAX",
    "player_id": "1029",
    "my_id": 1029,
    "gp": 5,
    "gs": 5,
    "pts_ppr": 76.72,
    "rec": 1,
    "rec_yd": 15,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 9,
    "rush_td": 0,
    "rush_yd": 17,
    "td": 0,
    "pass_td": 7,
    "pass_int": 4,
    "pass_cmp": 141,
    "pass_att": 195,
    "pass_yd": 1413,
    "pass_inc": 54,
    "fum_lost": 2
  },
  "Brandon Bolden": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 38,
    "full_name": "brandonbolden",
    "first_name": "Brandon",
    "last_name": "Bolden",
    "position": "RB",
    "age": 29,
    "team": "NE",
    "player_id": "1034",
    "my_id": 1034,
    "gp": 16,
    "gs": 0,
    "pts_ppr": 29.4,
    "rec": 3,
    "rec_yd": 13,
    "rec_td": 1,
    "rec_tgt": 3,
    "rush_att": 8,
    "rush_td": 2,
    "rush_yd": 91,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Rishard Matthews": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 82,
    "full_name": "rishardmatthews",
    "first_name": "Rishard",
    "last_name": "Matthews",
    "position": "WR",
    "age": 30,
    "team": null,
    "player_id": "1046",
    "my_id": 1046,
    "gp": 8,
    "gs": 1,
    "pts_ppr": 7.4,
    "rec": 5,
    "rec_yd": 24,
    "rec_td": 0,
    "rec_tgt": 9,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Lamar Miller": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 26,
    "full_name": "lamarmiller",
    "first_name": "Lamar",
    "last_name": "Miller",
    "position": "RB",
    "age": 28,
    "team": "HOU",
    "player_id": "1048",
    "my_id": 1048,
    "gp": 14,
    "gs": 14,
    "pts_ppr": 172.6,
    "rec": 25,
    "rec_yd": 163,
    "rec_td": 1,
    "rec_tgt": 35,
    "rush_att": 210,
    "rush_td": 5,
    "rush_yd": 973,
    "td": 6,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Ryan Tannehill": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 17,
    "full_name": "ryantannehill",
    "first_name": "Ryan",
    "last_name": "Tannehill",
    "position": "QB",
    "age": 31,
    "team": "TEN",
    "player_id": "1049",
    "my_id": 1049,
    "gp": 11,
    "gs": 11,
    "pts_ppr": 142.96,
    "rec": 1,
    "rec_yd": 3,
    "rec_td": 1,
    "rec_tgt": 1,
    "rush_att": 32,
    "rush_td": 0,
    "rush_yd": 145,
    "td": 1,
    "pass_td": 17,
    "pass_int": 9,
    "pass_cmp": 176,
    "pass_att": 274,
    "pass_yd": 1979,
    "pass_inc": 98,
    "fum_lost": 4
  },
  "Deonte Thompson": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 1,
    "full_name": "deontethompson",
    "first_name": "Deonte",
    "last_name": "Thompson",
    "position": "WR",
    "age": 30,
    "team": null,
    "player_id": "1061",
    "my_id": 1061,
    "gp": 13,
    "gs": 6,
    "pts_ppr": 33.1,
    "rec": 17,
    "rec_yd": 161,
    "rec_td": 0,
    "rec_tgt": 30,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Orson Charles": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 83,
    "full_name": "orsoncharles",
    "first_name": "Orson",
    "last_name": "Charles",
    "position": "TE",
    "age": 28,
    "team": null,
    "player_id": "1065",
    "my_id": 1065,
    "gp": 13,
    "gs": 2,
    "pts_ppr": 5.3,
    "rec": 3,
    "rec_yd": 23,
    "rec_td": 0,
    "rec_tgt": 5,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Marvin Jones": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 11,
    "full_name": "marvinjones",
    "first_name": "Marvin",
    "last_name": "Jones",
    "position": "WR",
    "age": 29,
    "team": "DET",
    "player_id": "1067",
    "my_id": 1067,
    "gp": 9,
    "gs": 9,
    "pts_ppr": 115.8,
    "rec": 35,
    "rec_yd": 508,
    "rec_td": 5,
    "rec_tgt": 62,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 5,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Mohamed Sanu": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 12,
    "full_name": "mohamedsanu",
    "first_name": "Mohamed",
    "last_name": "Sanu",
    "position": "WR",
    "age": 30,
    "team": "ATL",
    "player_id": "1071",
    "my_id": 1071,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 182.4,
    "rec": 66,
    "rec_yd": 838,
    "rec_td": 4,
    "rec_tgt": 94,
    "rush_att": 7,
    "rush_td": 0,
    "rush_yd": 44,
    "td": 4,
    "pass_td": 1,
    "pass_int": 0,
    "pass_cmp": 1,
    "pass_att": 2,
    "pass_yd": 5,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Travis Benjamin": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 12,
    "full_name": "travisbenjamin",
    "first_name": "Travis",
    "last_name": "Benjamin",
    "position": "WR",
    "age": 29,
    "team": "LAC",
    "player_id": "1077",
    "my_id": 1077,
    "gp": 12,
    "gs": 3,
    "pts_ppr": 40.7,
    "rec": 12,
    "rec_yd": 186,
    "rec_td": 1,
    "rec_tgt": 24,
    "rush_att": 7,
    "rush_td": 0,
    "rush_yd": 41,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Brandon Weeden": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 3,
    "full_name": "brandonweeden",
    "first_name": "Brandon",
    "last_name": "Weeden",
    "position": "QB",
    "age": 36,
    "team": null,
    "player_id": "1085",
    "my_id": 1085,
    "gp": 1,
    "gs": 0,
    "pts_ppr": -0.1,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": -1,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Dwayne Allen": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 89,
    "full_name": "dwayneallen",
    "first_name": "Dwayne",
    "last_name": "Allen",
    "position": "TE",
    "age": 29,
    "team": null,
    "player_id": "1105",
    "my_id": 1105,
    "gp": 13,
    "gs": 7,
    "pts_ppr": 5.7,
    "rec": 3,
    "rec_yd": 27,
    "rec_td": 0,
    "rec_tgt": 4,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "T.Y. Hilton": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 13,
    "full_name": "tyhilton",
    "first_name": "T.Y.",
    "last_name": "Hilton",
    "position": "WR",
    "age": 29,
    "team": "IND",
    "player_id": "1110",
    "my_id": 1110,
    "gp": 14,
    "gs": 14,
    "pts_ppr": 239,
    "rec": 76,
    "rec_yd": 1270,
    "rec_td": 6,
    "rec_tgt": 120,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 6,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Andrew Luck": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 12,
    "full_name": "andrewluck",
    "first_name": "Andrew",
    "last_name": "Luck",
    "position": "QB",
    "age": 30,
    "team": null,
    "player_id": "1111",
    "my_id": 1111,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 327.92,
    "rec": 1,
    "rec_yd": 4,
    "rec_td": 0,
    "rec_tgt": 2,
    "rush_att": 46,
    "rush_td": 0,
    "rush_yd": 148,
    "td": 0,
    "pass_td": 39,
    "pass_int": 15,
    "pass_cmp": 430,
    "pass_att": 639,
    "pass_yd": 4593,
    "pass_inc": 209,
    "fum_lost": 1
  },
  "Brock Osweiler": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 8,
    "full_name": "brockosweiler",
    "first_name": "Brock",
    "last_name": "Osweiler",
    "position": "QB",
    "age": 28,
    "team": null,
    "player_id": "1126",
    "my_id": 1126,
    "gp": 7,
    "gs": 5,
    "pts_ppr": 67.98,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 8,
    "rush_td": 0,
    "rush_yd": 21,
    "td": 0,
    "pass_td": 6,
    "pass_int": 4,
    "pass_cmp": 113,
    "pass_att": 178,
    "pass_yd": 1247,
    "pass_inc": 65,
    "fum_lost": 1
  },
  "Rod Streater": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 13,
    "full_name": "rodstreater",
    "first_name": "Rod",
    "last_name": "Streater",
    "position": "WR",
    "age": 31,
    "team": null,
    "player_id": "1138",
    "my_id": 1138,
    "gp": 3,
    "gs": 0,
    "pts_ppr": -1.1,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": -11,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Cole Beasley": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 10,
    "full_name": "colebeasley",
    "first_name": "Cole",
    "last_name": "Beasley",
    "position": "WR",
    "age": 30,
    "team": "BUF",
    "player_id": "1144",
    "my_id": 1144,
    "gp": 16,
    "gs": 4,
    "pts_ppr": 150.2,
    "rec": 65,
    "rec_yd": 672,
    "rec_td": 3,
    "rec_tgt": 86,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 1,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Alshon Jeffery": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 17,
    "full_name": "alshonjeffery",
    "first_name": "Alshon",
    "last_name": "Jeffery",
    "position": "WR",
    "age": 29,
    "team": "PHI",
    "player_id": "1149",
    "my_id": 1149,
    "gp": 13,
    "gs": 13,
    "pts_ppr": 185.3,
    "rec": 65,
    "rec_yd": 843,
    "rec_td": 6,
    "rec_tgt": 92,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 6,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Kirk Cousins": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 8,
    "full_name": "kirkcousins",
    "first_name": "Kirk",
    "last_name": "Cousins",
    "position": "QB",
    "age": 31,
    "team": "MIN",
    "player_id": "1166",
    "my_id": 1166,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 283.12,
    "rec": 1,
    "rec_yd": -1,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 44,
    "rush_td": 1,
    "rush_yd": 123,
    "td": 1,
    "pass_td": 30,
    "pass_int": 10,
    "pass_cmp": 425,
    "pass_att": 606,
    "pass_yd": 4298,
    "pass_inc": 181,
    "fum_lost": 7
  },
  "Robert Griffin III": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 3,
    "full_name": "robertgriffiniii",
    "first_name": "Robert",
    "last_name": "Griffin III",
    "position": "QB",
    "age": 29,
    "team": "BAL",
    "player_id": "1169",
    "my_id": 1169,
    "gp": 3,
    "gs": 0,
    "pts_ppr": 0.84,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 2,
    "pass_att": 6,
    "pass_yd": 21,
    "pass_inc": 2,
    "fum_lost": 0
  },
  "Alfred Morris": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 32,
    "full_name": "alfredmorris",
    "first_name": "Alfred",
    "last_name": "Morris",
    "position": "RB",
    "age": 30,
    "team": null,
    "player_id": "1170",
    "my_id": 1170,
    "gp": 12,
    "gs": 1,
    "pts_ppr": 68.1,
    "rec": 8,
    "rec_yd": 73,
    "rec_td": 0,
    "rec_tgt": 14,
    "rush_att": 111,
    "rush_td": 2,
    "rush_yd": 428,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Travaris Cadet": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 38,
    "full_name": "travariscadet",
    "first_name": "Travaris",
    "last_name": "Cadet",
    "position": "RB",
    "age": 30,
    "team": null,
    "player_id": "1185",
    "my_id": 1185,
    "gp": 1,
    "gs": 0,
    "pts_ppr": 3.2,
    "rec": 1,
    "rec_yd": 5,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 11,
    "rush_td": 0,
    "rush_yd": 17,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Doug Martin": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 22,
    "full_name": "dougmartin",
    "first_name": "Doug",
    "last_name": "Martin",
    "position": "RB",
    "age": 30,
    "team": null,
    "player_id": "1195",
    "my_id": 1195,
    "gp": 16,
    "gs": 9,
    "pts_ppr": 119.9,
    "rec": 18,
    "rec_yd": 116,
    "rec_td": 0,
    "rec_tgt": 24,
    "rush_att": 172,
    "rush_td": 4,
    "rush_yd": 723,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 3
  },
  "Brian Quick": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 83,
    "full_name": "brianquick",
    "first_name": "Brian",
    "last_name": "Quick",
    "position": "WR",
    "age": 30,
    "team": null,
    "player_id": "1208",
    "my_id": 1208,
    "gp": 6,
    "gs": 3,
    "pts_ppr": 4.8,
    "rec": 3,
    "rec_yd": 18,
    "rec_td": 0,
    "rec_tgt": 3,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Rhett Ellison": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 85,
    "full_name": "rhettellison",
    "first_name": "Rhett",
    "last_name": "Ellison",
    "position": "TE",
    "age": 31,
    "team": "NYG",
    "player_id": "1211",
    "my_id": 1211,
    "gp": 14,
    "gs": 12,
    "pts_ppr": 60.2,
    "rec": 25,
    "rec_yd": 272,
    "rec_td": 1,
    "rec_tgt": 34,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jarius Wright": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 13,
    "full_name": "jariuswright",
    "first_name": "Jarius",
    "last_name": "Wright",
    "position": "WR",
    "age": 29,
    "team": "CAR",
    "player_id": "1215",
    "my_id": 1215,
    "gp": 16,
    "gs": 6,
    "pts_ppr": 97.6,
    "rec": 43,
    "rec_yd": 447,
    "rec_td": 1,
    "rec_tgt": 59,
    "rush_att": 2,
    "rush_td": 0,
    "rush_yd": 39,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Michael Floyd": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 13,
    "full_name": "michaelfloyd",
    "first_name": "Michael",
    "last_name": "Floyd",
    "position": "WR",
    "age": 29,
    "team": null,
    "player_id": "1219",
    "my_id": 1219,
    "gp": 13,
    "gs": 3,
    "pts_ppr": 28,
    "rec": 10,
    "rec_yd": 100,
    "rec_td": 1,
    "rec_tgt": 24,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Garrett Celek": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 88,
    "full_name": "garrettcelek",
    "first_name": "Garrett",
    "last_name": "Celek",
    "position": "TE",
    "age": 31,
    "team": "SF",
    "player_id": "1223",
    "my_id": 1223,
    "gp": 15,
    "gs": 1,
    "pts_ppr": 26,
    "rec": 5,
    "rec_yd": 90,
    "rec_td": 2,
    "rec_tgt": 8,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Robert Turbin": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 33,
    "full_name": "robertturbin",
    "first_name": "Robert",
    "last_name": "Turbin",
    "position": "RB",
    "age": 29,
    "team": null,
    "player_id": "1232",
    "my_id": 1232,
    "gp": 2,
    "gs": 0,
    "pts_ppr": 0.3,
    "rec": 1,
    "rec_yd": 3,
    "rec_td": 0,
    "rec_tgt": 2,
    "rush_att": 4,
    "rush_td": 0,
    "rush_yd": 10,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Russell Wilson": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 3,
    "full_name": "russellwilson",
    "first_name": "Russell",
    "last_name": "Wilson",
    "position": "QB",
    "age": 30,
    "team": "SEA",
    "player_id": "1234",
    "my_id": 1234,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 299.42,
    "rec": 1,
    "rec_yd": -11,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 67,
    "rush_td": 0,
    "rush_yd": 376,
    "td": 0,
    "pass_td": 35,
    "pass_int": 7,
    "pass_cmp": 280,
    "pass_att": 427,
    "pass_yd": 3448,
    "pass_inc": 147,
    "fum_lost": 2
  },
  "Josh Gordon": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 10,
    "full_name": "joshgordon",
    "first_name": "Josh",
    "last_name": "Gordon",
    "position": "WR",
    "age": 28,
    "team": "NE",
    "player_id": "1244",
    "my_id": 1244,
    "gp": 12,
    "gs": 12,
    "pts_ppr": 138.7,
    "rec": 41,
    "rec_yd": 737,
    "rec_td": 4,
    "rec_tgt": 71,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Bradley Sowell": {
    "fantasy_positions": [
      "TE",
      "OL"
    ],
    "year": 2018,
    "number": 85,
    "full_name": "bradleysowell",
    "first_name": "Bradley",
    "last_name": "Sowell",
    "position": "TE",
    "age": 30,
    "team": "CHI",
    "player_id": "1269",
    "my_id": 1269,
    "gp": 16,
    "gs": 1,
    "pts_ppr": 7.2,
    "rec": 1,
    "rec_yd": 2,
    "rec_td": 1,
    "rec_tgt": 2,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jermaine Kearse": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 87,
    "full_name": "jermainekearse",
    "first_name": "Jermaine",
    "last_name": "Kearse",
    "position": "WR",
    "age": 29,
    "team": "DET",
    "player_id": "1290",
    "my_id": 1290,
    "gp": 14,
    "gs": 9,
    "pts_ppr": 80.1,
    "rec": 37,
    "rec_yd": 371,
    "rec_td": 1,
    "rec_tgt": 76,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Josh Bellamy": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 15,
    "full_name": "joshbellamy",
    "first_name": "Josh",
    "last_name": "Bellamy",
    "position": "WR",
    "age": 30,
    "team": "NYJ",
    "player_id": "1312",
    "my_id": 1312,
    "gp": 16,
    "gs": 2,
    "pts_ppr": 33.7,
    "rec": 14,
    "rec_yd": 117,
    "rec_td": 1,
    "rec_tgt": 25,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Chris Hogan": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 15,
    "full_name": "chrishogan",
    "first_name": "Chris",
    "last_name": "Hogan",
    "position": "WR",
    "age": 30,
    "team": "CAR",
    "player_id": "1329",
    "my_id": 1329,
    "gp": 16,
    "gs": 7,
    "pts_ppr": 106.2,
    "rec": 35,
    "rec_yd": 532,
    "rec_td": 3,
    "rec_tgt": 55,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Russell Shepard": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 81,
    "full_name": "russellshepard",
    "first_name": "Russell",
    "last_name": "Shepard",
    "position": "WR",
    "age": 29,
    "team": "NYG",
    "player_id": "1333",
    "my_id": 1333,
    "gp": 12,
    "gs": 0,
    "pts_ppr": 40.8,
    "rec": 10,
    "rec_yd": 188,
    "rec_td": 2,
    "rec_tgt": 19,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Matt Barkley": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 5,
    "full_name": "mattbarkley",
    "first_name": "Matt",
    "last_name": "Barkley",
    "position": "QB",
    "age": 29,
    "team": "BUF",
    "player_id": "1338",
    "my_id": 1338,
    "gp": 1,
    "gs": 1,
    "pts_ppr": 17.08,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 3,
    "rush_td": 0,
    "rush_yd": -2,
    "td": 0,
    "pass_td": 2,
    "pass_int": 0,
    "pass_cmp": 15,
    "pass_att": 25,
    "pass_yd": 232,
    "pass_inc": 10,
    "fum_lost": 0
  },
  "Zach Ertz": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 86,
    "full_name": "zachertz",
    "first_name": "Zach",
    "last_name": "Ertz",
    "position": "TE",
    "age": 29,
    "team": "PHI",
    "player_id": "1339",
    "my_id": 1339,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 280.3,
    "rec": 116,
    "rec_yd": 1163,
    "rec_td": 8,
    "rec_tgt": 156,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 8,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Marquise Goodwin": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 11,
    "full_name": "marquisegoodwin",
    "first_name": "Marquise",
    "last_name": "Goodwin",
    "position": "WR",
    "age": 28,
    "team": "SF",
    "player_id": "1346",
    "my_id": 1346,
    "gp": 11,
    "gs": 8,
    "pts_ppr": 87.4,
    "rec": 23,
    "rec_yd": 395,
    "rec_td": 4,
    "rec_tgt": 43,
    "rush_att": 4,
    "rush_td": 0,
    "rush_yd": 9,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Robert Woods": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 17,
    "full_name": "robertwoods",
    "first_name": "Robert",
    "last_name": "Woods",
    "position": "WR",
    "age": 27,
    "team": "LAR",
    "player_id": "1352",
    "my_id": 1352,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 265.6,
    "rec": 86,
    "rec_yd": 1219,
    "rec_td": 6,
    "rec_tgt": 130,
    "rush_att": 19,
    "rush_td": 1,
    "rush_yd": 157,
    "td": 7,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Mike Gillislee": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 25,
    "full_name": "mikegillislee",
    "first_name": "Mike",
    "last_name": "Gillislee",
    "position": "RB",
    "age": 28,
    "team": null,
    "player_id": "1353",
    "my_id": 1353,
    "gp": 4,
    "gs": 0,
    "pts_ppr": 4.2,
    "rec": 1,
    "rec_yd": 9,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 16,
    "rush_td": 0,
    "rush_yd": 43,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Dion Sims": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 88,
    "full_name": "dionsims",
    "first_name": "Dion",
    "last_name": "Sims",
    "position": "TE",
    "age": 28,
    "team": null,
    "player_id": "1357",
    "my_id": 1357,
    "gp": 8,
    "gs": 4,
    "pts_ppr": 2.9,
    "rec": 2,
    "rec_yd": 9,
    "rec_td": 0,
    "rec_tgt": 4,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Geno Smith": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 7,
    "full_name": "genosmith",
    "first_name": "Geno",
    "last_name": "Smith",
    "position": "QB",
    "age": 29,
    "team": "SEA",
    "player_id": "1373",
    "my_id": 1373,
    "gp": 5,
    "gs": 0,
    "pts_ppr": -1.48,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 8,
    "rush_td": 0,
    "rush_yd": 2,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 1,
    "pass_att": 4,
    "pass_yd": 8,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Giovani Bernard": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 25,
    "full_name": "giovanibernard",
    "first_name": "Giovani",
    "last_name": "Bernard",
    "position": "RB",
    "age": 27,
    "team": "CIN",
    "player_id": "1386",
    "my_id": 1386,
    "gp": 12,
    "gs": 4,
    "pts_ppr": 95.9,
    "rec": 35,
    "rec_yd": 218,
    "rec_td": 0,
    "rec_tgt": 48,
    "rush_att": 56,
    "rush_td": 3,
    "rush_yd": 211,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Rex Burkhead": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 34,
    "full_name": "rexburkhead",
    "first_name": "Rex",
    "last_name": "Burkhead",
    "position": "RB",
    "age": 29,
    "team": "NE",
    "player_id": "1387",
    "my_id": 1387,
    "gp": 8,
    "gs": 4,
    "pts_ppr": 49.7,
    "rec": 14,
    "rec_yd": 131,
    "rec_td": 1,
    "rec_tgt": 20,
    "rush_att": 57,
    "rush_td": 0,
    "rush_yd": 186,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Tyler Eifert": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 85,
    "full_name": "tylereifert",
    "first_name": "Tyler",
    "last_name": "Eifert",
    "position": "TE",
    "age": 29,
    "team": "CIN",
    "player_id": "1388",
    "my_id": 1388,
    "gp": 4,
    "gs": 2,
    "pts_ppr": 38.9,
    "rec": 15,
    "rec_yd": 179,
    "rec_td": 1,
    "rec_tgt": 19,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Markus Wheaton": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 80,
    "full_name": "markuswheaton",
    "first_name": "Markus",
    "last_name": "Wheaton",
    "position": "WR",
    "age": 28,
    "team": null,
    "player_id": "1413",
    "my_id": 1413,
    "gp": 1,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Justin Hunter": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 11,
    "full_name": "justinhunter",
    "first_name": "Justin",
    "last_name": "Hunter",
    "position": "WR",
    "age": 28,
    "team": null,
    "player_id": "1418",
    "my_id": 1418,
    "gp": 5,
    "gs": 0,
    "pts_ppr": 5.1,
    "rec": 3,
    "rec_yd": 21,
    "rec_td": 0,
    "rec_tgt": 13,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Ryan Griffin": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 84,
    "full_name": "ryangriffin",
    "first_name": "Ryan",
    "last_name": "Griffin",
    "position": "TE",
    "age": 29,
    "team": "NYJ",
    "player_id": "1425",
    "my_id": 1425,
    "gp": 14,
    "gs": 11,
    "pts_ppr": 54.5,
    "rec": 24,
    "rec_yd": 305,
    "rec_td": 0,
    "rec_tgt": 43,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "DeAndre Hopkins": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 10,
    "full_name": "deandrehopkins",
    "first_name": "DeAndre",
    "last_name": "Hopkins",
    "position": "WR",
    "age": 27,
    "team": "HOU",
    "player_id": "1426",
    "my_id": 1426,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 333.5,
    "rec": 115,
    "rec_yd": 1572,
    "rec_td": 11,
    "rec_tgt": 163,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": -7,
    "td": 11,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 1,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 2
  },
  "CJ Anderson": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 26,
    "full_name": "cjanderson",
    "first_name": "CJ",
    "last_name": "Anderson",
    "position": "RB",
    "age": 28,
    "team": null,
    "player_id": "1451",
    "my_id": 1451,
    "gp": 11,
    "gs": 3,
    "pts_ppr": 67.4,
    "rec": 5,
    "rec_yd": 41,
    "rec_td": 1,
    "rec_tgt": 9,
    "rush_att": 67,
    "rush_td": 2,
    "rush_yd": 403,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Travis Kelce": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 87,
    "full_name": "traviskelce",
    "first_name": "Travis",
    "last_name": "Kelce",
    "position": "TE",
    "age": 30,
    "team": "KC",
    "player_id": "1466",
    "my_id": 1466,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 294.6,
    "rec": 103,
    "rec_yd": 1336,
    "rec_td": 10,
    "rec_tgt": 150,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 10,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Brice Butler": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 14,
    "full_name": "bricebutler",
    "first_name": "Brice",
    "last_name": "Butler",
    "position": "WR",
    "age": 29,
    "team": null,
    "player_id": "1471",
    "my_id": 1471,
    "gp": 8,
    "gs": 1,
    "pts_ppr": 18,
    "rec": 6,
    "rec_yd": 60,
    "rec_td": 1,
    "rec_tgt": 10,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Latavius Murray": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 28,
    "full_name": "lataviusmurray",
    "first_name": "Latavius",
    "last_name": "Murray",
    "position": "RB",
    "age": 28,
    "team": "NO",
    "player_id": "1476",
    "my_id": 1476,
    "gp": 16,
    "gs": 6,
    "pts_ppr": 131.9,
    "rec": 22,
    "rec_yd": 141,
    "rec_td": 0,
    "rec_tgt": 26,
    "rush_att": 140,
    "rush_td": 6,
    "rush_yd": 578,
    "td": 6,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Keenan Allen": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 13,
    "full_name": "keenanallen",
    "first_name": "Keenan",
    "last_name": "Allen",
    "position": "WR",
    "age": 27,
    "team": "LAC",
    "player_id": "1479",
    "my_id": 1479,
    "gp": 16,
    "gs": 14,
    "pts_ppr": 260.1,
    "rec": 97,
    "rec_yd": 1196,
    "rec_td": 6,
    "rec_tgt": 136,
    "rush_att": 9,
    "rush_td": 0,
    "rush_yd": 75,
    "td": 6,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Terrance Williams": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 83,
    "full_name": "terrancewilliams",
    "first_name": "Terrance",
    "last_name": "Williams",
    "position": "WR",
    "age": 30,
    "team": null,
    "player_id": "1490",
    "my_id": 1490,
    "gp": 3,
    "gs": 2,
    "pts_ppr": 3.8,
    "rec": 2,
    "rec_yd": 18,
    "rec_td": 0,
    "rec_tgt": 3,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jordan Reed": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 86,
    "full_name": "jordanreed",
    "first_name": "Jordan",
    "last_name": "Reed",
    "position": "TE",
    "age": 29,
    "team": "WAS",
    "player_id": "1500",
    "my_id": 1500,
    "gp": 13,
    "gs": 8,
    "pts_ppr": 119.8,
    "rec": 54,
    "rec_yd": 558,
    "rec_td": 2,
    "rec_tgt": 84,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Chris Thompson": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 25,
    "full_name": "christhompson",
    "first_name": "Chris",
    "last_name": "Thompson",
    "position": "RB",
    "age": 29,
    "team": "WAS",
    "player_id": "1502",
    "my_id": 1502,
    "gp": 10,
    "gs": 0,
    "pts_ppr": 91.6,
    "rec": 41,
    "rec_yd": 268,
    "rec_td": 1,
    "rec_tgt": 55,
    "rush_att": 43,
    "rush_td": 0,
    "rush_yd": 178,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Theo Riddick": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 27,
    "full_name": "theoriddick",
    "first_name": "Theo",
    "last_name": "Riddick",
    "position": "RB",
    "age": 28,
    "team": "DEN",
    "player_id": "1517",
    "my_id": 1517,
    "gp": 14,
    "gs": 3,
    "pts_ppr": 116.5,
    "rec": 61,
    "rec_yd": 384,
    "rec_td": 0,
    "rec_tgt": 74,
    "rush_att": 40,
    "rush_td": 0,
    "rush_yd": 171,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Cordarrelle Patterson": {
    "fantasy_positions": [
      "WR",
      "RB"
    ],
    "year": 2018,
    "number": 84,
    "full_name": "cordarrellepatterson",
    "first_name": "Cordarrelle",
    "last_name": "Patterson",
    "position": "WR",
    "age": 28,
    "team": "CHI",
    "player_id": "1535",
    "my_id": 1535,
    "gp": 15,
    "gs": 6,
    "pts_ppr": 90.5,
    "rec": 21,
    "rec_yd": 247,
    "rec_td": 3,
    "rec_tgt": 28,
    "rush_att": 42,
    "rush_td": 1,
    "rush_yd": 228,
    "td": 5,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Kenjon Barner": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 38,
    "full_name": "kenjonbarner",
    "first_name": "Kenjon",
    "last_name": "Barner",
    "position": "RB",
    "age": 30,
    "team": "ATL",
    "player_id": "1546",
    "my_id": 1546,
    "gp": 9,
    "gs": 0,
    "pts_ppr": 8.4,
    "rec": 1,
    "rec_yd": 3,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 19,
    "rush_td": 0,
    "rush_yd": 71,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Kenny Stills": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 12,
    "full_name": "kennystills",
    "first_name": "Kenny",
    "last_name": "Stills",
    "position": "WR",
    "age": 27,
    "team": "HOU",
    "player_id": "1555",
    "my_id": 1555,
    "gp": 15,
    "gs": 15,
    "pts_ppr": 134.42,
    "rec": 37,
    "rec_yd": 553,
    "rec_td": 6,
    "rec_tgt": 64,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 6,
    "pass_td": 1,
    "pass_int": 0,
    "pass_cmp": 1,
    "pass_att": 1,
    "pass_yd": 3,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Mike Glennon": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 7,
    "full_name": "mikeglennon",
    "first_name": "Mike",
    "last_name": "Glennon",
    "position": "QB",
    "age": 29,
    "team": "OAK",
    "player_id": "1559",
    "my_id": 1559,
    "gp": 2,
    "gs": 0,
    "pts_ppr": 10.96,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 1,
    "pass_int": 0,
    "pass_cmp": 15,
    "pass_att": 21,
    "pass_yd": 174,
    "pass_inc": 6,
    "fum_lost": 0
  },
  "Benjamin Cunningham": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 29,
    "full_name": "benjamincunningham",
    "first_name": "Benjamin",
    "last_name": "Cunningham",
    "position": "RB",
    "age": 29,
    "team": null,
    "player_id": "1564",
    "my_id": 1564,
    "gp": 15,
    "gs": 0,
    "pts_ppr": 3.9,
    "rec": 1,
    "rec_yd": 9,
    "rec_td": 0,
    "rec_tgt": 2,
    "rush_att": 11,
    "rush_td": 0,
    "rush_yd": 20,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Tavon Austin": {
    "fantasy_positions": [
      "WR",
      "RB"
    ],
    "year": 2018,
    "number": 10,
    "full_name": "tavonaustin",
    "first_name": "Tavon",
    "last_name": "Austin",
    "position": "WR",
    "age": 28,
    "team": "DAL",
    "player_id": "1567",
    "my_id": 1567,
    "gp": 7,
    "gs": 0,
    "pts_ppr": 39.5,
    "rec": 8,
    "rec_yd": 140,
    "rec_td": 2,
    "rec_tgt": 13,
    "rush_att": 6,
    "rush_td": 0,
    "rush_yd": 55,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Vance McDonald": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 89,
    "full_name": "vancemcdonald",
    "first_name": "Vance",
    "last_name": "McDonald",
    "position": "TE",
    "age": 29,
    "team": "PIT",
    "player_id": "1587",
    "my_id": 1587,
    "gp": 15,
    "gs": 14,
    "pts_ppr": 133,
    "rec": 50,
    "rec_yd": 610,
    "rec_td": 4,
    "rec_tgt": 73,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Darren Fells": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 87,
    "full_name": "darrenfells",
    "first_name": "Darren",
    "last_name": "Fells",
    "position": "TE",
    "age": 33,
    "team": "HOU",
    "player_id": "1592",
    "my_id": 1592,
    "gp": 16,
    "gs": 11,
    "pts_ppr": 40.7,
    "rec": 11,
    "rec_yd": 117,
    "rec_td": 3,
    "rec_tgt": 12,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Christine Michael": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 38,
    "full_name": "christinemichael",
    "first_name": "Christine",
    "last_name": "Michael",
    "position": "RB",
    "age": 28,
    "team": null,
    "player_id": "1596",
    "my_id": 1596,
    "gp": 1,
    "gs": 0,
    "pts_ppr": 0.9,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 2,
    "rush_td": 0,
    "rush_yd": 9,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Spencer Ware": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 40,
    "full_name": "spencerware",
    "first_name": "Spencer",
    "last_name": "Ware",
    "position": "RB",
    "age": 27,
    "team": null,
    "player_id": "1601",
    "my_id": 1601,
    "gp": 13,
    "gs": 2,
    "pts_ppr": 79,
    "rec": 20,
    "rec_yd": 224,
    "rec_td": 0,
    "rec_tgt": 23,
    "rush_att": 51,
    "rush_td": 2,
    "rush_yd": 246,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Luke Willson": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 82,
    "full_name": "lukewillson",
    "first_name": "Luke",
    "last_name": "Willson",
    "position": "TE",
    "age": 29,
    "team": "SEA",
    "player_id": "1603",
    "my_id": 1603,
    "gp": 14,
    "gs": 8,
    "pts_ppr": 21.7,
    "rec": 13,
    "rec_yd": 87,
    "rec_td": 0,
    "rec_tgt": 19,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Nick Williams": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 86,
    "full_name": "nickwilliams",
    "first_name": "Nick",
    "last_name": "Williams",
    "position": "WR",
    "age": 28,
    "team": null,
    "player_id": "1604",
    "my_id": 1604,
    "gp": 4,
    "gs": 0,
    "pts_ppr": 3.7,
    "rec": 2,
    "rec_yd": 17,
    "rec_td": 0,
    "rec_tgt": 4,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Demetrius Harris": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 88,
    "full_name": "demetriusharris",
    "first_name": "Demetrius",
    "last_name": "Harris",
    "position": "TE",
    "age": 28,
    "team": "CLE",
    "player_id": "1619",
    "my_id": 1619,
    "gp": 15,
    "gs": 3,
    "pts_ppr": 46.4,
    "rec": 12,
    "rec_yd": 164,
    "rec_td": 3,
    "rec_tgt": 25,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Levine Toilolo": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 83,
    "full_name": "levinetoilolo",
    "first_name": "Levine",
    "last_name": "Toilolo",
    "position": "TE",
    "age": 28,
    "team": "SF",
    "player_id": "1642",
    "my_id": 1642,
    "gp": 16,
    "gs": 10,
    "pts_ppr": 53.3,
    "rec": 21,
    "rec_yd": 263,
    "rec_td": 1,
    "rec_tgt": 24,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jaron Brown": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 18,
    "full_name": "jaronbrown",
    "first_name": "Jaron",
    "last_name": "Brown",
    "position": "WR",
    "age": 29,
    "team": "SEA",
    "player_id": "1684",
    "my_id": 1684,
    "gp": 15,
    "gs": 2,
    "pts_ppr": 60.6,
    "rec": 14,
    "rec_yd": 166,
    "rec_td": 5,
    "rec_tgt": 20,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 5,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Adam Thielen": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 19,
    "full_name": "adamthielen",
    "first_name": "Adam",
    "last_name": "Thielen",
    "position": "WR",
    "age": 29,
    "team": "MIN",
    "player_id": "1689",
    "my_id": 1689,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 307.3,
    "rec": 113,
    "rec_yd": 1373,
    "rec_td": 9,
    "rec_tgt": 155,
    "rush_att": 5,
    "rush_td": 0,
    "rush_yd": 30,
    "td": 9,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Jack Doyle": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 84,
    "full_name": "jackdoyle",
    "first_name": "Jack",
    "last_name": "Doyle",
    "position": "TE",
    "age": 29,
    "team": "IND",
    "player_id": "1706",
    "my_id": 1706,
    "gp": 6,
    "gs": 6,
    "pts_ppr": 60.5,
    "rec": 26,
    "rec_yd": 245,
    "rec_td": 2,
    "rec_tgt": 33,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Derek Carrier": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 85,
    "full_name": "derekcarrier",
    "first_name": "Derek",
    "last_name": "Carrier",
    "position": "TE",
    "age": 29,
    "team": "OAK",
    "player_id": "1718",
    "my_id": 1718,
    "gp": 16,
    "gs": 2,
    "pts_ppr": 19.7,
    "rec": 7,
    "rec_yd": 67,
    "rec_td": 1,
    "rec_tgt": 12,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Case Keenum": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 8,
    "full_name": "casekeenum",
    "first_name": "Case",
    "last_name": "Keenum",
    "position": "QB",
    "age": 31,
    "team": "WAS",
    "player_id": "1737",
    "my_id": 1737,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 214.9,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 26,
    "rush_td": 2,
    "rush_yd": 93,
    "td": 2,
    "pass_td": 18,
    "pass_int": 15,
    "pass_cmp": 365,
    "pass_att": 586,
    "pass_yd": 3890,
    "pass_inc": 221,
    "fum_lost": 2
  },
  "Josh Hill": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 89,
    "full_name": "joshhill",
    "first_name": "Josh",
    "last_name": "Hill",
    "position": "TE",
    "age": 29,
    "team": "NO",
    "player_id": "1777",
    "my_id": 1777,
    "gp": 16,
    "gs": 11,
    "pts_ppr": 40.5,
    "rec": 16,
    "rec_yd": 185,
    "rec_td": 1,
    "rec_tgt": 24,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Trey Burton": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 80,
    "full_name": "treyburton",
    "first_name": "Trey",
    "last_name": "Burton",
    "position": "TE",
    "age": 27,
    "team": "CHI",
    "player_id": "1793",
    "my_id": 1793,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 147.1,
    "rec": 54,
    "rec_yd": 569,
    "rec_td": 6,
    "rec_tgt": 77,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 2,
    "td": 6,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "David Fluellen": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 32,
    "full_name": "davidfluellen",
    "first_name": "David",
    "last_name": "Fluellen",
    "position": "RB",
    "age": 27,
    "team": "TEN",
    "player_id": "1794",
    "my_id": 1794,
    "gp": 7,
    "gs": 0,
    "pts_ppr": 1.6,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 4,
    "rush_td": 0,
    "rush_yd": 16,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jordan Matthews": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 81,
    "full_name": "jordanmatthews",
    "first_name": "Jordan",
    "last_name": "Matthews",
    "position": "WR",
    "age": 27,
    "team": "SF",
    "player_id": "1800",
    "my_id": 1800,
    "gp": 14,
    "gs": 3,
    "pts_ppr": 62,
    "rec": 20,
    "rec_yd": 300,
    "rec_td": 2,
    "rec_tgt": 28,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Sammy Watkins": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 14,
    "full_name": "sammywatkins",
    "first_name": "Sammy",
    "last_name": "Watkins",
    "position": "WR",
    "age": 26,
    "team": "KC",
    "player_id": "1817",
    "my_id": 1817,
    "gp": 10,
    "gs": 9,
    "pts_ppr": 115.1,
    "rec": 40,
    "rec_yd": 519,
    "rec_td": 3,
    "rec_tgt": 55,
    "rush_att": 5,
    "rush_td": 0,
    "rush_yd": 52,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jarvis Landry": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 80,
    "full_name": "jarvislandry",
    "first_name": "Jarvis",
    "last_name": "Landry",
    "position": "WR",
    "age": 26,
    "team": "CLE",
    "player_id": "1825",
    "my_id": 1825,
    "gp": 16,
    "gs": 14,
    "pts_ppr": 217.12,
    "rec": 81,
    "rec_yd": 976,
    "rec_td": 4,
    "rec_tgt": 149,
    "rush_att": 3,
    "rush_td": 1,
    "rush_yd": 60,
    "td": 5,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 1,
    "pass_att": 2,
    "pass_yd": 63,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Damien Williams": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 26,
    "full_name": "damienwilliams",
    "first_name": "Damien",
    "last_name": "Williams",
    "position": "RB",
    "age": 27,
    "team": "KC",
    "player_id": "1833",
    "my_id": 1833,
    "gp": 14,
    "gs": 3,
    "pts_ppr": 98.6,
    "rec": 23,
    "rec_yd": 160,
    "rec_td": 2,
    "rec_tgt": 24,
    "rush_att": 50,
    "rush_td": 4,
    "rush_yd": 256,
    "td": 6,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Jimmy Garoppolo": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 10,
    "full_name": "jimmygaroppolo",
    "first_name": "Jimmy",
    "last_name": "Garoppolo",
    "position": "QB",
    "age": 27,
    "team": "SF",
    "player_id": "1837",
    "my_id": 1837,
    "gp": 3,
    "gs": 3,
    "pts_ppr": 48.02,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 8,
    "rush_td": 0,
    "rush_yd": 33,
    "td": 0,
    "pass_td": 5,
    "pass_int": 3,
    "pass_cmp": 53,
    "pass_att": 89,
    "pass_yd": 718,
    "pass_inc": 36,
    "fum_lost": 0
  },
  "James White": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 28,
    "full_name": "jameswhite",
    "first_name": "James",
    "last_name": "White",
    "position": "RB",
    "age": 27,
    "team": "NE",
    "player_id": "1848",
    "my_id": 1848,
    "gp": 16,
    "gs": 3,
    "pts_ppr": 276.6,
    "rec": 87,
    "rec_yd": 751,
    "rec_td": 7,
    "rec_tgt": 123,
    "rush_att": 94,
    "rush_td": 5,
    "rush_yd": 425,
    "td": 12,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Quincy Enunwa": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 81,
    "full_name": "quincyenunwa",
    "first_name": "Quincy",
    "last_name": "Enunwa",
    "position": "WR",
    "age": 27,
    "team": "NYJ",
    "player_id": "1854",
    "my_id": 1854,
    "gp": 11,
    "gs": 10,
    "pts_ppr": 86.9,
    "rec": 38,
    "rec_yd": 449,
    "rec_td": 1,
    "rec_tgt": 69,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Ryan Hewitt": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 88,
    "full_name": "ryanhewitt",
    "first_name": "Ryan",
    "last_name": "Hewitt",
    "position": "TE",
    "age": 28,
    "team": null,
    "player_id": "1891",
    "my_id": 1891,
    "gp": 12,
    "gs": 2,
    "pts_ppr": 7.1,
    "rec": 1,
    "rec_yd": 1,
    "rec_td": 1,
    "rec_tgt": 2,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jeremy Hill": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 33,
    "full_name": "jeremyhill",
    "first_name": "Jeremy",
    "last_name": "Hill",
    "position": "RB",
    "age": 27,
    "team": null,
    "player_id": "1892",
    "my_id": 1892,
    "gp": 1,
    "gs": 0,
    "pts_ppr": 4.1,
    "rec": 1,
    "rec_yd": 6,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 4,
    "rush_td": 0,
    "rush_yd": 25,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "AJ McCarron": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 2,
    "full_name": "ajmccarron",
    "first_name": "AJ",
    "last_name": "McCarron",
    "position": "QB",
    "age": 29,
    "team": "HOU",
    "player_id": "1895",
    "my_id": 1895,
    "gp": 2,
    "gs": 0,
    "pts_ppr": 0.12,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 3,
    "rush_td": 0,
    "rush_yd": -2,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 1,
    "pass_att": 3,
    "pass_yd": 8,
    "pass_inc": 2,
    "fum_lost": 0
  },
  "Isaiah Crowell": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 22,
    "full_name": "isaiahcrowell",
    "first_name": "Isaiah",
    "last_name": "Crowell",
    "position": "RB",
    "age": 26,
    "team": "OAK",
    "player_id": "1901",
    "my_id": 1901,
    "gp": 13,
    "gs": 6,
    "pts_ppr": 140.7,
    "rec": 21,
    "rec_yd": 152,
    "rec_td": 0,
    "rec_tgt": 28,
    "rush_att": 143,
    "rush_td": 6,
    "rush_yd": 685,
    "td": 6,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Taylor Gabriel": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 18,
    "full_name": "taylorgabriel",
    "first_name": "Taylor",
    "last_name": "Gabriel",
    "position": "WR",
    "age": 28,
    "team": "CHI",
    "player_id": "1903",
    "my_id": 1903,
    "gp": 16,
    "gs": 11,
    "pts_ppr": 151.9,
    "rec": 67,
    "rec_yd": 688,
    "rec_td": 2,
    "rec_tgt": 93,
    "rush_att": 9,
    "rush_td": 0,
    "rush_yd": 61,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Willie Snead": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 83,
    "full_name": "williesnead",
    "first_name": "Willie",
    "last_name": "Snead",
    "position": "WR",
    "age": 27,
    "team": "BAL",
    "player_id": "1911",
    "my_id": 1911,
    "gp": 16,
    "gs": 10,
    "pts_ppr": 134.4,
    "rec": 62,
    "rec_yd": 651,
    "rec_td": 1,
    "rec_tgt": 95,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 13,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Martavis Bryant": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 12,
    "full_name": "martavisbryant",
    "first_name": "Martavis",
    "last_name": "Bryant",
    "position": "WR",
    "age": 27,
    "team": null,
    "player_id": "1916",
    "my_id": 1916,
    "gp": 8,
    "gs": 2,
    "pts_ppr": 45.9,
    "rec": 19,
    "rec_yd": 266,
    "rec_td": 0,
    "rec_tgt": 27,
    "rush_att": 3,
    "rush_td": 0,
    "rush_yd": 23,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Alfred Blue": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 23,
    "full_name": "alfredblue",
    "first_name": "Alfred",
    "last_name": "Blue",
    "position": "RB",
    "age": 28,
    "team": "JAX",
    "player_id": "1944",
    "my_id": 1944,
    "gp": 16,
    "gs": 2,
    "pts_ppr": 97.3,
    "rec": 20,
    "rec_yd": 154,
    "rec_td": 0,
    "rec_tgt": 27,
    "rush_att": 150,
    "rush_td": 2,
    "rush_yd": 499,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Donte Moncrief": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 11,
    "full_name": "dontemoncrief",
    "first_name": "Donte",
    "last_name": "Moncrief",
    "position": "WR",
    "age": 26,
    "team": "PIT",
    "player_id": "1971",
    "my_id": 1971,
    "gp": 16,
    "gs": 14,
    "pts_ppr": 130.8,
    "rec": 48,
    "rec_yd": 668,
    "rec_td": 3,
    "rec_tgt": 89,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Erik Swoope": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 86,
    "full_name": "erikswoope",
    "first_name": "Erik",
    "last_name": "Swoope",
    "position": "TE",
    "age": 27,
    "team": null,
    "player_id": "1975",
    "my_id": 1975,
    "gp": 7,
    "gs": 2,
    "pts_ppr": 34.7,
    "rec": 8,
    "rec_yd": 87,
    "rec_td": 3,
    "rec_tgt": 10,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Blake Bortles": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 5,
    "full_name": "blakebortles",
    "first_name": "Blake",
    "last_name": "Bortles",
    "position": "QB",
    "age": 27,
    "team": "LAR",
    "player_id": "1979",
    "my_id": 1979,
    "gp": 13,
    "gs": 12,
    "pts_ppr": 173.22,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 58,
    "rush_td": 1,
    "rush_yd": 365,
    "td": 1,
    "pass_td": 13,
    "pass_int": 11,
    "pass_cmp": 243,
    "pass_att": 403,
    "pass_yd": 2718,
    "pass_inc": 160,
    "fum_lost": 4
  },
  "Allen Hurns": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 17,
    "full_name": "allenhurns",
    "first_name": "Allen",
    "last_name": "Hurns",
    "position": "WR",
    "age": 27,
    "team": "MIA",
    "player_id": "1984",
    "my_id": 1984,
    "gp": 16,
    "gs": 7,
    "pts_ppr": 61.5,
    "rec": 20,
    "rec_yd": 295,
    "rec_td": 2,
    "rec_tgt": 36,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Allen Robinson": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 12,
    "full_name": "allenrobinson",
    "first_name": "Allen",
    "last_name": "Robinson",
    "position": "WR",
    "age": 26,
    "team": "CHI",
    "player_id": "1992",
    "my_id": 1992,
    "gp": 13,
    "gs": 12,
    "pts_ppr": 153.3,
    "rec": 55,
    "rec_yd": 754,
    "rec_td": 4,
    "rec_tgt": 94,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 9,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Kapri Bibbs": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 22,
    "full_name": "kapribibbs",
    "first_name": "Kapri",
    "last_name": "Bibbs",
    "position": "RB",
    "age": 26,
    "team": null,
    "player_id": "2001",
    "my_id": 2001,
    "gp": 12,
    "gs": 0,
    "pts_ppr": 61.8,
    "rec": 16,
    "rec_yd": 115,
    "rec_td": 1,
    "rec_tgt": 23,
    "rush_att": 21,
    "rush_td": 3,
    "rush_yd": 103,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Bennie Fowler": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 18,
    "full_name": "benniefowler",
    "first_name": "Bennie",
    "last_name": "Fowler",
    "position": "WR",
    "age": 28,
    "team": "NYG",
    "player_id": "2003",
    "my_id": 2003,
    "gp": 10,
    "gs": 5,
    "pts_ppr": 41.9,
    "rec": 16,
    "rec_yd": 199,
    "rec_td": 1,
    "rec_tgt": 27,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Cody Latimer": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 12,
    "full_name": "codylatimer",
    "first_name": "Cody",
    "last_name": "Latimer",
    "position": "WR",
    "age": 27,
    "team": "NYG",
    "player_id": "2004",
    "my_id": 2004,
    "gp": 6,
    "gs": 2,
    "pts_ppr": 36,
    "rec": 11,
    "rec_yd": 190,
    "rec_td": 1,
    "rec_tgt": 16,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "De'Anthony Thomas": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 84,
    "full_name": "deanthonythomas",
    "first_name": "De'Anthony",
    "last_name": "Thomas",
    "position": "WR",
    "age": 26,
    "team": "KC",
    "player_id": "2023",
    "my_id": 2023,
    "gp": 5,
    "gs": 0,
    "pts_ppr": 12.5,
    "rec": 3,
    "rec_yd": 29,
    "rec_td": 1,
    "rec_tgt": 5,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 6,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Charcandrick West": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 36,
    "full_name": "charcandrickwest",
    "first_name": "Charcandrick",
    "last_name": "West",
    "position": "RB",
    "age": 28,
    "team": null,
    "player_id": "2024",
    "my_id": 2024,
    "gp": 3,
    "gs": 0,
    "pts_ppr": 11.6,
    "rec": 2,
    "rec_yd": 37,
    "rec_td": 1,
    "rec_tgt": 3,
    "rush_att": 2,
    "rush_td": 0,
    "rush_yd": -1,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Albert Wilson": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 15,
    "full_name": "albertwilson",
    "first_name": "Albert",
    "last_name": "Wilson",
    "position": "WR",
    "age": 27,
    "team": "MIA",
    "player_id": "2025",
    "my_id": 2025,
    "gp": 7,
    "gs": 4,
    "pts_ppr": 96.78,
    "rec": 26,
    "rec_yd": 391,
    "rec_td": 4,
    "rec_tgt": 35,
    "rush_att": 8,
    "rush_td": 0,
    "rush_yd": 16,
    "td": 4,
    "pass_td": 1,
    "pass_int": 0,
    "pass_cmp": 1,
    "pass_att": 1,
    "pass_yd": 52,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Derek Carr": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 4,
    "full_name": "derekcarr",
    "first_name": "Derek",
    "last_name": "Carr",
    "position": "QB",
    "age": 28,
    "team": "OAK",
    "player_id": "2028",
    "my_id": 2028,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 216.76,
    "rec": 1,
    "rec_yd": -9,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 24,
    "rush_td": 1,
    "rush_yd": 47,
    "td": 1,
    "pass_td": 19,
    "pass_int": 10,
    "pass_cmp": 381,
    "pass_att": 553,
    "pass_yd": 4049,
    "pass_inc": 172,
    "fum_lost": 7
  },
  "Seth Roberts": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 11,
    "full_name": "sethroberts",
    "first_name": "Seth",
    "last_name": "Roberts",
    "position": "WR",
    "age": 28,
    "team": "BAL",
    "player_id": "2039",
    "my_id": 2039,
    "gp": 15,
    "gs": 7,
    "pts_ppr": 106.9,
    "rec": 45,
    "rec_yd": 494,
    "rec_td": 2,
    "rec_tgt": 65,
    "rush_att": 3,
    "rush_td": 0,
    "rush_yd": 5,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Scott Simonson": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 82,
    "full_name": "scottsimonson",
    "first_name": "Scott",
    "last_name": "Simonson",
    "position": "TE",
    "age": 27,
    "team": null,
    "player_id": "2040",
    "my_id": 2040,
    "gp": 16,
    "gs": 4,
    "pts_ppr": 23.6,
    "rec": 9,
    "rec_yd": 86,
    "rec_td": 1,
    "rec_tgt": 14,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Odell Beckham Jr": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 13,
    "full_name": "odellbeckhamjr",
    "first_name": "Odell",
    "last_name": "Beckham Jr",
    "position": "WR",
    "age": 26,
    "team": "CLE",
    "player_id": "2078",
    "my_id": 2078,
    "gp": 12,
    "gs": 12,
    "pts_ppr": 230.34,
    "rec": 77,
    "rec_yd": 1052,
    "rec_td": 6,
    "rec_tgt": 124,
    "rush_att": 5,
    "rush_td": 0,
    "rush_yd": 19,
    "td": 6,
    "pass_td": 2,
    "pass_int": 0,
    "pass_cmp": 2,
    "pass_att": 2,
    "pass_yd": 106,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Xavier Grimble": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 85,
    "full_name": "xaviergrimble",
    "first_name": "Xavier",
    "last_name": "Grimble",
    "position": "TE",
    "age": 28,
    "team": null,
    "player_id": "2082",
    "my_id": 2082,
    "gp": 16,
    "gs": 2,
    "pts_ppr": 12.6,
    "rec": 6,
    "rec_yd": 86,
    "rec_td": 0,
    "rec_tgt": 8,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Ryan Grant": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 19,
    "full_name": "ryangrant",
    "first_name": "Ryan",
    "last_name": "Grant",
    "position": "WR",
    "age": 28,
    "team": null,
    "player_id": "2093",
    "my_id": 2093,
    "gp": 14,
    "gs": 10,
    "pts_ppr": 74.4,
    "rec": 35,
    "rec_yd": 334,
    "rec_td": 1,
    "rec_tgt": 51,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Senorise Perry": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 32,
    "full_name": "senoriseperry",
    "first_name": "Senorise",
    "last_name": "Perry",
    "position": "RB",
    "age": 28,
    "team": "BUF",
    "player_id": "2114",
    "my_id": 2114,
    "gp": 16,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Eric Ebron": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 85,
    "full_name": "ericebron",
    "first_name": "Eric",
    "last_name": "Ebron",
    "position": "TE",
    "age": 26,
    "team": "IND",
    "player_id": "2118",
    "my_id": 2118,
    "gp": 16,
    "gs": 8,
    "pts_ppr": 222.2,
    "rec": 66,
    "rec_yd": 750,
    "rec_td": 13,
    "rec_tgt": 110,
    "rush_att": 3,
    "rush_td": 1,
    "rush_yd": -8,
    "td": 14,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 1,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "TJ Jones": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 80,
    "full_name": "tjjones",
    "first_name": "TJ",
    "last_name": "Jones",
    "position": "WR",
    "age": 27,
    "team": null,
    "player_id": "2121",
    "my_id": 2121,
    "gp": 15,
    "gs": 3,
    "pts_ppr": 50,
    "rec": 19,
    "rec_yd": 190,
    "rec_td": 2,
    "rec_tgt": 27,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Davante Adams": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 17,
    "full_name": "davanteadams",
    "first_name": "Davante",
    "last_name": "Adams",
    "position": "WR",
    "age": 26,
    "team": "GB",
    "player_id": "2133",
    "my_id": 2133,
    "gp": 15,
    "gs": 15,
    "pts_ppr": 329.6,
    "rec": 111,
    "rec_yd": 1386,
    "rec_td": 13,
    "rec_tgt": 169,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 13,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Richard Rodgers": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 82,
    "full_name": "richardrodgers",
    "first_name": "Richard",
    "last_name": "Rodgers",
    "position": "TE",
    "age": 27,
    "team": null,
    "player_id": "2146",
    "my_id": 2146,
    "gp": 6,
    "gs": 0,
    "pts_ppr": 1.7,
    "rec": 1,
    "rec_yd": 7,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Teddy Bridgewater": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 5,
    "full_name": "teddybridgewater",
    "first_name": "Teddy",
    "last_name": "Bridgewater",
    "position": "QB",
    "age": 26,
    "team": "NO",
    "player_id": "2152",
    "my_id": 2152,
    "gp": 5,
    "gs": 1,
    "pts_ppr": 7.22,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 11,
    "rush_td": 0,
    "rush_yd": 5,
    "td": 0,
    "pass_td": 1,
    "pass_int": 1,
    "pass_cmp": 14,
    "pass_att": 23,
    "pass_yd": 118,
    "pass_inc": 8,
    "fum_lost": 0
  },
  "Devonta Freeman": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 24,
    "full_name": "devontafreeman",
    "first_name": "Devonta",
    "last_name": "Freeman",
    "position": "RB",
    "age": 27,
    "team": "ATL",
    "player_id": "2168",
    "my_id": 2168,
    "gp": 2,
    "gs": 2,
    "pts_ppr": 14.1,
    "rec": 5,
    "rec_yd": 23,
    "rec_td": 0,
    "rec_tgt": 7,
    "rush_att": 14,
    "rush_td": 0,
    "rush_yd": 68,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Freddie Martino": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 16,
    "full_name": "freddiemartino",
    "first_name": "Freddie",
    "last_name": "Martino",
    "position": "WR",
    "age": 28,
    "team": null,
    "player_id": "2171",
    "my_id": 2171,
    "gp": 4,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Roosevelt Nix": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 45,
    "full_name": "rooseveltnix",
    "first_name": "Roosevelt",
    "last_name": "Nix",
    "position": "RB",
    "age": 27,
    "team": "PIT",
    "player_id": "2174",
    "my_id": 2174,
    "gp": 16,
    "gs": 0,
    "pts_ppr": 8.2,
    "rec": 4,
    "rec_yd": 38,
    "rec_td": 0,
    "rec_tgt": 6,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 4,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Kelvin Benjamin": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 81,
    "full_name": "kelvinbenjamin",
    "first_name": "Kelvin",
    "last_name": "Benjamin",
    "position": "WR",
    "age": 28,
    "team": null,
    "player_id": "2182",
    "my_id": 2182,
    "gp": 15,
    "gs": 10,
    "pts_ppr": 69,
    "rec": 25,
    "rec_yd": 380,
    "rec_td": 1,
    "rec_tgt": 67,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Brandin Cooks": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 12,
    "full_name": "brandincooks",
    "first_name": "Brandin",
    "last_name": "Cooks",
    "position": "WR",
    "age": 26,
    "team": "LAR",
    "player_id": "2197",
    "my_id": 2197,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 243.2,
    "rec": 80,
    "rec_yd": 1204,
    "rec_td": 5,
    "rec_tgt": 117,
    "rush_att": 10,
    "rush_td": 1,
    "rush_yd": 68,
    "td": 6,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Cameron Brate": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 84,
    "full_name": "cameronbrate",
    "first_name": "Cameron",
    "last_name": "Brate",
    "position": "TE",
    "age": 28,
    "team": "TB",
    "player_id": "2214",
    "my_id": 2214,
    "gp": 16,
    "gs": 2,
    "pts_ppr": 92.9,
    "rec": 30,
    "rec_yd": 289,
    "rec_td": 6,
    "rec_tgt": 49,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 6,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Mike Evans": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 13,
    "full_name": "mikeevans",
    "first_name": "Mike",
    "last_name": "Evans",
    "position": "WR",
    "age": 26,
    "team": "TB",
    "player_id": "2216",
    "my_id": 2216,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 290.4,
    "rec": 86,
    "rec_yd": 1524,
    "rec_td": 8,
    "rec_tgt": 138,
    "rush_att": 0,
    "rush_td": 1,
    "rush_yd": 0,
    "td": 9,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Austin Seferian-Jenkins": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 88,
    "full_name": "austinseferianjenkins",
    "first_name": "Austin",
    "last_name": "Seferian-Jenkins",
    "position": "TE",
    "age": 27,
    "team": null,
    "player_id": "2222",
    "my_id": 2222,
    "gp": 5,
    "gs": 5,
    "pts_ppr": 26,
    "rec": 11,
    "rec_yd": 90,
    "rec_td": 1,
    "rec_tgt": 20,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Garrett Gilbert": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 3,
    "full_name": "garrettgilbert",
    "first_name": "Garrett",
    "last_name": "Gilbert",
    "position": "QB",
    "age": 28,
    "team": "CLE",
    "player_id": "2229",
    "my_id": 2229,
    "gp": 1,
    "gs": 0,
    "pts_ppr": 1.6,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 2,
    "pass_att": 3,
    "pass_yd": 40,
    "pass_inc": 1,
    "fum_lost": 0
  },
  "John Brown": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 15,
    "full_name": "johnbrown",
    "first_name": "John",
    "last_name": "Brown",
    "position": "WR",
    "age": 29,
    "team": "BUF",
    "player_id": "2238",
    "my_id": 2238,
    "gp": 16,
    "gs": 15,
    "pts_ppr": 143.9,
    "rec": 42,
    "rec_yd": 715,
    "rec_td": 5,
    "rec_tgt": 97,
    "rush_att": 3,
    "rush_td": 0,
    "rush_yd": 4,
    "td": 5,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Logan Thomas": {
    "fantasy_positions": [
      "TE",
      "QB"
    ],
    "year": 2018,
    "number": 82,
    "full_name": "loganthomas",
    "first_name": "Logan",
    "last_name": "Thomas",
    "position": "TE",
    "age": 27,
    "team": "DET",
    "player_id": "2251",
    "my_id": 2251,
    "gp": 12,
    "gs": 3,
    "pts_ppr": 20.3,
    "rec": 12,
    "rec_yd": 77,
    "rec_td": 0,
    "rec_tgt": 17,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 1,
    "pass_att": 1,
    "pass_yd": 15,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Bruce Ellington": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 12,
    "full_name": "bruceellington",
    "first_name": "Bruce",
    "last_name": "Ellington",
    "position": "WR",
    "age": 28,
    "team": null,
    "player_id": "2255",
    "my_id": 2255,
    "gp": 7,
    "gs": 3,
    "pts_ppr": 59.6,
    "rec": 31,
    "rec_yd": 224,
    "rec_td": 1,
    "rec_tgt": 42,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 2,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 1,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Carlos Hyde": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 23,
    "full_name": "carloshyde",
    "first_name": "Carlos",
    "last_name": "Hyde",
    "position": "RB",
    "age": 29,
    "team": "HOU",
    "player_id": "2257",
    "my_id": 2257,
    "gp": 14,
    "gs": 7,
    "pts_ppr": 98.4,
    "rec": 10,
    "rec_yd": 33,
    "rec_td": 0,
    "rec_tgt": 17,
    "rush_att": 172,
    "rush_td": 5,
    "rush_yd": 571,
    "td": 5,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Paul Richardson": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 10,
    "full_name": "paulrichardson",
    "first_name": "Paul",
    "last_name": "Richardson",
    "position": "WR",
    "age": 27,
    "team": "WAS",
    "player_id": "2279",
    "my_id": 2279,
    "gp": 7,
    "gs": 4,
    "pts_ppr": 59.1,
    "rec": 20,
    "rec_yd": 262,
    "rec_td": 2,
    "rec_tgt": 35,
    "rush_att": 2,
    "rush_td": 0,
    "rush_yd": 9,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Dontrelle Inman": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 15,
    "full_name": "dontrelleinman",
    "first_name": "Dontrelle",
    "last_name": "Inman",
    "position": "WR",
    "age": 30,
    "team": "LAC",
    "player_id": "2291",
    "my_id": 2291,
    "gp": 9,
    "gs": 4,
    "pts_ppr": 76.4,
    "rec": 28,
    "rec_yd": 304,
    "rec_td": 3,
    "rec_tgt": 39,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jerome Cunningham": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 83,
    "full_name": "jeromecunningham",
    "first_name": "Jerome",
    "last_name": "Cunningham",
    "position": "TE",
    "age": 28,
    "team": "WAS",
    "player_id": "2304",
    "my_id": 2304,
    "gp": 1,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jameis Winston": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 3,
    "full_name": "jameiswinston",
    "first_name": "Jameis",
    "last_name": "Winston",
    "position": "QB",
    "age": 25,
    "team": "TB",
    "player_id": "2306",
    "my_id": 2306,
    "gp": 11,
    "gs": 9,
    "pts_ppr": 195.78,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 49,
    "rush_td": 1,
    "rush_yd": 281,
    "td": 1,
    "pass_td": 19,
    "pass_int": 14,
    "pass_cmp": 244,
    "pass_att": 378,
    "pass_yd": 2992,
    "pass_inc": 134,
    "fum_lost": 3
  },
  "Marcus Mariota": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 8,
    "full_name": "marcusmariota",
    "first_name": "Marcus",
    "last_name": "Mariota",
    "position": "QB",
    "age": 25,
    "team": "TEN",
    "player_id": "2307",
    "my_id": 2307,
    "gp": 14,
    "gs": 13,
    "pts_ppr": 175.92,
    "rec": 1,
    "rec_yd": 21,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 64,
    "rush_td": 2,
    "rush_yd": 357,
    "td": 2,
    "pass_td": 11,
    "pass_int": 8,
    "pass_cmp": 228,
    "pass_att": 331,
    "pass_yd": 2528,
    "pass_inc": 103,
    "fum_lost": 2
  },
  "Amari Cooper": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 19,
    "full_name": "amaricooper",
    "first_name": "Amari",
    "last_name": "Cooper",
    "position": "WR",
    "age": 25,
    "team": "DAL",
    "player_id": "2309",
    "my_id": 2309,
    "gp": 15,
    "gs": 15,
    "pts_ppr": 215.4,
    "rec": 75,
    "rec_yd": 1004,
    "rec_td": 7,
    "rec_tgt": 107,
    "rush_att": 2,
    "rush_td": 0,
    "rush_yd": 20,
    "td": 7,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 2
  },
  "Kevin White": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 18,
    "full_name": "kevinwhite",
    "first_name": "Kevin",
    "last_name": "White",
    "position": "WR",
    "age": 26,
    "team": null,
    "player_id": "2312",
    "my_id": 2312,
    "gp": 9,
    "gs": 0,
    "pts_ppr": 13.2,
    "rec": 4,
    "rec_yd": 92,
    "rec_td": 0,
    "rec_tgt": 8,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Todd Gurley": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 30,
    "full_name": "toddgurley",
    "first_name": "Todd",
    "last_name": "Gurley",
    "position": "RB",
    "age": 25,
    "team": "LAR",
    "player_id": "2315",
    "my_id": 2315,
    "gp": 14,
    "gs": 14,
    "pts_ppr": 372.1,
    "rec": 59,
    "rec_yd": 580,
    "rec_td": 4,
    "rec_tgt": 81,
    "rush_att": 256,
    "rush_td": 17,
    "rush_yd": 1251,
    "td": 21,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Devante Parker": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 11,
    "full_name": "devanteparker",
    "first_name": "Devante",
    "last_name": "Parker",
    "position": "WR",
    "age": 26,
    "team": "MIA",
    "player_id": "2319",
    "my_id": 2319,
    "gp": 11,
    "gs": 7,
    "pts_ppr": 60.9,
    "rec": 24,
    "rec_yd": 309,
    "rec_td": 1,
    "rec_tgt": 47,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Melvin Gordon": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 25,
    "full_name": "melvingordon",
    "first_name": "Melvin",
    "last_name": "Gordon",
    "position": "RB",
    "age": 26,
    "team": "LAC",
    "player_id": "2320",
    "my_id": 2320,
    "gp": 12,
    "gs": 12,
    "pts_ppr": 275.5,
    "rec": 50,
    "rec_yd": 490,
    "rec_td": 4,
    "rec_tgt": 66,
    "rush_att": 175,
    "rush_td": 10,
    "rush_yd": 885,
    "td": 14,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Nelson Agholor": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 13,
    "full_name": "nelsonagholor",
    "first_name": "Nelson",
    "last_name": "Agholor",
    "position": "WR",
    "age": 26,
    "team": "PHI",
    "player_id": "2325",
    "my_id": 2325,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 165.4,
    "rec": 64,
    "rec_yd": 736,
    "rec_td": 4,
    "rec_tgt": 97,
    "rush_att": 3,
    "rush_td": 0,
    "rush_yd": 32,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 1,
    "pass_att": 1,
    "pass_yd": 15,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Breshad Perriman": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 19,
    "full_name": "breshadperriman",
    "first_name": "Breshad",
    "last_name": "Perriman",
    "position": "WR",
    "age": 26,
    "team": "TB",
    "player_id": "2331",
    "my_id": 2331,
    "gp": 10,
    "gs": 2,
    "pts_ppr": 62.2,
    "rec": 16,
    "rec_yd": 340,
    "rec_td": 2,
    "rec_tgt": 25,
    "rush_att": 4,
    "rush_td": 0,
    "rush_yd": 2,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Phillip Dorsett": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 13,
    "full_name": "phillipdorsett",
    "first_name": "Phillip",
    "last_name": "Dorsett",
    "position": "WR",
    "age": 26,
    "team": "NE",
    "player_id": "2334",
    "my_id": 2334,
    "gp": 16,
    "gs": 2,
    "pts_ppr": 81.9,
    "rec": 32,
    "rec_yd": 290,
    "rec_td": 3,
    "rec_tgt": 42,
    "rush_att": 4,
    "rush_td": 0,
    "rush_yd": 29,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "TJ Yeldon": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 22,
    "full_name": "tjyeldon",
    "first_name": "TJ",
    "last_name": "Yeldon",
    "position": "RB",
    "age": 26,
    "team": "BUF",
    "player_id": "2341",
    "my_id": 2341,
    "gp": 14,
    "gs": 5,
    "pts_ppr": 173.1,
    "rec": 55,
    "rec_yd": 487,
    "rec_td": 4,
    "rec_tgt": 77,
    "rush_att": 104,
    "rush_td": 1,
    "rush_yd": 414,
    "td": 5,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Devin Funchess": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 17,
    "full_name": "devinfunchess",
    "first_name": "Devin",
    "last_name": "Funchess",
    "position": "WR",
    "age": 25,
    "team": "IND",
    "player_id": "2346",
    "my_id": 2346,
    "gp": 14,
    "gs": 12,
    "pts_ppr": 122.9,
    "rec": 44,
    "rec_yd": 549,
    "rec_td": 4,
    "rec_tgt": 79,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Ameer Abdullah": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 31,
    "full_name": "ameerabdullah",
    "first_name": "Ameer",
    "last_name": "Abdullah",
    "position": "RB",
    "age": 26,
    "team": "MIN",
    "player_id": "2359",
    "my_id": 2359,
    "gp": 10,
    "gs": 0,
    "pts_ppr": 3.9,
    "rec": 3,
    "rec_yd": 28,
    "rec_td": 0,
    "rec_tgt": 4,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 1,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Maxx Williams": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 87,
    "full_name": "maxxwilliams",
    "first_name": "Maxx",
    "last_name": "Williams",
    "position": "TE",
    "age": 25,
    "team": "ARI",
    "player_id": "2360",
    "my_id": 2360,
    "gp": 13,
    "gs": 6,
    "pts_ppr": 37.1,
    "rec": 16,
    "rec_yd": 143,
    "rec_td": 1,
    "rec_tgt": 17,
    "rush_att": 3,
    "rush_td": 0,
    "rush_yd": 8,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Clive Walford": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 87,
    "full_name": "clivewalford",
    "first_name": "Clive",
    "last_name": "Walford",
    "position": "TE",
    "age": 24,
    "team": null,
    "player_id": "2373",
    "my_id": 2373,
    "gp": 1,
    "gs": 1,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Tyler Lockett": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 16,
    "full_name": "tylerlockett",
    "first_name": "Tyler",
    "last_name": "Lockett",
    "position": "WR",
    "age": 26,
    "team": "SEA",
    "player_id": "2374",
    "my_id": 2374,
    "gp": 16,
    "gs": 14,
    "pts_ppr": 222.4,
    "rec": 57,
    "rec_yd": 965,
    "rec_td": 10,
    "rec_tgt": 71,
    "rush_att": 13,
    "rush_td": 0,
    "rush_yd": 69,
    "td": 10,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Tevin Coleman": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 26,
    "full_name": "tevincoleman",
    "first_name": "Tevin",
    "last_name": "Coleman",
    "position": "RB",
    "age": 26,
    "team": "SF",
    "player_id": "2378",
    "my_id": 2378,
    "gp": 16,
    "gs": 14,
    "pts_ppr": 193.6,
    "rec": 32,
    "rec_yd": 276,
    "rec_td": 5,
    "rec_tgt": 44,
    "rush_att": 167,
    "rush_td": 4,
    "rush_yd": 800,
    "td": 9,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Chris Conley": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 18,
    "full_name": "chrisconley",
    "first_name": "Chris",
    "last_name": "Conley",
    "position": "WR",
    "age": 26,
    "team": "JAX",
    "player_id": "2381",
    "my_id": 2381,
    "gp": 16,
    "gs": 13,
    "pts_ppr": 91.4,
    "rec": 32,
    "rec_yd": 334,
    "rec_td": 5,
    "rec_tgt": 52,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 5,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 2
  },
  "Duke Johnson": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 25,
    "full_name": "dukejohnson",
    "first_name": "Duke",
    "last_name": "Johnson",
    "position": "RB",
    "age": 26,
    "team": "HOU",
    "player_id": "2382",
    "my_id": 2382,
    "gp": 16,
    "gs": 2,
    "pts_ppr": 132,
    "rec": 47,
    "rec_yd": 429,
    "rec_td": 3,
    "rec_tgt": 62,
    "rush_att": 40,
    "rush_td": 0,
    "rush_yd": 201,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Tyler Kroft": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 81,
    "full_name": "tylerkroft",
    "first_name": "Tyler",
    "last_name": "Kroft",
    "position": "TE",
    "age": 27,
    "team": "BUF",
    "player_id": "2390",
    "my_id": 2390,
    "gp": 5,
    "gs": 2,
    "pts_ppr": 7.6,
    "rec": 4,
    "rec_yd": 36,
    "rec_td": 0,
    "rec_tgt": 6,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "David Johnson": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 31,
    "full_name": "davidjohnson",
    "first_name": "David",
    "last_name": "Johnson",
    "position": "RB",
    "age": 27,
    "team": "ARI",
    "player_id": "2391",
    "my_id": 2391,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 246.6,
    "rec": 50,
    "rec_yd": 446,
    "rec_td": 3,
    "rec_tgt": 76,
    "rush_att": 258,
    "rush_td": 7,
    "rush_yd": 940,
    "td": 10,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 2
  },
  "Sammie Coates": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 13,
    "full_name": "sammiecoates",
    "first_name": "Sammie",
    "last_name": "Coates",
    "position": "WR",
    "age": 26,
    "team": null,
    "player_id": "2392",
    "my_id": 2392,
    "gp": 12,
    "gs": 0,
    "pts_ppr": 2.2,
    "rec": 1,
    "rec_yd": 12,
    "rec_td": 0,
    "rec_tgt": 2,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Sean Mannion": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 4,
    "full_name": "seanmannion",
    "first_name": "Sean",
    "last_name": "Mannion",
    "position": "QB",
    "age": 27,
    "team": "MIN",
    "player_id": "2394",
    "my_id": 2394,
    "gp": 3,
    "gs": 0,
    "pts_ppr": 0.02,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 7,
    "rush_td": 0,
    "rush_yd": -9,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 2,
    "pass_att": 3,
    "pass_yd": 23,
    "pass_inc": 1,
    "fum_lost": 0
  },
  "Jeff Heuerman": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 82,
    "full_name": "jeffheuerman",
    "first_name": "Jeff",
    "last_name": "Heuerman",
    "position": "TE",
    "age": 24,
    "team": "DEN",
    "player_id": "2397",
    "my_id": 2397,
    "gp": 11,
    "gs": 10,
    "pts_ppr": 71.1,
    "rec": 31,
    "rec_yd": 281,
    "rec_td": 2,
    "rec_tgt": 48,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Ty Montgomery": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 88,
    "full_name": "tymontgomery",
    "first_name": "Ty",
    "last_name": "Montgomery",
    "position": "RB",
    "age": 26,
    "team": "NYJ",
    "player_id": "2399",
    "my_id": 2399,
    "gp": 13,
    "gs": 0,
    "pts_ppr": 71.3,
    "rec": 25,
    "rec_yd": 235,
    "rec_td": 0,
    "rec_tgt": 40,
    "rush_att": 41,
    "rush_td": 1,
    "rush_yd": 188,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Jamison Crowder": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 82,
    "full_name": "jamisoncrowder",
    "first_name": "Jamison",
    "last_name": "Crowder",
    "position": "WR",
    "age": 26,
    "team": "NYJ",
    "player_id": "2410",
    "my_id": 2410,
    "gp": 9,
    "gs": 7,
    "pts_ppr": 82.8,
    "rec": 29,
    "rec_yd": 388,
    "rec_td": 2,
    "rec_tgt": 50,
    "rush_att": 4,
    "rush_td": 0,
    "rush_yd": 30,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jeremy Langford": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 43,
    "full_name": "jeremylangford",
    "first_name": "Jeremy",
    "last_name": "Langford",
    "position": "RB",
    "age": 27,
    "team": null,
    "player_id": "2411",
    "my_id": 2411,
    "gp": 1,
    "gs": 0,
    "pts_ppr": 2.5,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 9,
    "rush_td": 0,
    "rush_yd": 25,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Justin Hardy": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 14,
    "full_name": "justinhardy",
    "first_name": "Justin",
    "last_name": "Hardy",
    "position": "WR",
    "age": 27,
    "team": "ATL",
    "player_id": "2412",
    "my_id": 2412,
    "gp": 16,
    "gs": 0,
    "pts_ppr": 39.3,
    "rec": 14,
    "rec_yd": 133,
    "rec_td": 2,
    "rec_tgt": 22,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Blake Bell": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 81,
    "full_name": "blakebell",
    "first_name": "Blake",
    "last_name": "Bell",
    "position": "TE",
    "age": 28,
    "team": "KC",
    "player_id": "2422",
    "my_id": 2422,
    "gp": 10,
    "gs": 4,
    "pts_ppr": 14.7,
    "rec": 8,
    "rec_yd": 67,
    "rec_td": 0,
    "rec_tgt": 11,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Javorius Allen": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 37,
    "full_name": "javoriusallen",
    "first_name": "Javorius",
    "last_name": "Allen",
    "position": "RB",
    "age": 28,
    "team": "NYG",
    "player_id": "2430",
    "my_id": 2430,
    "gp": 14,
    "gs": 0,
    "pts_ppr": 93.6,
    "rec": 35,
    "rec_yd": 196,
    "rec_td": 2,
    "rec_tgt": 43,
    "rush_att": 41,
    "rush_td": 3,
    "rush_yd": 110,
    "td": 5,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Mike Davis": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 25,
    "full_name": "mikedavis",
    "first_name": "Mike",
    "last_name": "Davis",
    "position": "RB",
    "age": 26,
    "team": "CHI",
    "player_id": "2431",
    "my_id": 2431,
    "gp": 15,
    "gs": 2,
    "pts_ppr": 136.8,
    "rec": 34,
    "rec_yd": 214,
    "rec_td": 1,
    "rec_tgt": 42,
    "rush_att": 112,
    "rush_td": 4,
    "rush_yd": 514,
    "td": 5,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Rashad Greene": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 13,
    "full_name": "rashadgreene",
    "first_name": "Rashad",
    "last_name": "Greene",
    "position": "WR",
    "age": 27,
    "team": null,
    "player_id": "2442",
    "my_id": 2442,
    "gp": 8,
    "gs": 1,
    "pts_ppr": 10,
    "rec": 6,
    "rec_yd": 60,
    "rec_td": 0,
    "rec_tgt": 8,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "MyCole Pruitt": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 85,
    "full_name": "mycolepruitt",
    "first_name": "MyCole",
    "last_name": "Pruitt",
    "position": "TE",
    "age": 27,
    "team": "TEN",
    "player_id": "2446",
    "my_id": 2446,
    "gp": 15,
    "gs": 1,
    "pts_ppr": 25.2,
    "rec": 9,
    "rec_yd": 102,
    "rec_td": 1,
    "rec_tgt": 11,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Stefon Diggs": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 14,
    "full_name": "stefondiggs",
    "first_name": "Stefon",
    "last_name": "Diggs",
    "position": "WR",
    "age": 25,
    "team": "MIN",
    "player_id": "2449",
    "my_id": 2449,
    "gp": 15,
    "gs": 14,
    "pts_ppr": 266.3,
    "rec": 102,
    "rec_yd": 1021,
    "rec_td": 9,
    "rec_tgt": 150,
    "rush_att": 10,
    "rush_td": 0,
    "rush_yd": 62,
    "td": 9,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jay Ajayi": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 26,
    "full_name": "jayajayi",
    "first_name": "Jay",
    "last_name": "Ajayi",
    "position": "RB",
    "age": 26,
    "team": null,
    "player_id": "2452",
    "my_id": 2452,
    "gp": 4,
    "gs": 3,
    "pts_ppr": 43.4,
    "rec": 5,
    "rec_yd": 20,
    "rec_td": 0,
    "rec_tgt": 6,
    "rush_att": 45,
    "rush_td": 3,
    "rush_yd": 184,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Tony Lippett": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 39,
    "full_name": "tonylippett",
    "first_name": "Tony",
    "last_name": "Lippett",
    "position": "WR",
    "age": 27,
    "team": null,
    "player_id": "2459",
    "my_id": 2459,
    "gp": 3,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "CJ Uzomah": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 87,
    "full_name": "cjuzomah",
    "first_name": "CJ",
    "last_name": "Uzomah",
    "position": "TE",
    "age": 26,
    "team": "CIN",
    "player_id": "2460",
    "my_id": 2460,
    "gp": 16,
    "gs": 15,
    "pts_ppr": 104.9,
    "rec": 43,
    "rec_yd": 439,
    "rec_td": 3,
    "rec_tgt": 64,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "JJ Nelson": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 15,
    "full_name": "jjnelson",
    "first_name": "JJ",
    "last_name": "Nelson",
    "position": "WR",
    "age": 27,
    "team": null,
    "player_id": "2462",
    "my_id": 2462,
    "gp": 14,
    "gs": 2,
    "pts_ppr": 13.4,
    "rec": 7,
    "rec_yd": 64,
    "rec_td": 0,
    "rec_tgt": 19,
    "rush_att": 4,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jesse James": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 83,
    "full_name": "jessejames",
    "first_name": "Jesse",
    "last_name": "James",
    "position": "TE",
    "age": 25,
    "team": "DET",
    "player_id": "2463",
    "my_id": 2463,
    "gp": 16,
    "gs": 7,
    "pts_ppr": 84.3,
    "rec": 30,
    "rec_yd": 423,
    "rec_td": 2,
    "rec_tgt": 39,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Nick Boyle": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 86,
    "full_name": "nickboyle",
    "first_name": "Nick",
    "last_name": "Boyle",
    "position": "TE",
    "age": 26,
    "team": "BAL",
    "player_id": "2474",
    "my_id": 2474,
    "gp": 16,
    "gs": 13,
    "pts_ppr": 44.3,
    "rec": 23,
    "rec_yd": 213,
    "rec_td": 0,
    "rec_tgt": 37,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "James O'Shaughnessy": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 80,
    "full_name": "jamesoshaughnessy",
    "first_name": "James",
    "last_name": "O'Shaughnessy",
    "position": "TE",
    "age": 27,
    "team": "JAX",
    "player_id": "2476",
    "my_id": 2476,
    "gp": 14,
    "gs": 9,
    "pts_ppr": 45.4,
    "rec": 24,
    "rec_yd": 214,
    "rec_td": 0,
    "rec_tgt": 38,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Cameron Artis-Payne": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 34,
    "full_name": "cameronartispayne",
    "first_name": "Cameron",
    "last_name": "Artis-Payne",
    "position": "RB",
    "age": 27,
    "team": null,
    "player_id": "2477",
    "my_id": 2477,
    "gp": 9,
    "gs": 0,
    "pts_ppr": 17.4,
    "rec": 3,
    "rec_yd": 15,
    "rec_td": 0,
    "rec_tgt": 4,
    "rush_att": 19,
    "rush_td": 1,
    "rush_yd": 69,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Kaelin Clay": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 15,
    "full_name": "kaelinclay",
    "first_name": "Kaelin",
    "last_name": "Clay",
    "position": "WR",
    "age": 27,
    "team": null,
    "player_id": "2485",
    "my_id": 2485,
    "gp": 2,
    "gs": 0,
    "pts_ppr": -2,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Geremy Davis": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 11,
    "full_name": "geremydavis",
    "first_name": "Geremy",
    "last_name": "Davis",
    "position": "WR",
    "age": 27,
    "team": "LAC",
    "player_id": "2487",
    "my_id": 2487,
    "gp": 14,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Nick O'Leary": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 83,
    "full_name": "nickoleary",
    "first_name": "Nick",
    "last_name": "O'Leary",
    "position": "TE",
    "age": 27,
    "team": "MIA",
    "player_id": "2495",
    "my_id": 2495,
    "gp": 10,
    "gs": 6,
    "pts_ppr": 22.6,
    "rec": 8,
    "rec_yd": 86,
    "rec_td": 1,
    "rec_tgt": 10,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "AJ Derby": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 85,
    "full_name": "ajderby",
    "first_name": "AJ",
    "last_name": "Derby",
    "position": "TE",
    "age": 28,
    "team": null,
    "player_id": "2503",
    "my_id": 2503,
    "gp": 4,
    "gs": 0,
    "pts_ppr": 13.8,
    "rec": 3,
    "rec_yd": 48,
    "rec_td": 1,
    "rec_tgt": 5,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Darren Waller": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 83,
    "full_name": "darrenwaller",
    "first_name": "Darren",
    "last_name": "Waller",
    "position": "TE",
    "age": 27,
    "team": "OAK",
    "player_id": "2505",
    "my_id": 2505,
    "gp": 4,
    "gs": 0,
    "pts_ppr": 15.6,
    "rec": 6,
    "rec_yd": 75,
    "rec_td": 0,
    "rec_tgt": 6,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 21,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Neal Sterling": {
    "fantasy_positions": [
      "WR",
      "TE"
    ],
    "year": 2018,
    "number": 85,
    "full_name": "nealsterling",
    "first_name": "Neal",
    "last_name": "Sterling",
    "position": "TE",
    "age": 27,
    "team": null,
    "player_id": "2519",
    "my_id": 2519,
    "gp": 5,
    "gs": 4,
    "pts_ppr": 10.7,
    "rec": 6,
    "rec_yd": 47,
    "rec_td": 0,
    "rec_tgt": 8,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Ben Koyack": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 83,
    "full_name": "benkoyack",
    "first_name": "Ben",
    "last_name": "Koyack",
    "position": "TE",
    "age": 26,
    "team": "JAX",
    "player_id": "2528",
    "my_id": 2528,
    "gp": 7,
    "gs": 2,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Marcus Murphy": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 22,
    "full_name": "marcusmurphy",
    "first_name": "Marcus",
    "last_name": "Murphy",
    "position": "RB",
    "age": 28,
    "team": null,
    "player_id": "2529",
    "my_id": 2529,
    "gp": 11,
    "gs": 1,
    "pts_ppr": 38.6,
    "rec": 11,
    "rec_yd": 26,
    "rec_td": 0,
    "rec_tgt": 19,
    "rush_att": 52,
    "rush_td": 0,
    "rush_yd": 250,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Geoff Swaim": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 87,
    "full_name": "geoffswaim",
    "first_name": "Geoff",
    "last_name": "Swaim",
    "position": "TE",
    "age": 26,
    "team": "JAX",
    "player_id": "2545",
    "my_id": 2545,
    "gp": 9,
    "gs": 9,
    "pts_ppr": 56.2,
    "rec": 26,
    "rec_yd": 242,
    "rec_td": 1,
    "rec_tgt": 32,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Zach Zenner": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 34,
    "full_name": "zachzenner",
    "first_name": "Zach",
    "last_name": "Zenner",
    "position": "RB",
    "age": 28,
    "team": null,
    "player_id": "2560",
    "my_id": 2560,
    "gp": 8,
    "gs": 1,
    "pts_ppr": 57.1,
    "rec": 7,
    "rec_yd": 56,
    "rec_td": 0,
    "rec_tgt": 10,
    "rush_att": 55,
    "rush_td": 3,
    "rush_yd": 265,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Tyrell Williams": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 16,
    "full_name": "tyrellwilliams",
    "first_name": "Tyrell",
    "last_name": "Williams",
    "position": "WR",
    "age": 27,
    "team": "OAK",
    "player_id": "2583",
    "my_id": 2583,
    "gp": 16,
    "gs": 10,
    "pts_ppr": 137.8,
    "rec": 41,
    "rec_yd": 653,
    "rec_td": 5,
    "rec_tgt": 65,
    "rush_att": 2,
    "rush_td": 0,
    "rush_yd": 15,
    "td": 5,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Thomas Rawls": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 34,
    "full_name": "thomasrawls",
    "first_name": "Thomas",
    "last_name": "Rawls",
    "position": "RB",
    "age": 26,
    "team": null,
    "player_id": "2585",
    "my_id": 2585,
    "gp": 1,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Malcolm Brown": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 34,
    "full_name": "malcolmbrown",
    "first_name": "Malcolm",
    "last_name": "Brown",
    "position": "RB",
    "age": 26,
    "team": "LAR",
    "player_id": "2588",
    "my_id": 2588,
    "gp": 12,
    "gs": 0,
    "pts_ppr": 39.4,
    "rec": 5,
    "rec_yd": 52,
    "rec_td": 1,
    "rec_tgt": 7,
    "rush_att": 43,
    "rush_td": 0,
    "rush_yd": 212,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Darius Jennings": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 15,
    "full_name": "dariusjennings",
    "first_name": "Darius",
    "last_name": "Jennings",
    "position": "WR",
    "age": 27,
    "team": "TEN",
    "player_id": "2602",
    "my_id": 2602,
    "gp": 16,
    "gs": 0,
    "pts_ppr": 22.14,
    "rec": 11,
    "rec_yd": 101,
    "rec_td": 0,
    "rec_tgt": 15,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 2,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 1,
    "pass_att": 1,
    "pass_yd": 21,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Brian Parker": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 89,
    "full_name": "brianparker",
    "first_name": "Brian",
    "last_name": "Parker",
    "position": "TE",
    "age": 27,
    "team": null,
    "player_id": "2653",
    "my_id": 2653,
    "gp": 12,
    "gs": 1,
    "pts_ppr": 8.3,
    "rec": 5,
    "rec_yd": 33,
    "rec_td": 0,
    "rec_tgt": 10,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Damiere Byrd": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 14,
    "full_name": "damierebyrd",
    "first_name": "Damiere",
    "last_name": "Byrd",
    "position": "WR",
    "age": 26,
    "team": "ARI",
    "player_id": "2673",
    "my_id": 2673,
    "gp": 8,
    "gs": 0,
    "pts_ppr": 1.8,
    "rec": 1,
    "rec_yd": 8,
    "rec_td": 0,
    "rec_tgt": 2,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Khari Lee": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 88,
    "full_name": "kharilee",
    "first_name": "Khari",
    "last_name": "Lee",
    "position": "TE",
    "age": 27,
    "team": null,
    "player_id": "2686",
    "my_id": 2686,
    "gp": 2,
    "gs": 0,
    "pts_ppr": 1.5,
    "rec": 1,
    "rec_yd": 5,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Cameron Meredith": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 19,
    "full_name": "cameronmeredith",
    "first_name": "Cameron",
    "last_name": "Meredith",
    "position": "WR",
    "age": 27,
    "team": null,
    "player_id": "2699",
    "my_id": 2699,
    "gp": 6,
    "gs": 1,
    "pts_ppr": 24.4,
    "rec": 9,
    "rec_yd": 114,
    "rec_td": 1,
    "rec_tgt": 10,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Taylor Heinicke": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 6,
    "full_name": "taylorheinicke",
    "first_name": "Taylor",
    "last_name": "Heinicke",
    "position": "QB",
    "age": 26,
    "team": null,
    "player_id": "2711",
    "my_id": 2711,
    "gp": 6,
    "gs": 1,
    "pts_ppr": 13.9,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 5,
    "rush_td": 0,
    "rush_yd": 31,
    "td": 0,
    "pass_td": 1,
    "pass_int": 3,
    "pass_cmp": 35,
    "pass_att": 57,
    "pass_yd": 320,
    "pass_inc": 20,
    "fum_lost": 0
  },
  "Gabe Holmes": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 47,
    "full_name": "gabeholmes",
    "first_name": "Gabe",
    "last_name": "Holmes",
    "position": "TE",
    "age": 28,
    "team": null,
    "player_id": "2714",
    "my_id": 2714,
    "gp": 8,
    "gs": 4,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Corey Grant": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 30,
    "full_name": "coreygrant",
    "first_name": "Corey",
    "last_name": "Grant",
    "position": "RB",
    "age": 27,
    "team": null,
    "player_id": "2729",
    "my_id": 2729,
    "gp": 5,
    "gs": 1,
    "pts_ppr": 19.7,
    "rec": 9,
    "rec_yd": 67,
    "rec_td": 0,
    "rec_tgt": 12,
    "rush_att": 13,
    "rush_td": 0,
    "rush_yd": 40,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Raheem Mostert": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 31,
    "full_name": "raheemmostert",
    "first_name": "Raheem",
    "last_name": "Mostert",
    "position": "RB",
    "age": 27,
    "team": "SF",
    "player_id": "2749",
    "my_id": 2749,
    "gp": 9,
    "gs": 0,
    "pts_ppr": 38.6,
    "rec": 6,
    "rec_yd": 25,
    "rec_td": 0,
    "rec_tgt": 7,
    "rush_att": 34,
    "rush_td": 1,
    "rush_yd": 261,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Deandre Carter": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 14,
    "full_name": "deandrecarter",
    "first_name": "Deandre",
    "last_name": "Carter",
    "position": "WR",
    "age": 26,
    "team": "HOU",
    "player_id": "2750",
    "my_id": 2750,
    "gp": 14,
    "gs": 4,
    "pts_ppr": 42.3,
    "rec": 22,
    "rec_yd": 216,
    "rec_td": 0,
    "rec_tgt": 25,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 7,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Daniel Brown": {
    "fantasy_positions": [
      "WR",
      "TE"
    ],
    "year": 2018,
    "number": 87,
    "full_name": "danielbrown",
    "first_name": "Daniel",
    "last_name": "Brown",
    "position": "TE",
    "age": 27,
    "team": "NYJ",
    "player_id": "2751",
    "my_id": 2751,
    "gp": 14,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Eric Tomlinson": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 83,
    "full_name": "erictomlinson",
    "first_name": "Eric",
    "last_name": "Tomlinson",
    "position": "TE",
    "age": 27,
    "team": "NE",
    "player_id": "2755",
    "my_id": 2755,
    "gp": 15,
    "gs": 12,
    "pts_ppr": 15.2,
    "rec": 8,
    "rec_yd": 72,
    "rec_td": 0,
    "rec_tgt": 14,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Bradley Marquez": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 12,
    "full_name": "bradleymarquez",
    "first_name": "Bradley",
    "last_name": "Marquez",
    "position": "WR",
    "age": 26,
    "team": null,
    "player_id": "2803",
    "my_id": 2803,
    "gp": 1,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jake Kumerow": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 16,
    "full_name": "jakekumerow",
    "first_name": "Jake",
    "last_name": "Kumerow",
    "position": "WR",
    "age": 27,
    "team": "GB",
    "player_id": "2821",
    "my_id": 2821,
    "gp": 5,
    "gs": 2,
    "pts_ppr": 24.3,
    "rec": 8,
    "rec_yd": 103,
    "rec_td": 1,
    "rec_tgt": 11,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Adam Humphries": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 10,
    "full_name": "adamhumphries",
    "first_name": "Adam",
    "last_name": "Humphries",
    "position": "WR",
    "age": 26,
    "team": "TEN",
    "player_id": "2822",
    "my_id": 2822,
    "gp": 16,
    "gs": 10,
    "pts_ppr": 188.7,
    "rec": 76,
    "rec_yd": 816,
    "rec_td": 5,
    "rec_tgt": 105,
    "rush_att": 2,
    "rush_td": 0,
    "rush_yd": 11,
    "td": 5,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Rod Smith": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 45,
    "full_name": "rodsmith",
    "first_name": "Rod",
    "last_name": "Smith",
    "position": "RB",
    "age": 27,
    "team": "TEN",
    "player_id": "2892",
    "my_id": 2892,
    "gp": 16,
    "gs": 1,
    "pts_ppr": 33.7,
    "rec": 9,
    "rec_yd": 60,
    "rec_td": 0,
    "rec_tgt": 12,
    "rush_att": 44,
    "rush_td": 1,
    "rush_yd": 127,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Matt LaCosse": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 83,
    "full_name": "mattlacosse",
    "first_name": "Matt",
    "last_name": "LaCosse",
    "position": "TE",
    "age": 27,
    "team": "NE",
    "player_id": "2944",
    "my_id": 2944,
    "gp": 15,
    "gs": 5,
    "pts_ppr": 55,
    "rec": 24,
    "rec_yd": 250,
    "rec_td": 1,
    "rec_tgt": 37,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Eli Rogers": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 17,
    "full_name": "elirogers",
    "first_name": "Eli",
    "last_name": "Rogers",
    "position": "WR",
    "age": 26,
    "team": null,
    "player_id": "2980",
    "my_id": 2980,
    "gp": 3,
    "gs": 3,
    "pts_ppr": 21.5,
    "rec": 12,
    "rec_yd": 79,
    "rec_td": 0,
    "rec_tgt": 14,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": -4,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Matt Lengel": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 89,
    "full_name": "mattlengel",
    "first_name": "Matt",
    "last_name": "Lengel",
    "position": "TE",
    "age": 28,
    "team": null,
    "player_id": "3036",
    "my_id": 3036,
    "gp": 6,
    "gs": 1,
    "pts_ppr": 10.7,
    "rec": 3,
    "rec_yd": 17,
    "rec_td": 1,
    "rec_tgt": 8,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Chris Manhertz": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 82,
    "full_name": "chrismanhertz",
    "first_name": "Chris",
    "last_name": "Manhertz",
    "position": "TE",
    "age": 27,
    "team": "CAR",
    "player_id": "3048",
    "my_id": 3048,
    "gp": 16,
    "gs": 0,
    "pts_ppr": 13.2,
    "rec": 2,
    "rec_yd": 52,
    "rec_td": 1,
    "rec_tgt": 5,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Laquon Treadwell": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 11,
    "full_name": "laquontreadwell",
    "first_name": "Laquon",
    "last_name": "Treadwell",
    "position": "WR",
    "age": 24,
    "team": "MIN",
    "player_id": "3155",
    "my_id": 3155,
    "gp": 15,
    "gs": 7,
    "pts_ppr": 71.2,
    "rec": 35,
    "rec_yd": 302,
    "rec_td": 1,
    "rec_tgt": 53,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Will Fuller": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 15,
    "full_name": "willfuller",
    "first_name": "Will",
    "last_name": "Fuller",
    "position": "WR",
    "age": 25,
    "team": "HOU",
    "player_id": "3157",
    "my_id": 3157,
    "gp": 7,
    "gs": 7,
    "pts_ppr": 106.3,
    "rec": 32,
    "rec_yd": 503,
    "rec_td": 4,
    "rec_tgt": 45,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Carson Wentz": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 11,
    "full_name": "carsonwentz",
    "first_name": "Carson",
    "last_name": "Wentz",
    "position": "QB",
    "age": 26,
    "team": "PHI",
    "player_id": "3161",
    "my_id": 3161,
    "gp": 11,
    "gs": 11,
    "pts_ppr": 193.66,
    "rec": 1,
    "rec_yd": 4,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 34,
    "rush_td": 0,
    "rush_yd": 93,
    "td": 0,
    "pass_td": 21,
    "pass_int": 7,
    "pass_cmp": 279,
    "pass_att": 401,
    "pass_yd": 3074,
    "pass_inc": 122,
    "fum_lost": 6
  },
  "Jared Goff": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 16,
    "full_name": "jaredgoff",
    "first_name": "Jared",
    "last_name": "Goff",
    "position": "QB",
    "age": 25,
    "team": "LAR",
    "player_id": "3163",
    "my_id": 3163,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 310.32,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 43,
    "rush_td": 2,
    "rush_yd": 108,
    "td": 2,
    "pass_td": 32,
    "pass_int": 12,
    "pass_cmp": 364,
    "pass_att": 561,
    "pass_yd": 4688,
    "pass_inc": 197,
    "fum_lost": 5
  },
  "Ezekiel Elliott": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 21,
    "full_name": "ezekielelliott",
    "first_name": "Ezekiel",
    "last_name": "Elliott",
    "position": "RB",
    "age": 24,
    "team": "DAL",
    "player_id": "3164",
    "my_id": 3164,
    "gp": 15,
    "gs": 15,
    "pts_ppr": 329.2,
    "rec": 77,
    "rec_yd": 567,
    "rec_td": 3,
    "rec_tgt": 95,
    "rush_att": 304,
    "rush_td": 6,
    "rush_yd": 1435,
    "td": 9,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Corey Coleman": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 19,
    "full_name": "coreycoleman",
    "first_name": "Corey",
    "last_name": "Coleman",
    "position": "WR",
    "age": 25,
    "team": "NYG",
    "player_id": "3177",
    "my_id": 3177,
    "gp": 8,
    "gs": 1,
    "pts_ppr": 12.6,
    "rec": 5,
    "rec_yd": 71,
    "rec_td": 0,
    "rec_tgt": 8,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 5,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Josh Doctson": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 13,
    "full_name": "joshdoctson",
    "first_name": "Josh",
    "last_name": "Doctson",
    "position": "WR",
    "age": 26,
    "team": "MIN",
    "player_id": "3178",
    "my_id": 3178,
    "gp": 15,
    "gs": 12,
    "pts_ppr": 109.2,
    "rec": 44,
    "rec_yd": 532,
    "rec_td": 2,
    "rec_tgt": 79,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Derrick Henry": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 22,
    "full_name": "derrickhenry",
    "first_name": "Derrick",
    "last_name": "Henry",
    "position": "RB",
    "age": 25,
    "team": "TEN",
    "player_id": "3198",
    "my_id": 3198,
    "gp": 16,
    "gs": 12,
    "pts_ppr": 201.36,
    "rec": 15,
    "rec_yd": 99,
    "rec_td": 0,
    "rec_tgt": 18,
    "rush_att": 215,
    "rush_td": 12,
    "rush_yd": 1059,
    "td": 12,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 2,
    "pass_att": 3,
    "pass_yd": 14,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Michael Thomas": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 13,
    "full_name": "michaelthomas",
    "first_name": "Michael",
    "last_name": "Thomas",
    "position": "WR",
    "age": 26,
    "team": "NO",
    "player_id": "3199",
    "my_id": 3199,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 315.5,
    "rec": 125,
    "rec_yd": 1405,
    "rec_td": 9,
    "rec_tgt": 147,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 9,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 2
  },
  "Sterling Shepard": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 87,
    "full_name": "sterlingshepard",
    "first_name": "Sterling",
    "last_name": "Shepard",
    "position": "WR",
    "age": 25,
    "team": "NYG",
    "player_id": "3200",
    "my_id": 3200,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 182.5,
    "rec": 66,
    "rec_yd": 872,
    "rec_td": 4,
    "rec_tgt": 107,
    "rush_att": 3,
    "rush_td": 0,
    "rush_yd": 33,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Austin Hooper": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 81,
    "full_name": "austinhooper",
    "first_name": "Austin",
    "last_name": "Hooper",
    "position": "TE",
    "age": 24,
    "team": "ATL",
    "player_id": "3202",
    "my_id": 3202,
    "gp": 16,
    "gs": 7,
    "pts_ppr": 163,
    "rec": 71,
    "rec_yd": 660,
    "rec_td": 4,
    "rec_tgt": 88,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "CJ Prosise": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 22,
    "full_name": "cjprosise",
    "first_name": "CJ",
    "last_name": "Prosise",
    "position": "RB",
    "age": 25,
    "team": "SEA",
    "player_id": "3204",
    "my_id": 3204,
    "gp": 5,
    "gs": 0,
    "pts_ppr": 4.9,
    "rec": 3,
    "rec_yd": 22,
    "rec_td": 0,
    "rec_tgt": 3,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": -3,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Cody Kessler": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 6,
    "full_name": "codykessler",
    "first_name": "Cody",
    "last_name": "Kessler",
    "position": "QB",
    "age": 26,
    "team": "NE",
    "player_id": "3205",
    "my_id": 3205,
    "gp": 5,
    "gs": 4,
    "pts_ppr": 38.66,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 19,
    "rush_td": 0,
    "rush_yd": 123,
    "td": 0,
    "pass_td": 2,
    "pass_int": 2,
    "pass_cmp": 85,
    "pass_att": 131,
    "pass_yd": 709,
    "pass_inc": 46,
    "fum_lost": 3
  },
  "Kenneth Dixon": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 30,
    "full_name": "kennethdixon",
    "first_name": "Kenneth",
    "last_name": "Dixon",
    "position": "RB",
    "age": 25,
    "team": null,
    "player_id": "3208",
    "my_id": 3208,
    "gp": 6,
    "gs": 0,
    "pts_ppr": 54.4,
    "rec": 6,
    "rec_yd": 51,
    "rec_td": 0,
    "rec_tgt": 7,
    "rush_att": 60,
    "rush_td": 2,
    "rush_yd": 333,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Devontae Booker": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 23,
    "full_name": "devontaebooker",
    "first_name": "Devontae",
    "last_name": "Booker",
    "position": "RB",
    "age": 27,
    "team": "DEN",
    "player_id": "3209",
    "my_id": 3209,
    "gp": 16,
    "gs": 0,
    "pts_ppr": 87.8,
    "rec": 38,
    "rec_yd": 275,
    "rec_td": 0,
    "rec_tgt": 51,
    "rush_att": 34,
    "rush_td": 1,
    "rush_yd": 183,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Tyler Boyd": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 83,
    "full_name": "tylerboyd",
    "first_name": "Tyler",
    "last_name": "Boyd",
    "position": "WR",
    "age": 24,
    "team": "CIN",
    "player_id": "3225",
    "my_id": 3225,
    "gp": 14,
    "gs": 14,
    "pts_ppr": 221.1,
    "rec": 76,
    "rec_yd": 1028,
    "rec_td": 7,
    "rec_tgt": 108,
    "rush_att": 2,
    "rush_td": 0,
    "rush_yd": 3,
    "td": 7,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 1,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Kenyan Drake": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 32,
    "full_name": "kenyandrake",
    "first_name": "Kenyan",
    "last_name": "Drake",
    "position": "RB",
    "age": 25,
    "team": "MIA",
    "player_id": "3242",
    "my_id": 3242,
    "gp": 16,
    "gs": 7,
    "pts_ppr": 206.2,
    "rec": 53,
    "rec_yd": 477,
    "rec_td": 5,
    "rec_tgt": 73,
    "rush_att": 120,
    "rush_td": 4,
    "rush_yd": 535,
    "td": 9,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Leonte Carroo": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 88,
    "full_name": "leontecarroo",
    "first_name": "Leonte",
    "last_name": "Carroo",
    "position": "WR",
    "age": 25,
    "team": null,
    "player_id": "3253",
    "my_id": 3253,
    "gp": 9,
    "gs": 0,
    "pts_ppr": 18.8,
    "rec": 2,
    "rec_yd": 94,
    "rec_td": 1,
    "rec_tgt": 4,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 14,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jacoby Brissett": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 7,
    "full_name": "jacobybrissett",
    "first_name": "Jacoby",
    "last_name": "Brissett",
    "position": "QB",
    "age": 26,
    "team": "IND",
    "player_id": "3257",
    "my_id": 3257,
    "gp": 4,
    "gs": 0,
    "pts_ppr": -0.62,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 7,
    "rush_td": 0,
    "rush_yd": -7,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 2,
    "pass_att": 4,
    "pass_yd": 2,
    "pass_inc": 1,
    "fum_lost": 0
  },
  "Nick Vannett": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 88,
    "full_name": "nickvannett",
    "first_name": "Nick",
    "last_name": "Vannett",
    "position": "TE",
    "age": 26,
    "team": "PIT",
    "player_id": "3258",
    "my_id": 3258,
    "gp": 15,
    "gs": 9,
    "pts_ppr": 73.9,
    "rec": 29,
    "rec_yd": 269,
    "rec_td": 3,
    "rec_tgt": 43,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Chris Moore": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 10,
    "full_name": "chrismoore",
    "first_name": "Chris",
    "last_name": "Moore",
    "position": "WR",
    "age": 26,
    "team": "BAL",
    "player_id": "3269",
    "my_id": 3269,
    "gp": 16,
    "gs": 0,
    "pts_ppr": 46.3,
    "rec": 19,
    "rec_yd": 196,
    "rec_td": 1,
    "rec_tgt": 25,
    "rush_att": 5,
    "rush_td": 0,
    "rush_yd": 17,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Tyler Higbee": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 89,
    "full_name": "tylerhigbee",
    "first_name": "Tyler",
    "last_name": "Higbee",
    "position": "TE",
    "age": 26,
    "team": "LAR",
    "player_id": "3271",
    "my_id": 3271,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 65.2,
    "rec": 24,
    "rec_yd": 292,
    "rec_td": 2,
    "rec_tgt": 34,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Pharoh Cooper": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 12,
    "full_name": "pharohcooper",
    "first_name": "Pharoh",
    "last_name": "Cooper",
    "position": "WR",
    "age": 24,
    "team": "ARI",
    "player_id": "3278",
    "my_id": 3278,
    "gp": 7,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Tyler Ervin": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 24,
    "full_name": "tylerervin",
    "first_name": "Tyler",
    "last_name": "Ervin",
    "position": "RB",
    "age": 26,
    "team": "JAX",
    "player_id": "3280",
    "my_id": 3280,
    "gp": 9,
    "gs": 0,
    "pts_ppr": 6.5,
    "rec": 3,
    "rec_yd": 35,
    "rec_td": 0,
    "rec_tgt": 4,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Demarcus Robinson": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 11,
    "full_name": "demarcusrobinson",
    "first_name": "Demarcus",
    "last_name": "Robinson",
    "position": "WR",
    "age": 25,
    "team": "KC",
    "player_id": "3286",
    "my_id": 3286,
    "gp": 16,
    "gs": 5,
    "pts_ppr": 74.8,
    "rec": 22,
    "rec_yd": 288,
    "rec_td": 4,
    "rec_tgt": 33,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Dak Prescott": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 4,
    "full_name": "dakprescott",
    "first_name": "Dak",
    "last_name": "Prescott",
    "position": "QB",
    "age": 26,
    "team": "DAL",
    "player_id": "3294",
    "my_id": 3294,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 285.86,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 75,
    "rush_td": 6,
    "rush_yd": 305,
    "td": 6,
    "pass_td": 22,
    "pass_int": 8,
    "pass_cmp": 356,
    "pass_att": 526,
    "pass_yd": 3884,
    "pass_inc": 170,
    "fum_lost": 6
  },
  "Seth DeValve": {
    "fantasy_positions": [
      "WR",
      "TE"
    ],
    "year": 2018,
    "number": 88,
    "full_name": "sethdevalve",
    "first_name": "Seth",
    "last_name": "DeValve",
    "position": "TE",
    "age": 26,
    "team": "JAX",
    "player_id": "3296",
    "my_id": 3296,
    "gp": 13,
    "gs": 4,
    "pts_ppr": 18.4,
    "rec": 5,
    "rec_yd": 74,
    "rec_td": 1,
    "rec_tgt": 7,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Tajae Sharpe": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 19,
    "full_name": "tajaesharpe",
    "first_name": "Tajae",
    "last_name": "Sharpe",
    "position": "WR",
    "age": 24,
    "team": "TEN",
    "player_id": "3297",
    "my_id": 3297,
    "gp": 16,
    "gs": 12,
    "pts_ppr": 71.2,
    "rec": 26,
    "rec_yd": 316,
    "rec_td": 2,
    "rec_tgt": 47,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 16,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Deandre Washington": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 33,
    "full_name": "deandrewashington",
    "first_name": "Deandre",
    "last_name": "Washington",
    "position": "RB",
    "age": 26,
    "team": "OAK",
    "player_id": "3300",
    "my_id": 3300,
    "gp": 10,
    "gs": 0,
    "pts_ppr": 11.4,
    "rec": 1,
    "rec_yd": 9,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 30,
    "rush_td": 0,
    "rush_yd": 115,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Jordan Howard": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 24,
    "full_name": "jordanhoward",
    "first_name": "Jordan",
    "last_name": "Howard",
    "position": "RB",
    "age": 24,
    "team": "PHI",
    "player_id": "3306",
    "my_id": 3306,
    "gp": 16,
    "gs": 15,
    "pts_ppr": 180,
    "rec": 20,
    "rec_yd": 145,
    "rec_td": 0,
    "rec_tgt": 27,
    "rush_att": 250,
    "rush_td": 9,
    "rush_yd": 935,
    "td": 9,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Wendell Smallwood": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 34,
    "full_name": "wendellsmallwood",
    "first_name": "Wendell",
    "last_name": "Smallwood",
    "position": "RB",
    "age": 25,
    "team": "WAS",
    "player_id": "3309",
    "my_id": 3309,
    "gp": 16,
    "gs": 6,
    "pts_ppr": 117.4,
    "rec": 28,
    "rec_yd": 230,
    "rec_td": 2,
    "rec_tgt": 35,
    "rush_att": 87,
    "rush_td": 3,
    "rush_yd": 364,
    "td": 5,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Jonathan Williams": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 33,
    "full_name": "jonathanwilliams",
    "first_name": "Jonathan",
    "last_name": "Williams",
    "position": "RB",
    "age": 25,
    "team": "IND",
    "player_id": "3312",
    "my_id": 3312,
    "gp": 3,
    "gs": 0,
    "pts_ppr": 1.1,
    "rec": 1,
    "rec_yd": 1,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 3,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Trevor Davis": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 12,
    "full_name": "trevordavis",
    "first_name": "Trevor",
    "last_name": "Davis",
    "position": "WR",
    "age": 26,
    "team": "OAK",
    "player_id": "3319",
    "my_id": 3319,
    "gp": 2,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Tyreek Hill": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 10,
    "full_name": "tyreekhill",
    "first_name": "Tyreek",
    "last_name": "Hill",
    "position": "WR",
    "age": 25,
    "team": "KC",
    "player_id": "3321",
    "my_id": 3321,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 328,
    "rec": 87,
    "rec_yd": 1479,
    "rec_td": 12,
    "rec_tgt": 137,
    "rush_att": 22,
    "rush_td": 1,
    "rush_yd": 151,
    "td": 14,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Alex Collins": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 34,
    "full_name": "alexcollins",
    "first_name": "Alex",
    "last_name": "Collins",
    "position": "RB",
    "age": 25,
    "team": null,
    "player_id": "3327",
    "my_id": 3327,
    "gp": 10,
    "gs": 10,
    "pts_ppr": 108.6,
    "rec": 15,
    "rec_yd": 105,
    "rec_td": 1,
    "rec_tgt": 21,
    "rush_att": 114,
    "rush_td": 7,
    "rush_yd": 411,
    "td": 8,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 3
  },
  "Rashard Higgins": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 81,
    "full_name": "rashardhiggins",
    "first_name": "Rashard",
    "last_name": "Higgins",
    "position": "WR",
    "age": 25,
    "team": "CLE",
    "player_id": "3328",
    "my_id": 3328,
    "gp": 13,
    "gs": 1,
    "pts_ppr": 118.2,
    "rec": 39,
    "rec_yd": 572,
    "rec_td": 4,
    "rec_tgt": 54,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Temarrick Hemingway": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 84,
    "full_name": "temarrickhemingway",
    "first_name": "Temarrick",
    "last_name": "Hemingway",
    "position": "TE",
    "age": 26,
    "team": "CAR",
    "player_id": "3333",
    "my_id": 3333,
    "gp": 5,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Keenan Reynolds": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 19,
    "full_name": "keenanreynolds",
    "first_name": "Keenan",
    "last_name": "Reynolds",
    "position": "WR",
    "age": 24,
    "team": null,
    "player_id": "3338",
    "my_id": 3338,
    "gp": 2,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jakeem Grant": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 19,
    "full_name": "jakeemgrant",
    "first_name": "Jakeem",
    "last_name": "Grant",
    "position": "WR",
    "age": 26,
    "team": "MIA",
    "player_id": "3342",
    "my_id": 3342,
    "gp": 10,
    "gs": 3,
    "pts_ppr": 60.3,
    "rec": 21,
    "rec_yd": 268,
    "rec_td": 2,
    "rec_tgt": 34,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 5,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Nate Sudfeld": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 7,
    "full_name": "natesudfeld",
    "first_name": "Nate",
    "last_name": "Sudfeld",
    "position": "QB",
    "age": 26,
    "team": "PHI",
    "player_id": "3343",
    "my_id": 3343,
    "gp": 2,
    "gs": 0,
    "pts_ppr": 4.68,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 2,
    "rush_td": 0,
    "rush_yd": -2,
    "td": 0,
    "pass_td": 1,
    "pass_int": 0,
    "pass_cmp": 1,
    "pass_att": 2,
    "pass_yd": 22,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "David Morgan": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 89,
    "full_name": "davidmorgan",
    "first_name": "David",
    "last_name": "Morgan",
    "position": "TE",
    "age": 26,
    "team": "MIN",
    "player_id": "3344",
    "my_id": 3344,
    "gp": 11,
    "gs": 6,
    "pts_ppr": 8.6,
    "rec": 5,
    "rec_yd": 36,
    "rec_td": 0,
    "rec_tgt": 6,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Cody Core": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 17,
    "full_name": "codycore",
    "first_name": "Cody",
    "last_name": "Core",
    "position": "WR",
    "age": 25,
    "team": "NYG",
    "player_id": "3355",
    "my_id": 3355,
    "gp": 14,
    "gs": 3,
    "pts_ppr": 37,
    "rec": 13,
    "rec_yd": 160,
    "rec_td": 1,
    "rec_tgt": 28,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jeff Driskel": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 2,
    "full_name": "jeffdriskel",
    "first_name": "Jeff",
    "last_name": "Driskel",
    "position": "QB",
    "age": 26,
    "team": "DET",
    "player_id": "3362",
    "my_id": 3362,
    "gp": 9,
    "gs": 5,
    "pts_ppr": 85.12,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 25,
    "rush_td": 2,
    "rush_yd": 130,
    "td": 2,
    "pass_td": 6,
    "pass_int": 2,
    "pass_cmp": 105,
    "pass_att": 176,
    "pass_yd": 1003,
    "pass_inc": 71,
    "fum_lost": 1
  },
  "Darius Jackson": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 43,
    "full_name": "dariusjackson",
    "first_name": "Darius",
    "last_name": "Jackson",
    "position": "RB",
    "age": 25,
    "team": "TB",
    "player_id": "3371",
    "my_id": 3371,
    "gp": 4,
    "gs": 0,
    "pts_ppr": 1.6,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 6,
    "rush_td": 0,
    "rush_yd": 16,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Rico Gathers": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 84,
    "full_name": "ricogathers",
    "first_name": "Rico",
    "last_name": "Gathers",
    "position": "TE",
    "age": 25,
    "team": null,
    "player_id": "3372",
    "my_id": 3372,
    "gp": 15,
    "gs": 4,
    "pts_ppr": 7.5,
    "rec": 3,
    "rec_yd": 45,
    "rec_td": 0,
    "rec_tgt": 7,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Dwayne Washington": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 27,
    "full_name": "dwaynewashington",
    "first_name": "Dwayne",
    "last_name": "Washington",
    "position": "RB",
    "age": 25,
    "team": "NO",
    "player_id": "3391",
    "my_id": 3391,
    "gp": 6,
    "gs": 0,
    "pts_ppr": 15.4,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 27,
    "rush_td": 0,
    "rush_yd": 154,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Charone Peake": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 17,
    "full_name": "charonepeake",
    "first_name": "Charone",
    "last_name": "Peake",
    "position": "WR",
    "age": 27,
    "team": null,
    "player_id": "3396",
    "my_id": 3396,
    "gp": 13,
    "gs": 0,
    "pts_ppr": 4.5,
    "rec": 2,
    "rec_yd": 25,
    "rec_td": 0,
    "rec_tgt": 3,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Robby Anderson": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 11,
    "full_name": "robbyanderson",
    "first_name": "Robby",
    "last_name": "Anderson",
    "position": "WR",
    "age": 26,
    "team": "NYJ",
    "player_id": "3423",
    "my_id": 3423,
    "gp": 14,
    "gs": 9,
    "pts_ppr": 156.4,
    "rec": 50,
    "rec_yd": 752,
    "rec_td": 6,
    "rec_tgt": 93,
    "rush_att": 2,
    "rush_td": 0,
    "rush_yd": -8,
    "td": 6,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 2
  },
  "Alex Erickson": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 12,
    "full_name": "alexerickson",
    "first_name": "Alex",
    "last_name": "Erickson",
    "position": "WR",
    "age": 26,
    "team": "CIN",
    "player_id": "3433",
    "my_id": 3433,
    "gp": 16,
    "gs": 6,
    "pts_ppr": 36.9,
    "rec": 20,
    "rec_yd": 167,
    "rec_td": 0,
    "rec_tgt": 29,
    "rush_att": 3,
    "rush_td": 0,
    "rush_yd": 22,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Marcus Johnson": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 16,
    "full_name": "marcusjohnson",
    "first_name": "Marcus",
    "last_name": "Johnson",
    "position": "WR",
    "age": 25,
    "team": "IND",
    "player_id": "3445",
    "my_id": 3445,
    "gp": 5,
    "gs": 0,
    "pts_ppr": 22,
    "rec": 6,
    "rec_yd": 102,
    "rec_td": 1,
    "rec_tgt": 8,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": -2,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Cayleb Jones": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 16,
    "full_name": "caylebjones",
    "first_name": "Cayleb",
    "last_name": "Jones",
    "position": "WR",
    "age": 26,
    "team": null,
    "player_id": "3447",
    "my_id": 3447,
    "gp": 1,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Ben Braunecker": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 82,
    "full_name": "benbraunecker",
    "first_name": "Ben",
    "last_name": "Braunecker",
    "position": "TE",
    "age": 25,
    "team": "CHI",
    "player_id": "3465",
    "my_id": 3465,
    "gp": 15,
    "gs": 2,
    "pts_ppr": 7.2,
    "rec": 3,
    "rec_yd": 42,
    "rec_td": 0,
    "rec_tgt": 5,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "David Grinnage": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 86,
    "full_name": "davidgrinnage",
    "first_name": "David",
    "last_name": "Grinnage",
    "position": "TE",
    "age": 25,
    "team": null,
    "player_id": "3472",
    "my_id": 3472,
    "gp": 3,
    "gs": 2,
    "pts_ppr": 12.1,
    "rec": 6,
    "rec_yd": 61,
    "rec_td": 0,
    "rec_tgt": 8,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Johnny Holton": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 80,
    "full_name": "johnnyholton",
    "first_name": "Johnny",
    "last_name": "Holton",
    "position": "WR",
    "age": 28,
    "team": "PIT",
    "player_id": "3476",
    "my_id": 3476,
    "gp": 1,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Byron Marshall": {
    "fantasy_positions": [
      "WR",
      "RB"
    ],
    "year": 2018,
    "number": 40,
    "full_name": "byronmarshall",
    "first_name": "Byron",
    "last_name": "Marshall",
    "position": "RB",
    "age": 25,
    "team": null,
    "player_id": "3491",
    "my_id": 3491,
    "gp": 6,
    "gs": 0,
    "pts_ppr": 7.9,
    "rec": 4,
    "rec_yd": 30,
    "rec_td": 0,
    "rec_tgt": 6,
    "rush_att": 3,
    "rush_td": 0,
    "rush_yd": 9,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Geronimo Allison": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 81,
    "full_name": "geronimoallison",
    "first_name": "Geronimo",
    "last_name": "Allison",
    "position": "WR",
    "age": 25,
    "team": "GB",
    "player_id": "3503",
    "my_id": 3503,
    "gp": 5,
    "gs": 4,
    "pts_ppr": 62.3,
    "rec": 20,
    "rec_yd": 303,
    "rec_td": 2,
    "rec_tgt": 30,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Tre Madden": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 38,
    "full_name": "tremadden",
    "first_name": "Tre",
    "last_name": "Madden",
    "position": "RB",
    "age": 26,
    "team": null,
    "player_id": "3564",
    "my_id": 3564,
    "gp": 14,
    "gs": 3,
    "pts_ppr": 5.8,
    "rec": 2,
    "rec_yd": 35,
    "rec_td": 0,
    "rec_tgt": 3,
    "rush_att": 3,
    "rush_td": 0,
    "rush_yd": 3,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Brandon Wilds": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 35,
    "full_name": "brandonwilds",
    "first_name": "Brandon",
    "last_name": "Wilds",
    "position": "RB",
    "age": 26,
    "team": null,
    "player_id": "3573",
    "my_id": 3573,
    "gp": 3,
    "gs": 0,
    "pts_ppr": 1.5,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 6,
    "rush_td": 0,
    "rush_yd": 15,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Chester Rogers": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 80,
    "full_name": "chesterrogers",
    "first_name": "Chester",
    "last_name": "Rogers",
    "position": "WR",
    "age": 25,
    "team": "IND",
    "player_id": "3582",
    "my_id": 3582,
    "gp": 16,
    "gs": 10,
    "pts_ppr": 117.1,
    "rec": 53,
    "rec_yd": 485,
    "rec_td": 2,
    "rec_tgt": 72,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": -4,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Peyton Barber": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 25,
    "full_name": "peytonbarber",
    "first_name": "Peyton",
    "last_name": "Barber",
    "position": "RB",
    "age": 25,
    "team": "TB",
    "player_id": "3594",
    "my_id": 3594,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 150.3,
    "rec": 20,
    "rec_yd": 92,
    "rec_td": 1,
    "rec_tgt": 29,
    "rush_att": 234,
    "rush_td": 5,
    "rush_yd": 871,
    "td": 6,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Hakeem Valles": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 49,
    "full_name": "hakeemvalles",
    "first_name": "Hakeem",
    "last_name": "Valles",
    "position": "TE",
    "age": 26,
    "team": null,
    "player_id": "3612",
    "my_id": 3612,
    "gp": 3,
    "gs": 0,
    "pts_ppr": 3.1,
    "rec": 2,
    "rec_yd": 11,
    "rec_td": 0,
    "rec_tgt": 3,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Tommylee Lewis": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 14,
    "full_name": "tommyleelewis",
    "first_name": "Tommylee",
    "last_name": "Lewis",
    "position": "WR",
    "age": 26,
    "team": null,
    "player_id": "3614",
    "my_id": 3614,
    "gp": 7,
    "gs": 3,
    "pts_ppr": 14,
    "rec": 3,
    "rec_yd": 60,
    "rec_td": 1,
    "rec_tgt": 3,
    "rush_att": 2,
    "rush_td": 0,
    "rush_yd": 10,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Maurice Harris": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 82,
    "full_name": "mauriceharris",
    "first_name": "Maurice",
    "last_name": "Harris",
    "position": "WR",
    "age": 26,
    "team": null,
    "player_id": "3650",
    "my_id": 3650,
    "gp": 12,
    "gs": 7,
    "pts_ppr": 59.4,
    "rec": 28,
    "rec_yd": 304,
    "rec_td": 0,
    "rec_tgt": 47,
    "rush_att": 2,
    "rush_td": 0,
    "rush_yd": 10,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Mike Thomas": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 88,
    "full_name": "mikethomas",
    "first_name": "Mike",
    "last_name": "Thomas",
    "position": "WR",
    "age": 25,
    "team": "LAR",
    "player_id": "3652",
    "my_id": 3652,
    "gp": 1,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Rob Kelley": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 37,
    "full_name": "robkelley",
    "first_name": "Rob",
    "last_name": "Kelley",
    "position": "RB",
    "age": 27,
    "team": null,
    "player_id": "3657",
    "my_id": 3657,
    "gp": 2,
    "gs": 0,
    "pts_ppr": 0.8,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 4,
    "rush_td": 0,
    "rush_yd": 8,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "JD McKissic": {
    "fantasy_positions": [
      "WR",
      "RB"
    ],
    "year": 2018,
    "number": 41,
    "full_name": "jdmckissic",
    "first_name": "JD",
    "last_name": "McKissic",
    "position": "RB",
    "age": 26,
    "team": "DET",
    "player_id": "3664",
    "my_id": 3664,
    "gp": 5,
    "gs": 0,
    "pts_ppr": 0.8,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 3,
    "rush_td": 0,
    "rush_yd": 8,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Joshua Perkins": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 81,
    "full_name": "joshuaperkins",
    "first_name": "Joshua",
    "last_name": "Perkins",
    "position": "TE",
    "age": 26,
    "team": "PHI",
    "player_id": "3668",
    "my_id": 3668,
    "gp": 9,
    "gs": 1,
    "pts_ppr": 11.7,
    "rec": 5,
    "rec_yd": 67,
    "rec_td": 0,
    "rec_tgt": 11,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Tra Carson": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 32,
    "full_name": "tracarson",
    "first_name": "Tra",
    "last_name": "Carson",
    "position": "RB",
    "age": 26,
    "team": "GB",
    "player_id": "3688",
    "my_id": 3688,
    "gp": 6,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Andy Jones": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 16,
    "full_name": "andyjones",
    "first_name": "Andy",
    "last_name": "Jones",
    "position": "WR",
    "age": 25,
    "team": "MIA",
    "player_id": "3702",
    "my_id": 3702,
    "gp": 7,
    "gs": 3,
    "pts_ppr": 25,
    "rec": 11,
    "rec_yd": 80,
    "rec_td": 1,
    "rec_tgt": 24,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Cole Wick": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 89,
    "full_name": "colewick",
    "first_name": "Cole",
    "last_name": "Wick",
    "position": "TE",
    "age": 25,
    "team": null,
    "player_id": "3715",
    "my_id": 3715,
    "gp": 5,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Tanner McEvoy": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 87,
    "full_name": "tannermcevoy",
    "first_name": "Tanner",
    "last_name": "McEvoy",
    "position": "WR",
    "age": 26,
    "team": null,
    "player_id": "3788",
    "my_id": 3788,
    "gp": 2,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Elijhaa Penny": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 39,
    "full_name": "elijhaapenny",
    "first_name": "Elijhaa",
    "last_name": "Penny",
    "position": "RB",
    "age": 26,
    "team": "NYG",
    "player_id": "3803",
    "my_id": 3803,
    "gp": 12,
    "gs": 2,
    "pts_ppr": 15.5,
    "rec": 8,
    "rec_yd": 50,
    "rec_td": 0,
    "rec_tgt": 9,
    "rush_att": 7,
    "rush_td": 0,
    "rush_yd": 25,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Alex Ellis": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 85,
    "full_name": "alexellis",
    "first_name": "Alex",
    "last_name": "Ellis",
    "position": "TE",
    "age": 26,
    "team": "PHI",
    "player_id": "3824",
    "my_id": 3824,
    "gp": 2,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "CJ Ham": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 30,
    "full_name": "cjham",
    "first_name": "CJ",
    "last_name": "Ham",
    "position": "RB",
    "age": 26,
    "team": "MIN",
    "player_id": "3832",
    "my_id": 3832,
    "gp": 15,
    "gs": 2,
    "pts_ppr": 20.3,
    "rec": 11,
    "rec_yd": 85,
    "rec_td": 0,
    "rec_tgt": 15,
    "rush_att": 6,
    "rush_td": 0,
    "rush_yd": 8,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jaydon Mickens": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 14,
    "full_name": "jaydonmickens",
    "first_name": "Jaydon",
    "last_name": "Mickens",
    "position": "WR",
    "age": 25,
    "team": null,
    "player_id": "3852",
    "my_id": 3852,
    "gp": 6,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jalen Richard": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 30,
    "full_name": "jalenrichard",
    "first_name": "Jalen",
    "last_name": "Richard",
    "position": "RB",
    "age": 26,
    "team": "OAK",
    "player_id": "3868",
    "my_id": 3868,
    "gp": 16,
    "gs": 1,
    "pts_ppr": 156.6,
    "rec": 68,
    "rec_yd": 607,
    "rec_td": 0,
    "rec_tgt": 81,
    "rush_att": 55,
    "rush_td": 1,
    "rush_yd": 259,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 2
  },
  "Marvin Hall": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 17,
    "full_name": "marvinhall",
    "first_name": "Marvin",
    "last_name": "Hall",
    "position": "WR",
    "age": 26,
    "team": "DET",
    "player_id": "3895",
    "my_id": 3895,
    "gp": 16,
    "gs": 0,
    "pts_ppr": 30.9,
    "rec": 10,
    "rec_yd": 149,
    "rec_td": 1,
    "rec_tgt": 19,
    "rush_att": 2,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Leonard Fournette": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 27,
    "full_name": "leonardfournette",
    "first_name": "Leonard",
    "last_name": "Fournette",
    "position": "RB",
    "age": 24,
    "team": "JAX",
    "player_id": "3969",
    "my_id": 3969,
    "gp": 8,
    "gs": 8,
    "pts_ppr": 120.4,
    "rec": 22,
    "rec_yd": 185,
    "rec_td": 1,
    "rec_tgt": 26,
    "rush_att": 133,
    "rush_td": 5,
    "rush_yd": 439,
    "td": 6,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Mitch Trubisky": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 10,
    "full_name": "mitchtrubisky",
    "first_name": "Mitch",
    "last_name": "Trubisky",
    "position": "QB",
    "age": 25,
    "team": "CHI",
    "player_id": "3976",
    "my_id": 3976,
    "gp": 14,
    "gs": 14,
    "pts_ppr": 263.02,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 68,
    "rush_td": 3,
    "rush_yd": 421,
    "td": 3,
    "pass_td": 24,
    "pass_int": 12,
    "pass_cmp": 289,
    "pass_att": 434,
    "pass_yd": 3223,
    "pass_inc": 145,
    "fum_lost": 3
  },
  "Deshaun Watson": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 4,
    "full_name": "deshaunwatson",
    "first_name": "Deshaun",
    "last_name": "Watson",
    "position": "QB",
    "age": 24,
    "team": "HOU",
    "player_id": "4017",
    "my_id": 4017,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 331.7,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 99,
    "rush_td": 5,
    "rush_yd": 551,
    "td": 5,
    "pass_td": 26,
    "pass_int": 9,
    "pass_cmp": 345,
    "pass_att": 505,
    "pass_yd": 4165,
    "pass_inc": 160,
    "fum_lost": 3
  },
  "Joe Mixon": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 28,
    "full_name": "joemixon",
    "first_name": "Joe",
    "last_name": "Mixon",
    "position": "RB",
    "age": 23,
    "team": "CIN",
    "player_id": "4018",
    "my_id": 4018,
    "gp": 14,
    "gs": 13,
    "pts_ppr": 243.4,
    "rec": 43,
    "rec_yd": 296,
    "rec_td": 1,
    "rec_tgt": 55,
    "rush_att": 237,
    "rush_td": 8,
    "rush_yd": 1168,
    "td": 9,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Deshone Kizer": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 14,
    "full_name": "deshonekizer",
    "first_name": "Deshone",
    "last_name": "Kizer",
    "position": "QB",
    "age": 23,
    "team": "OAK",
    "player_id": "4026",
    "my_id": 4026,
    "gp": 3,
    "gs": 0,
    "pts_ppr": 5.38,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 5,
    "rush_td": 0,
    "rush_yd": 39,
    "td": 0,
    "pass_td": 0,
    "pass_int": 2,
    "pass_cmp": 20,
    "pass_att": 42,
    "pass_yd": 187,
    "pass_inc": 22,
    "fum_lost": 1
  },
  "Dalvin Cook": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 33,
    "full_name": "dalvincook",
    "first_name": "Dalvin",
    "last_name": "Cook",
    "position": "RB",
    "age": 24,
    "team": "MIN",
    "player_id": "4029",
    "my_id": 4029,
    "gp": 11,
    "gs": 10,
    "pts_ppr": 152,
    "rec": 40,
    "rec_yd": 305,
    "rec_td": 2,
    "rec_tgt": 49,
    "rush_att": 133,
    "rush_td": 2,
    "rush_yd": 615,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 2
  },
  "David Njoku": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 85,
    "full_name": "davidnjoku",
    "first_name": "David",
    "last_name": "Njoku",
    "position": "TE",
    "age": 23,
    "team": "CLE",
    "player_id": "4033",
    "my_id": 4033,
    "gp": 16,
    "gs": 14,
    "pts_ppr": 143.9,
    "rec": 56,
    "rec_yd": 639,
    "rec_td": 4,
    "rec_tgt": 89,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Christian McCaffrey": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 22,
    "full_name": "christianmccaffrey",
    "first_name": "Christian",
    "last_name": "McCaffrey",
    "position": "RB",
    "age": 23,
    "team": "CAR",
    "player_id": "4034",
    "my_id": 4034,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 385.5,
    "rec": 107,
    "rec_yd": 867,
    "rec_td": 6,
    "rec_tgt": 124,
    "rush_att": 219,
    "rush_td": 7,
    "rush_yd": 1098,
    "td": 13,
    "pass_td": 1,
    "pass_int": 0,
    "pass_cmp": 1,
    "pass_att": 1,
    "pass_yd": 50,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Alvin Kamara": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 41,
    "full_name": "alvinkamara",
    "first_name": "Alvin",
    "last_name": "Kamara",
    "position": "RB",
    "age": 24,
    "team": "NO",
    "player_id": "4035",
    "my_id": 4035,
    "gp": 15,
    "gs": 13,
    "pts_ppr": 354.2,
    "rec": 81,
    "rec_yd": 709,
    "rec_td": 4,
    "rec_tgt": 105,
    "rush_att": 194,
    "rush_td": 14,
    "rush_yd": 883,
    "td": 18,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Corey Davis": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 84,
    "full_name": "coreydavis",
    "first_name": "Corey",
    "last_name": "Davis",
    "position": "WR",
    "age": 24,
    "team": "TEN",
    "player_id": "4036",
    "my_id": 4036,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 183.6,
    "rec": 65,
    "rec_yd": 891,
    "rec_td": 4,
    "rec_tgt": 112,
    "rush_att": 6,
    "rush_td": 0,
    "rush_yd": 55,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Chris Godwin": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 12,
    "full_name": "chrisgodwin",
    "first_name": "Chris",
    "last_name": "Godwin",
    "position": "WR",
    "age": 23,
    "team": "TB",
    "player_id": "4037",
    "my_id": 4037,
    "gp": 16,
    "gs": 5,
    "pts_ppr": 185.2,
    "rec": 59,
    "rec_yd": 842,
    "rec_td": 7,
    "rec_tgt": 95,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 7,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "John Ross": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 11,
    "full_name": "johnross",
    "first_name": "John",
    "last_name": "Ross",
    "position": "WR",
    "age": 24,
    "team": "CIN",
    "player_id": "4038",
    "my_id": 4038,
    "gp": 13,
    "gs": 10,
    "pts_ppr": 84.9,
    "rec": 21,
    "rec_yd": 210,
    "rec_td": 7,
    "rec_tgt": 58,
    "rush_att": 4,
    "rush_td": 0,
    "rush_yd": 9,
    "td": 7,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Cooper Kupp": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 18,
    "full_name": "cooperkupp",
    "first_name": "Cooper",
    "last_name": "Kupp",
    "position": "WR",
    "age": 26,
    "team": "LAR",
    "player_id": "4039",
    "my_id": 4039,
    "gp": 8,
    "gs": 8,
    "pts_ppr": 135.1,
    "rec": 40,
    "rec_yd": 566,
    "rec_td": 6,
    "rec_tgt": 56,
    "rush_att": 4,
    "rush_td": 0,
    "rush_yd": 25,
    "td": 6,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "JuJu Smith-Schuster": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 19,
    "full_name": "jujusmithschuster",
    "first_name": "JuJu",
    "last_name": "Smith-Schuster",
    "position": "WR",
    "age": 22,
    "team": "PIT",
    "player_id": "4040",
    "my_id": 4040,
    "gp": 16,
    "gs": 13,
    "pts_ppr": 296.9,
    "rec": 111,
    "rec_yd": 1426,
    "rec_td": 7,
    "rec_tgt": 166,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 13,
    "td": 7,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Patrick Mahomes": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 15,
    "full_name": "patrickmahomes",
    "first_name": "Patrick",
    "last_name": "Mahomes",
    "position": "QB",
    "age": 24,
    "team": "KC",
    "player_id": "4046",
    "my_id": 4046,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 417.08,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 60,
    "rush_td": 2,
    "rush_yd": 272,
    "td": 2,
    "pass_td": 50,
    "pass_int": 12,
    "pass_cmp": 383,
    "pass_att": 580,
    "pass_yd": 5097,
    "pass_inc": 197,
    "fum_lost": 2
  },
  "Chad Kelly": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 6,
    "full_name": "chadkelly",
    "first_name": "Chad",
    "last_name": "Kelly",
    "position": "QB",
    "age": 25,
    "team": "IND",
    "player_id": "4051",
    "my_id": 4051,
    "gp": 1,
    "gs": 0,
    "pts_ppr": -0.1,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": -1,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Mo Alie-Cox": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 81,
    "full_name": "moaliecox",
    "first_name": "Mo",
    "last_name": "Alie-Cox",
    "position": "TE",
    "age": 26,
    "team": "IND",
    "player_id": "4054",
    "my_id": 4054,
    "gp": 9,
    "gs": 1,
    "pts_ppr": 32.3,
    "rec": 7,
    "rec_yd": 133,
    "rec_td": 2,
    "rec_tgt": 13,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "OJ Howard": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 80,
    "full_name": "ojhoward",
    "first_name": "OJ",
    "last_name": "Howard",
    "position": "TE",
    "age": 24,
    "team": "TB",
    "player_id": "4055",
    "my_id": 4055,
    "gp": 10,
    "gs": 8,
    "pts_ppr": 120.5,
    "rec": 34,
    "rec_yd": 565,
    "rec_td": 5,
    "rec_tgt": 48,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 5,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Evan Engram": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 88,
    "full_name": "evanengram",
    "first_name": "Evan",
    "last_name": "Engram",
    "position": "TE",
    "age": 25,
    "team": "NYG",
    "player_id": "4066",
    "my_id": 4066,
    "gp": 11,
    "gs": 8,
    "pts_ppr": 126.3,
    "rec": 45,
    "rec_yd": 577,
    "rec_td": 3,
    "rec_tgt": 64,
    "rush_att": 3,
    "rush_td": 0,
    "rush_yd": 36,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Mike Williams": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 81,
    "full_name": "mikewilliams",
    "first_name": "Mike",
    "last_name": "Williams",
    "position": "WR",
    "age": 25,
    "team": "LAC",
    "player_id": "4068",
    "my_id": 4068,
    "gp": 16,
    "gs": 5,
    "pts_ppr": 180.2,
    "rec": 43,
    "rec_yd": 664,
    "rec_td": 10,
    "rec_tgt": 66,
    "rush_att": 7,
    "rush_td": 1,
    "rush_yd": 28,
    "td": 11,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Zay Jones": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 81,
    "full_name": "zayjones",
    "first_name": "Zay",
    "last_name": "Jones",
    "position": "WR",
    "age": 24,
    "team": "OAK",
    "player_id": "4080",
    "my_id": 4080,
    "gp": 16,
    "gs": 15,
    "pts_ppr": 165.2,
    "rec": 56,
    "rec_yd": 652,
    "rec_td": 7,
    "rec_tgt": 102,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 7,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 1,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Curtis Samuel": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 10,
    "full_name": "curtissamuel",
    "first_name": "Curtis",
    "last_name": "Samuel",
    "position": "WR",
    "age": 23,
    "team": "CAR",
    "player_id": "4082",
    "my_id": 4082,
    "gp": 13,
    "gs": 8,
    "pts_ppr": 136.8,
    "rec": 39,
    "rec_yd": 494,
    "rec_td": 5,
    "rec_tgt": 65,
    "rush_att": 8,
    "rush_td": 2,
    "rush_yd": 84,
    "td": 7,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Adam Shaheen": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 87,
    "full_name": "adamshaheen",
    "first_name": "Adam",
    "last_name": "Shaheen",
    "position": "TE",
    "age": 24,
    "team": "CHI",
    "player_id": "4085",
    "my_id": 4085,
    "gp": 5,
    "gs": 3,
    "pts_ppr": 15.8,
    "rec": 5,
    "rec_yd": 48,
    "rec_td": 1,
    "rec_tgt": 6,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Gerald Everett": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 81,
    "full_name": "geraldeverett",
    "first_name": "Gerald",
    "last_name": "Everett",
    "position": "TE",
    "age": 25,
    "team": "LAR",
    "player_id": "4089",
    "my_id": 4089,
    "gp": 16,
    "gs": 0,
    "pts_ppr": 86.6,
    "rec": 33,
    "rec_yd": 320,
    "rec_td": 3,
    "rec_tgt": 51,
    "rush_att": 2,
    "rush_td": 0,
    "rush_yd": 16,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Kareem Hunt": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 27,
    "full_name": "kareemhunt",
    "first_name": "Kareem",
    "last_name": "Hunt",
    "position": "RB",
    "age": 24,
    "team": "CLE",
    "player_id": "4098",
    "my_id": 4098,
    "gp": 11,
    "gs": 11,
    "pts_ppr": 230.2,
    "rec": 26,
    "rec_yd": 378,
    "rec_td": 7,
    "rec_tgt": 35,
    "rush_att": 181,
    "rush_td": 7,
    "rush_yd": 824,
    "td": 14,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "D'Onta Foreman": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 40,
    "full_name": "dontaforeman",
    "first_name": "D'Onta",
    "last_name": "Foreman",
    "position": "RB",
    "age": 23,
    "team": null,
    "player_id": "4111",
    "my_id": 4111,
    "gp": 1,
    "gs": 0,
    "pts_ppr": 10.7,
    "rec": 2,
    "rec_yd": 28,
    "rec_td": 1,
    "rec_tgt": 2,
    "rush_att": 7,
    "rush_td": 0,
    "rush_yd": -1,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Taywan Taylor": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 10,
    "full_name": "taywantaylor",
    "first_name": "Taywan",
    "last_name": "Taylor",
    "position": "WR",
    "age": 24,
    "team": "CLE",
    "player_id": "4125",
    "my_id": 4125,
    "gp": 13,
    "gs": 5,
    "pts_ppr": 87.6,
    "rec": 37,
    "rec_yd": 466,
    "rec_td": 1,
    "rec_tgt": 56,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "CJ Beathard": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 3,
    "full_name": "cjbeathard",
    "first_name": "CJ",
    "last_name": "Beathard",
    "position": "QB",
    "age": 25,
    "team": "SF",
    "player_id": "4127",
    "my_id": 4127,
    "gp": 6,
    "gs": 5,
    "pts_ppr": 74.98,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 19,
    "rush_td": 1,
    "rush_yd": 69,
    "td": 1,
    "pass_td": 8,
    "pass_int": 7,
    "pass_cmp": 102,
    "pass_att": 169,
    "pass_yd": 1252,
    "pass_inc": 67,
    "fum_lost": 3
  },
  "Chad Williams": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 1,
    "full_name": "chadwilliams",
    "first_name": "Chad",
    "last_name": "Williams",
    "position": "WR",
    "age": 25,
    "team": "IND",
    "player_id": "4128",
    "my_id": 4128,
    "gp": 10,
    "gs": 7,
    "pts_ppr": 41,
    "rec": 17,
    "rec_yd": 171,
    "rec_td": 1,
    "rec_tgt": 46,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 9,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Kenny Golladay": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 19,
    "full_name": "kennygolladay",
    "first_name": "Kenny",
    "last_name": "Golladay",
    "position": "WR",
    "age": 25,
    "team": "DET",
    "player_id": "4131",
    "my_id": 4131,
    "gp": 15,
    "gs": 13,
    "pts_ppr": 207.1,
    "rec": 70,
    "rec_yd": 1063,
    "rec_td": 5,
    "rec_tgt": 119,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 8,
    "td": 5,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "James Conner": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 30,
    "full_name": "jamesconner",
    "first_name": "James",
    "last_name": "Conner",
    "position": "RB",
    "age": 24,
    "team": "PIT",
    "player_id": "4137",
    "my_id": 4137,
    "gp": 13,
    "gs": 12,
    "pts_ppr": 280,
    "rec": 55,
    "rec_yd": 497,
    "rec_td": 1,
    "rec_tgt": 71,
    "rush_att": 215,
    "rush_td": 12,
    "rush_yd": 973,
    "td": 13,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 2
  },
  "Jonnu Smith": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 81,
    "full_name": "jonnusmith",
    "first_name": "Jonnu",
    "last_name": "Smith",
    "position": "TE",
    "age": 24,
    "team": "TEN",
    "player_id": "4144",
    "my_id": 4144,
    "gp": 13,
    "gs": 12,
    "pts_ppr": 63.8,
    "rec": 20,
    "rec_yd": 258,
    "rec_td": 3,
    "rec_tgt": 31,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Dede Westbrook": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 12,
    "full_name": "dedewestbrook",
    "first_name": "Dede",
    "last_name": "Westbrook",
    "position": "WR",
    "age": 25,
    "team": "JAX",
    "player_id": "4146",
    "my_id": 4146,
    "gp": 16,
    "gs": 9,
    "pts_ppr": 173.5,
    "rec": 66,
    "rec_yd": 717,
    "rec_td": 5,
    "rec_tgt": 101,
    "rush_att": 9,
    "rush_td": 0,
    "rush_yd": 98,
    "td": 6,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 1,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 2
  },
  "Samaje Perine": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 34,
    "full_name": "samajeperine",
    "first_name": "Samaje",
    "last_name": "Perine",
    "position": "RB",
    "age": 24,
    "team": "CIN",
    "player_id": "4147",
    "my_id": 4147,
    "gp": 5,
    "gs": 0,
    "pts_ppr": 6.7,
    "rec": 3,
    "rec_yd": 5,
    "rec_td": 0,
    "rec_tgt": 4,
    "rush_att": 8,
    "rush_td": 0,
    "rush_yd": 32,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jamaal Williams": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 30,
    "full_name": "jamaalwilliams",
    "first_name": "Jamaal",
    "last_name": "Williams",
    "position": "RB",
    "age": 24,
    "team": "GB",
    "player_id": "4149",
    "my_id": 4149,
    "gp": 16,
    "gs": 8,
    "pts_ppr": 114.4,
    "rec": 27,
    "rec_yd": 210,
    "rec_td": 0,
    "rec_tgt": 41,
    "rush_att": 121,
    "rush_td": 3,
    "rush_yd": 464,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Wayne Gallman": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 22,
    "full_name": "waynegallman",
    "first_name": "Wayne",
    "last_name": "Gallman",
    "position": "RB",
    "age": 25,
    "team": "NYG",
    "player_id": "4150",
    "my_id": 4150,
    "gp": 15,
    "gs": 1,
    "pts_ppr": 44.5,
    "rec": 14,
    "rec_yd": 89,
    "rec_td": 0,
    "rec_tgt": 22,
    "rush_att": 51,
    "rush_td": 1,
    "rush_yd": 176,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Jake Butt": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 80,
    "full_name": "jakebutt",
    "first_name": "Jake",
    "last_name": "Butt",
    "position": "TE",
    "age": 24,
    "team": "DEN",
    "player_id": "4151",
    "my_id": 4151,
    "gp": 3,
    "gs": 3,
    "pts_ppr": 16.5,
    "rec": 8,
    "rec_yd": 85,
    "rec_td": 0,
    "rec_tgt": 12,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Marlon Mack": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 25,
    "full_name": "marlonmack",
    "first_name": "Marlon",
    "last_name": "Mack",
    "position": "RB",
    "age": 23,
    "team": "IND",
    "player_id": "4152",
    "my_id": 4152,
    "gp": 12,
    "gs": 10,
    "pts_ppr": 178.1,
    "rec": 17,
    "rec_yd": 103,
    "rec_td": 1,
    "rec_tgt": 26,
    "rush_att": 195,
    "rush_td": 9,
    "rush_yd": 908,
    "td": 10,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 2
  },
  "Jordan Leggett": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 87,
    "full_name": "jordanleggett",
    "first_name": "Jordan",
    "last_name": "Leggett",
    "position": "TE",
    "age": 24,
    "team": "TB",
    "player_id": "4153",
    "my_id": 4153,
    "gp": 15,
    "gs": 4,
    "pts_ppr": 31.4,
    "rec": 14,
    "rec_yd": 114,
    "rec_td": 1,
    "rec_tgt": 25,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Tarik Cohen": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 29,
    "full_name": "tarikcohen",
    "first_name": "Tarik",
    "last_name": "Cohen",
    "position": "RB",
    "age": 24,
    "team": "CHI",
    "player_id": "4157",
    "my_id": 4157,
    "gp": 16,
    "gs": 7,
    "pts_ppr": 233.94,
    "rec": 71,
    "rec_yd": 725,
    "rec_td": 5,
    "rec_tgt": 91,
    "rush_att": 99,
    "rush_td": 3,
    "rush_yd": 444,
    "td": 8,
    "pass_td": 1,
    "pass_int": 0,
    "pass_cmp": 1,
    "pass_att": 1,
    "pass_yd": 1,
    "pass_inc": 0,
    "fum_lost": 3
  },
  "Josh Malone": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 83,
    "full_name": "joshmalone",
    "first_name": "Josh",
    "last_name": "Malone",
    "position": "WR",
    "age": 23,
    "team": "NYJ",
    "player_id": "4160",
    "my_id": 4160,
    "gp": 9,
    "gs": 0,
    "pts_ppr": 2.2,
    "rec": 1,
    "rec_yd": 12,
    "rec_td": 0,
    "rec_tgt": 5,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Ryan Switzer": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 10,
    "full_name": "ryanswitzer",
    "first_name": "Ryan",
    "last_name": "Switzer",
    "position": "WR",
    "age": 24,
    "team": "PIT",
    "player_id": "4162",
    "my_id": 4162,
    "gp": 16,
    "gs": 1,
    "pts_ppr": 69.4,
    "rec": 36,
    "rec_yd": 253,
    "rec_td": 1,
    "rec_tgt": 44,
    "rush_att": 6,
    "rush_td": 0,
    "rush_yd": 21,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Michael Roberts": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 80,
    "full_name": "michaelroberts",
    "first_name": "Michael",
    "last_name": "Roberts",
    "position": "TE",
    "age": 25,
    "team": null,
    "player_id": "4164",
    "my_id": 4164,
    "gp": 8,
    "gs": 2,
    "pts_ppr": 37,
    "rec": 9,
    "rec_yd": 100,
    "rec_td": 3,
    "rec_tgt": 20,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jehu Chesson": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 16,
    "full_name": "jehuchesson",
    "first_name": "Jehu",
    "last_name": "Chesson",
    "position": "WR",
    "age": 25,
    "team": "WAS",
    "player_id": "4169",
    "my_id": 4169,
    "gp": 6,
    "gs": 0,
    "pts_ppr": 1.3,
    "rec": 1,
    "rec_yd": 7,
    "rec_td": 0,
    "rec_tgt": 2,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": -4,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Josh Reynolds": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 83,
    "full_name": "joshreynolds",
    "first_name": "Josh",
    "last_name": "Reynolds",
    "position": "WR",
    "age": 24,
    "team": "LAR",
    "player_id": "4171",
    "my_id": 4171,
    "gp": 16,
    "gs": 8,
    "pts_ppr": 100,
    "rec": 29,
    "rec_yd": 402,
    "rec_td": 5,
    "rec_tgt": 53,
    "rush_att": 2,
    "rush_td": 0,
    "rush_yd": 8,
    "td": 5,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Joshua Dobbs": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 1,
    "full_name": "joshuadobbs",
    "first_name": "Joshua",
    "last_name": "Dobbs",
    "position": "QB",
    "age": 24,
    "team": "JAX",
    "player_id": "4179",
    "my_id": 4179,
    "gp": 5,
    "gs": 0,
    "pts_ppr": 0.82,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 4,
    "rush_td": 0,
    "rush_yd": 11,
    "td": 0,
    "pass_td": 0,
    "pass_int": 1,
    "pass_cmp": 6,
    "pass_att": 12,
    "pass_yd": 43,
    "pass_inc": 6,
    "fum_lost": 0
  },
  "Nathan Peterman": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 3,
    "full_name": "nathanpeterman",
    "first_name": "Nathan",
    "last_name": "Peterman",
    "position": "QB",
    "age": 25,
    "team": "OAK",
    "player_id": "4183",
    "my_id": 4183,
    "gp": 4,
    "gs": 2,
    "pts_ppr": 12.84,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 10,
    "rush_td": 1,
    "rush_yd": 50,
    "td": 1,
    "pass_td": 1,
    "pass_int": 7,
    "pass_cmp": 44,
    "pass_att": 81,
    "pass_yd": 296,
    "pass_inc": 37,
    "fum_lost": 0
  },
  "TJ Logan": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 22,
    "full_name": "tjlogan",
    "first_name": "TJ",
    "last_name": "Logan",
    "position": "RB",
    "age": 25,
    "team": "TB",
    "player_id": "4186",
    "my_id": 4186,
    "gp": 10,
    "gs": 0,
    "pts_ppr": 10.9,
    "rec": 7,
    "rec_yd": 37,
    "rec_td": 0,
    "rec_tgt": 7,
    "rush_att": 2,
    "rush_td": 0,
    "rush_yd": 2,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Brian Hill": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 23,
    "full_name": "brianhill",
    "first_name": "Brian",
    "last_name": "Hill",
    "position": "RB",
    "age": 23,
    "team": "ATL",
    "player_id": "4187",
    "my_id": 4187,
    "gp": 9,
    "gs": 0,
    "pts_ppr": 15.6,
    "rec": 1,
    "rec_yd": 9,
    "rec_td": 0,
    "rec_tgt": 2,
    "rush_att": 20,
    "rush_td": 0,
    "rush_yd": 157,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Eric Saubert": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 86,
    "full_name": "ericsaubert",
    "first_name": "Eric",
    "last_name": "Saubert",
    "position": "TE",
    "age": 25,
    "team": "OAK",
    "player_id": "4189",
    "my_id": 4189,
    "gp": 16,
    "gs": 1,
    "pts_ppr": 9.8,
    "rec": 5,
    "rec_yd": 48,
    "rec_td": 0,
    "rec_tgt": 9,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Isaiah McKenzie": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 19,
    "full_name": "isaiahmckenzie",
    "first_name": "Isaiah",
    "last_name": "McKenzie",
    "position": "WR",
    "age": 24,
    "team": "BUF",
    "player_id": "4197",
    "my_id": 4197,
    "gp": 8,
    "gs": 1,
    "pts_ppr": 52.5,
    "rec": 18,
    "rec_yd": 179,
    "rec_td": 0,
    "rec_tgt": 30,
    "rush_att": 10,
    "rush_td": 2,
    "rush_yd": 66,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Aaron Jones": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 33,
    "full_name": "aaronjones",
    "first_name": "Aaron",
    "last_name": "Jones",
    "position": "RB",
    "age": 24,
    "team": "GB",
    "player_id": "4199",
    "my_id": 4199,
    "gp": 12,
    "gs": 8,
    "pts_ppr": 171.4,
    "rec": 26,
    "rec_yd": 206,
    "rec_td": 1,
    "rec_tgt": 35,
    "rush_att": 133,
    "rush_td": 8,
    "rush_yd": 728,
    "td": 9,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Shelton Gibson": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 17,
    "full_name": "sheltongibson",
    "first_name": "Shelton",
    "last_name": "Gibson",
    "position": "WR",
    "age": 25,
    "team": "CLE",
    "player_id": "4214",
    "my_id": 4214,
    "gp": 15,
    "gs": 0,
    "pts_ppr": 5.8,
    "rec": 1,
    "rec_yd": 48,
    "rec_td": 0,
    "rec_tgt": 3,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "George Kittle": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 85,
    "full_name": "georgekittle",
    "first_name": "George",
    "last_name": "Kittle",
    "position": "TE",
    "age": 26,
    "team": "SF",
    "player_id": "4217",
    "my_id": 4217,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 258.7,
    "rec": 88,
    "rec_yd": 1377,
    "rec_td": 5,
    "rec_tgt": 136,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 10,
    "td": 5,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Trent Taylor": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 15,
    "full_name": "trenttaylor",
    "first_name": "Trent",
    "last_name": "Taylor",
    "position": "WR",
    "age": 25,
    "team": "SF",
    "player_id": "4218",
    "my_id": 4218,
    "gp": 14,
    "gs": 0,
    "pts_ppr": 55.5,
    "rec": 26,
    "rec_yd": 215,
    "rec_td": 1,
    "rec_tgt": 41,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jeremy McNichols": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 30,
    "full_name": "jeremymcnichols",
    "first_name": "Jeremy",
    "last_name": "McNichols",
    "position": "RB",
    "age": 23,
    "team": null,
    "player_id": "4219",
    "my_id": 4219,
    "gp": 1,
    "gs": 0,
    "pts_ppr": 0.4,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 2,
    "rush_td": 0,
    "rush_yd": 4,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jeremy Sprinkle": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 87,
    "full_name": "jeremysprinkle",
    "first_name": "Jeremy",
    "last_name": "Sprinkle",
    "position": "TE",
    "age": 25,
    "team": "WAS",
    "player_id": "4221",
    "my_id": 4221,
    "gp": 16,
    "gs": 9,
    "pts_ppr": 15.1,
    "rec": 5,
    "rec_yd": 41,
    "rec_td": 1,
    "rec_tgt": 9,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Alex Armah": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 40,
    "full_name": "alexarmah",
    "first_name": "Alex",
    "last_name": "Armah",
    "position": "RB",
    "age": 25,
    "team": "CAR",
    "player_id": "4226",
    "my_id": 4226,
    "gp": 16,
    "gs": 2,
    "pts_ppr": 15,
    "rec": 1,
    "rec_yd": 5,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 9,
    "rush_td": 2,
    "rush_yd": 15,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Mason Schreck": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 86,
    "full_name": "masonschreck",
    "first_name": "Mason",
    "last_name": "Schreck",
    "position": "TE",
    "age": 25,
    "team": "CIN",
    "player_id": "4229",
    "my_id": 4229,
    "gp": 6,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Matt Dayes": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 30,
    "full_name": "mattdayes",
    "first_name": "Matt",
    "last_name": "Dayes",
    "position": "RB",
    "age": 25,
    "team": null,
    "player_id": "4232",
    "my_id": 4232,
    "gp": 6,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Noah Brown": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 85,
    "full_name": "noahbrown",
    "first_name": "Noah",
    "last_name": "Brown",
    "position": "WR",
    "age": 23,
    "team": "DAL",
    "player_id": "4234",
    "my_id": 4234,
    "gp": 8,
    "gs": 2,
    "pts_ppr": 10.4,
    "rec": 5,
    "rec_yd": 54,
    "rec_td": 0,
    "rec_tgt": 8,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "De'Angelo Henderson": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 32,
    "full_name": "deangelohenderson",
    "first_name": "De'Angelo",
    "last_name": "Henderson",
    "position": "RB",
    "age": 26,
    "team": "PHI",
    "player_id": "4239",
    "my_id": 4239,
    "gp": 1,
    "gs": 0,
    "pts_ppr": -0.1,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 2,
    "rush_td": 0,
    "rush_yd": 19,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Isaiah Ford": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 84,
    "full_name": "isaiahford",
    "first_name": "Isaiah",
    "last_name": "Ford",
    "position": "WR",
    "age": 23,
    "team": "MIA",
    "player_id": "4252",
    "my_id": 4252,
    "gp": 1,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Stacy Coley": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 12,
    "full_name": "stacycoley",
    "first_name": "Stacy",
    "last_name": "Coley",
    "position": "WR",
    "age": 25,
    "team": null,
    "player_id": "4254",
    "my_id": 4254,
    "gp": 3,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Elijah McGuire": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 36,
    "full_name": "elijahmcguire",
    "first_name": "Elijah",
    "last_name": "McGuire",
    "position": "RB",
    "age": 25,
    "team": "CLE",
    "player_id": "4263",
    "my_id": 4263,
    "gp": 8,
    "gs": 3,
    "pts_ppr": 85.9,
    "rec": 19,
    "rec_yd": 193,
    "rec_td": 1,
    "rec_tgt": 31,
    "rush_att": 92,
    "rush_td": 3,
    "rush_yd": 276,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 2
  },
  "Chris Carson": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 32,
    "full_name": "chriscarson",
    "first_name": "Chris",
    "last_name": "Carson",
    "position": "RB",
    "age": 25,
    "team": "SEA",
    "player_id": "4273",
    "my_id": 4273,
    "gp": 14,
    "gs": 14,
    "pts_ppr": 201.4,
    "rec": 20,
    "rec_yd": 163,
    "rec_td": 0,
    "rec_tgt": 24,
    "rush_att": 247,
    "rush_td": 9,
    "rush_yd": 1151,
    "td": 9,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 2
  },
  "David Moore": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 83,
    "full_name": "davidmoore",
    "first_name": "David",
    "last_name": "Moore",
    "position": "WR",
    "age": 24,
    "team": "SEA",
    "player_id": "4274",
    "my_id": 4274,
    "gp": 16,
    "gs": 7,
    "pts_ppr": 101,
    "rec": 26,
    "rec_yd": 445,
    "rec_td": 5,
    "rec_tgt": 53,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 5,
    "td": 5,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Deante Burton": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 43,
    "full_name": "deanteburton",
    "first_name": "Deante",
    "last_name": "Burton",
    "position": "WR",
    "age": 25,
    "team": "IND",
    "player_id": "4294",
    "my_id": 4294,
    "gp": 2,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Johnny Mundt": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 82,
    "full_name": "johnnymundt",
    "first_name": "Johnny",
    "last_name": "Mundt",
    "position": "TE",
    "age": 24,
    "team": "LAR",
    "player_id": "4314",
    "my_id": 4314,
    "gp": 10,
    "gs": 0,
    "pts_ppr": 1.5,
    "rec": 1,
    "rec_yd": 5,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Zach Pascal": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 14,
    "full_name": "zachpascal",
    "first_name": "Zach",
    "last_name": "Pascal",
    "position": "WR",
    "age": 24,
    "team": "IND",
    "player_id": "4319",
    "my_id": 4319,
    "gp": 16,
    "gs": 4,
    "pts_ppr": 66.8,
    "rec": 27,
    "rec_yd": 268,
    "rec_td": 2,
    "rec_tgt": 46,
    "rush_att": 2,
    "rush_td": 0,
    "rush_yd": 10,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Darrell Daniels": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 81,
    "full_name": "darrelldaniels",
    "first_name": "Darrell",
    "last_name": "Daniels",
    "position": "TE",
    "age": 24,
    "team": "ARI",
    "player_id": "4323",
    "my_id": 4323,
    "gp": 11,
    "gs": 3,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 2,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jojo Natson": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 19,
    "full_name": "jojonatson",
    "first_name": "Jojo",
    "last_name": "Natson",
    "position": "WR",
    "age": 25,
    "team": "LAR",
    "player_id": "4330",
    "my_id": 4330,
    "gp": 13,
    "gs": 0,
    "pts_ppr": -2,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Taquan Mizzell": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 44,
    "full_name": "taquanmizzell",
    "first_name": "Taquan",
    "last_name": "Mizzell",
    "position": "RB",
    "age": 26,
    "team": "NO",
    "player_id": "4349",
    "my_id": 4349,
    "gp": 9,
    "gs": 1,
    "pts_ppr": 23.4,
    "rec": 8,
    "rec_yd": 78,
    "rec_td": 1,
    "rec_tgt": 10,
    "rush_att": 9,
    "rush_td": 0,
    "rush_yd": 16,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Ricky Ortiz": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 30,
    "full_name": "rickyortiz",
    "first_name": "Ricky",
    "last_name": "Ortiz",
    "position": "RB",
    "age": 25,
    "team": null,
    "player_id": "4350",
    "my_id": 4350,
    "gp": 12,
    "gs": 9,
    "pts_ppr": 4.1,
    "rec": 3,
    "rec_yd": 11,
    "rec_td": 0,
    "rec_tgt": 4,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Tim Patrick": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 81,
    "full_name": "timpatrick",
    "first_name": "Tim",
    "last_name": "Patrick",
    "position": "WR",
    "age": 25,
    "team": "DEN",
    "player_id": "4351",
    "my_id": 4351,
    "gp": 16,
    "gs": 4,
    "pts_ppr": 60.2,
    "rec": 23,
    "rec_yd": 315,
    "rec_td": 1,
    "rec_tgt": 41,
    "rush_att": 3,
    "rush_td": 0,
    "rush_yd": 17,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Tim White": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 6,
    "full_name": "timwhite",
    "first_name": "Tim",
    "last_name": "White",
    "position": "WR",
    "age": 25,
    "team": null,
    "player_id": "4355",
    "my_id": 4355,
    "gp": 3,
    "gs": 0,
    "pts_ppr": 2.4,
    "rec": 1,
    "rec_yd": 14,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Taysom Hill": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 7,
    "full_name": "taysomhill",
    "first_name": "Taysom",
    "last_name": "Hill",
    "position": "QB",
    "age": 29,
    "team": "NO",
    "player_id": "4381",
    "my_id": 4381,
    "gp": 16,
    "gs": 4,
    "pts_ppr": 33.56,
    "rec": 3,
    "rec_yd": 4,
    "rec_td": 0,
    "rec_tgt": 7,
    "rush_att": 37,
    "rush_td": 2,
    "rush_yd": 196,
    "td": 2,
    "pass_td": 0,
    "pass_int": 1,
    "pass_cmp": 3,
    "pass_att": 7,
    "pass_yd": 64,
    "pass_inc": 2,
    "fum_lost": 1
  },
  "Austin Carr": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 80,
    "full_name": "austincarr",
    "first_name": "Austin",
    "last_name": "Carr",
    "position": "WR",
    "age": 25,
    "team": "NO",
    "player_id": "4416",
    "my_id": 4416,
    "gp": 14,
    "gs": 2,
    "pts_ppr": 30.7,
    "rec": 9,
    "rec_yd": 97,
    "rec_td": 2,
    "rec_tgt": 14,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jacob Hollister": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 48,
    "full_name": "jacobhollister",
    "first_name": "Jacob",
    "last_name": "Hollister",
    "position": "TE",
    "age": 25,
    "team": "SEA",
    "player_id": "4421",
    "my_id": 4421,
    "gp": 8,
    "gs": 1,
    "pts_ppr": 9.2,
    "rec": 4,
    "rec_yd": 52,
    "rec_td": 0,
    "rec_tgt": 5,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Anthony Firkser": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 86,
    "full_name": "anthonyfirkser",
    "first_name": "Anthony",
    "last_name": "Firkser",
    "position": "TE",
    "age": 24,
    "team": "TEN",
    "player_id": "4435",
    "my_id": 4435,
    "gp": 10,
    "gs": 0,
    "pts_ppr": 47.5,
    "rec": 19,
    "rec_yd": 225,
    "rec_td": 1,
    "rec_tgt": 20,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Keon Hatcher": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 84,
    "full_name": "keonhatcher",
    "first_name": "Keon",
    "last_name": "Hatcher",
    "position": "WR",
    "age": 25,
    "team": "GB",
    "player_id": "4445",
    "my_id": 4445,
    "gp": 3,
    "gs": 0,
    "pts_ppr": 1.8,
    "rec": 1,
    "rec_yd": 8,
    "rec_td": 0,
    "rec_tgt": 2,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Victor Bolden Jr.": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 13,
    "full_name": "victorboldenjr",
    "first_name": "Victor",
    "last_name": "Bolden Jr.",
    "position": "WR",
    "age": 24,
    "team": null,
    "player_id": "4453",
    "my_id": 4453,
    "gp": 6,
    "gs": 0,
    "pts_ppr": 2,
    "rec": 1,
    "rec_yd": 10,
    "rec_td": 0,
    "rec_tgt": 4,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Kendrick Bourne": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 84,
    "full_name": "kendrickbourne",
    "first_name": "Kendrick",
    "last_name": "Bourne",
    "position": "WR",
    "age": 24,
    "team": "SF",
    "player_id": "4454",
    "my_id": 4454,
    "gp": 16,
    "gs": 8,
    "pts_ppr": 114.7,
    "rec": 42,
    "rec_yd": 487,
    "rec_td": 4,
    "rec_tgt": 66,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Matt Breida": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 22,
    "full_name": "mattbreida",
    "first_name": "Matt",
    "last_name": "Breida",
    "position": "RB",
    "age": 24,
    "team": "SF",
    "player_id": "4455",
    "my_id": 4455,
    "gp": 14,
    "gs": 13,
    "pts_ppr": 162.5,
    "rec": 27,
    "rec_yd": 261,
    "rec_td": 2,
    "rec_tgt": 31,
    "rush_att": 153,
    "rush_td": 3,
    "rush_yd": 814,
    "td": 5,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Nick Mullens": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 4,
    "full_name": "nickmullens",
    "first_name": "Nick",
    "last_name": "Mullens",
    "position": "QB",
    "age": 24,
    "team": "SF",
    "player_id": "4464",
    "my_id": 4464,
    "gp": 8,
    "gs": 8,
    "pts_ppr": 123.48,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 18,
    "rush_td": 0,
    "rush_yd": -16,
    "td": 0,
    "pass_td": 13,
    "pass_int": 10,
    "pass_cmp": 176,
    "pass_att": 274,
    "pass_yd": 2277,
    "pass_inc": 98,
    "fum_lost": 0
  },
  "Antony Auclair": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 82,
    "full_name": "antonyauclair",
    "first_name": "Antony",
    "last_name": "Auclair",
    "position": "TE",
    "age": 26,
    "team": "TB",
    "player_id": "4468",
    "my_id": 4468,
    "gp": 16,
    "gs": 10,
    "pts_ppr": 11.8,
    "rec": 7,
    "rec_yd": 48,
    "rec_td": 0,
    "rec_tgt": 8,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jesus Wilson": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 85,
    "full_name": "jesuswilson",
    "first_name": "Jesus",
    "last_name": "Wilson",
    "position": "WR",
    "age": 24,
    "team": "TB",
    "player_id": "4480",
    "my_id": 4480,
    "gp": 5,
    "gs": 0,
    "pts_ppr": 9.2,
    "rec": 4,
    "rec_yd": 52,
    "rec_td": 0,
    "rec_tgt": 5,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Gehrig Dieter": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 12,
    "full_name": "gehrigdieter",
    "first_name": "Gehrig",
    "last_name": "Dieter",
    "position": "WR",
    "age": 26,
    "team": null,
    "player_id": "4489",
    "my_id": 4489,
    "gp": 4,
    "gs": 0,
    "pts_ppr": 3.2,
    "rec": 1,
    "rec_yd": 22,
    "rec_td": 0,
    "rec_tgt": 3,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Marcus Kemp": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 19,
    "full_name": "marcuskemp",
    "first_name": "Marcus",
    "last_name": "Kemp",
    "position": "WR",
    "age": 24,
    "team": "KC",
    "player_id": "4491",
    "my_id": 4491,
    "gp": 16,
    "gs": 0,
    "pts_ppr": 1.7,
    "rec": 1,
    "rec_yd": 7,
    "rec_td": 0,
    "rec_tgt": 2,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Ricky Seals-Jones": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 83,
    "full_name": "rickysealsjones",
    "first_name": "Ricky",
    "last_name": "Seals-Jones",
    "position": "TE",
    "age": 24,
    "team": "CLE",
    "player_id": "4531",
    "my_id": 4531,
    "gp": 15,
    "gs": 5,
    "pts_ppr": 74.3,
    "rec": 34,
    "rec_yd": 343,
    "rec_td": 1,
    "rec_tgt": 70,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jason Croom": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 80,
    "full_name": "jasoncroom",
    "first_name": "Jason",
    "last_name": "Croom",
    "position": "TE",
    "age": 25,
    "team": "BUF",
    "player_id": "4536",
    "my_id": 4536,
    "gp": 15,
    "gs": 3,
    "pts_ppr": 55.9,
    "rec": 22,
    "rec_yd": 259,
    "rec_td": 1,
    "rec_tgt": 35,
    "rush_att": 0,
    "rush_td": 1,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 2
  },
  "Blake Jarwin": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 89,
    "full_name": "blakejarwin",
    "first_name": "Blake",
    "last_name": "Jarwin",
    "position": "TE",
    "age": 25,
    "team": "DAL",
    "player_id": "4571",
    "my_id": 4571,
    "gp": 16,
    "gs": 4,
    "pts_ppr": 75.7,
    "rec": 27,
    "rec_yd": 307,
    "rec_td": 3,
    "rec_tgt": 36,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Cooper Rush": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 7,
    "full_name": "cooperrush",
    "first_name": "Cooper",
    "last_name": "Rush",
    "position": "QB",
    "age": 25,
    "team": "DAL",
    "player_id": "4574",
    "my_id": 4574,
    "gp": 1,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Robert Tonyan Jr.": {
    "fantasy_positions": [
      "WR",
      "TE"
    ],
    "year": 2018,
    "number": 85,
    "full_name": "roberttonyanjr",
    "first_name": "Robert",
    "last_name": "Tonyan Jr.",
    "position": "TE",
    "age": 25,
    "team": "GB",
    "player_id": "4602",
    "my_id": 4602,
    "gp": 16,
    "gs": 1,
    "pts_ppr": 17.7,
    "rec": 4,
    "rec_yd": 77,
    "rec_td": 1,
    "rec_tgt": 6,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Justin Hardee": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 34,
    "full_name": "justinhardee",
    "first_name": "Justin",
    "last_name": "Hardee",
    "position": "WR",
    "age": 25,
    "team": "NO",
    "player_id": "4611",
    "my_id": 4611,
    "gp": 16,
    "gs": 0,
    "pts_ppr": 2,
    "rec": 1,
    "rec_yd": 10,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Riley McCarron": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 17,
    "full_name": "rileymccarron",
    "first_name": "Riley",
    "last_name": "McCarron",
    "position": "WR",
    "age": 26,
    "team": null,
    "player_id": "4614",
    "my_id": 4614,
    "gp": 1,
    "gs": 0,
    "pts_ppr": -2,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Keelan Cole": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 84,
    "full_name": "keelancole",
    "first_name": "Keelan",
    "last_name": "Cole",
    "position": "WR",
    "age": 26,
    "team": "JAX",
    "player_id": "4622",
    "my_id": 4622,
    "gp": 16,
    "gs": 11,
    "pts_ppr": 89.1,
    "rec": 38,
    "rec_yd": 491,
    "rec_td": 1,
    "rec_tgt": 70,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 2
  },
  "Justin Davis": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 39,
    "full_name": "justindavis",
    "first_name": "Justin",
    "last_name": "Davis",
    "position": "RB",
    "age": 23,
    "team": "ARI",
    "player_id": "4635",
    "my_id": 4635,
    "gp": 11,
    "gs": 0,
    "pts_ppr": 1.9,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 2,
    "rush_td": 0,
    "rush_yd": 19,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Corey Clement": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 30,
    "full_name": "coreyclement",
    "first_name": "Corey",
    "last_name": "Clement",
    "position": "RB",
    "age": 24,
    "team": "PHI",
    "player_id": "4651",
    "my_id": 4651,
    "gp": 11,
    "gs": 0,
    "pts_ppr": 81.1,
    "rec": 22,
    "rec_yd": 192,
    "rec_td": 0,
    "rec_tgt": 25,
    "rush_att": 68,
    "rush_td": 2,
    "rush_yd": 259,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Sean Culkin": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 80,
    "full_name": "seanculkin",
    "first_name": "Sean",
    "last_name": "Culkin",
    "position": "TE",
    "age": 26,
    "team": "LAC",
    "player_id": "4660",
    "my_id": 4660,
    "gp": 13,
    "gs": 10,
    "pts_ppr": 3.4,
    "rec": 1,
    "rec_yd": 24,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Austin Ekeler": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 30,
    "full_name": "austinekeler",
    "first_name": "Austin",
    "last_name": "Ekeler",
    "position": "RB",
    "age": 24,
    "team": "LAC",
    "player_id": "4663",
    "my_id": 4663,
    "gp": 14,
    "gs": 3,
    "pts_ppr": 168.8,
    "rec": 39,
    "rec_yd": 404,
    "rec_td": 3,
    "rec_tgt": 53,
    "rush_att": 106,
    "rush_td": 3,
    "rush_yd": 554,
    "td": 6,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Tyrone Swoopes": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 46,
    "full_name": "tyroneswoopes",
    "first_name": "Tyrone",
    "last_name": "Swoopes",
    "position": "TE",
    "age": 24,
    "team": null,
    "player_id": "4678",
    "my_id": 4678,
    "gp": 1,
    "gs": 1,
    "pts_ppr": 3.3,
    "rec": 1,
    "rec_yd": 23,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Trey Edmunds": {
    "fantasy_positions": [
      "TE",
      "RB"
    ],
    "year": 2018,
    "number": 33,
    "full_name": "treyedmunds",
    "first_name": "Trey",
    "last_name": "Edmunds",
    "position": "RB",
    "age": 24,
    "team": "PIT",
    "player_id": "4696",
    "my_id": 4696,
    "gp": 4,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Dare Ogunbowale": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 44,
    "full_name": "dareogunbowale",
    "first_name": "Dare",
    "last_name": "Ogunbowale",
    "position": "RB",
    "age": 25,
    "team": "TB",
    "player_id": "4718",
    "my_id": 4718,
    "gp": 2,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Dan Arnold": {
    "fantasy_positions": [
      "WR",
      "TE"
    ],
    "year": 2018,
    "number": 85,
    "full_name": "danarnold",
    "first_name": "Dan",
    "last_name": "Arnold",
    "position": "TE",
    "age": 24,
    "team": "NO",
    "player_id": "4741",
    "my_id": 4741,
    "gp": 10,
    "gs": 1,
    "pts_ppr": 33,
    "rec": 12,
    "rec_yd": 150,
    "rec_td": 1,
    "rec_tgt": 19,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Lance Lenoir": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 14,
    "full_name": "lancelenoir",
    "first_name": "Lance",
    "last_name": "Lenoir",
    "position": "WR",
    "age": 24,
    "team": "DAL",
    "player_id": "4750",
    "my_id": 4750,
    "gp": 7,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "River Cracraft": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 12,
    "full_name": "rivercracraft",
    "first_name": "River",
    "last_name": "Cracraft",
    "position": "WR",
    "age": 24,
    "team": null,
    "player_id": "4854",
    "my_id": 4854,
    "gp": 8,
    "gs": 0,
    "pts_ppr": 3.4,
    "rec": 1,
    "rec_yd": 44,
    "rec_td": 0,
    "rec_tgt": 2,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Josh Rosen": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 3,
    "full_name": "joshrosen",
    "first_name": "Josh",
    "last_name": "Rosen",
    "position": "QB",
    "age": 22,
    "team": "MIA",
    "player_id": "4863",
    "my_id": 4863,
    "gp": 14,
    "gs": 13,
    "pts_ppr": 112.92,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 23,
    "rush_td": 0,
    "rush_yd": 138,
    "td": 0,
    "pass_td": 11,
    "pass_int": 14,
    "pass_cmp": 217,
    "pass_att": 393,
    "pass_yd": 2278,
    "pass_inc": 176,
    "fum_lost": 5
  },
  "Saquon Barkley": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 26,
    "full_name": "saquonbarkley",
    "first_name": "Saquon",
    "last_name": "Barkley",
    "position": "RB",
    "age": 22,
    "team": "NYG",
    "player_id": "4866",
    "my_id": 4866,
    "gp": 16,
    "gs": 16,
    "pts_ppr": 385.8,
    "rec": 91,
    "rec_yd": 721,
    "rec_td": 4,
    "rec_tgt": 121,
    "rush_att": 261,
    "rush_td": 11,
    "rush_yd": 1307,
    "td": 15,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Brandon Zylstra": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 11,
    "full_name": "brandonzylstra",
    "first_name": "Brandon",
    "last_name": "Zylstra",
    "position": "WR",
    "age": 26,
    "team": "CAR",
    "player_id": "4878",
    "my_id": 4878,
    "gp": 16,
    "gs": 0,
    "pts_ppr": 3.3,
    "rec": 1,
    "rec_yd": 23,
    "rec_td": 0,
    "rec_tgt": 2,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Lamar Jackson": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 8,
    "full_name": "lamarjackson",
    "first_name": "Lamar",
    "last_name": "Jackson",
    "position": "QB",
    "age": 22,
    "team": "BAL",
    "player_id": "4881",
    "my_id": 4881,
    "gp": 16,
    "gs": 7,
    "pts_ppr": 157.54,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 2,
    "rush_att": 147,
    "rush_td": 5,
    "rush_yd": 695,
    "td": 5,
    "pass_td": 6,
    "pass_int": 3,
    "pass_cmp": 99,
    "pass_att": 170,
    "pass_yd": 1201,
    "pass_inc": 70,
    "fum_lost": 4
  },
  "Baker Mayfield": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 6,
    "full_name": "bakermayfield",
    "first_name": "Baker",
    "last_name": "Mayfield",
    "position": "QB",
    "age": 24,
    "team": "CLE",
    "player_id": "4892",
    "my_id": 4892,
    "gp": 14,
    "gs": 13,
    "pts_ppr": 240.1,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 39,
    "rush_td": 0,
    "rush_yd": 131,
    "td": 0,
    "pass_td": 27,
    "pass_int": 14,
    "pass_cmp": 310,
    "pass_att": 486,
    "pass_yd": 3725,
    "pass_inc": 176,
    "fum_lost": 3
  },
  "Marcell Ateman": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 88,
    "full_name": "marcellateman",
    "first_name": "Marcell",
    "last_name": "Ateman",
    "position": "WR",
    "age": 25,
    "team": "OAK",
    "player_id": "4942",
    "my_id": 4942,
    "gp": 7,
    "gs": 6,
    "pts_ppr": 36.4,
    "rec": 15,
    "rec_yd": 154,
    "rec_td": 1,
    "rec_tgt": 31,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Sam Darnold": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 14,
    "full_name": "samdarnold",
    "first_name": "Sam",
    "last_name": "Darnold",
    "position": "QB",
    "age": 22,
    "team": "NYJ",
    "player_id": "4943",
    "my_id": 4943,
    "gp": 13,
    "gs": 13,
    "pts_ppr": 168.4,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 44,
    "rush_td": 1,
    "rush_yd": 138,
    "td": 1,
    "pass_td": 17,
    "pass_int": 15,
    "pass_cmp": 239,
    "pass_att": 414,
    "pass_yd": 2865,
    "pass_inc": 175,
    "fum_lost": 2
  },
  "Christian Kirk": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 13,
    "full_name": "christiankirk",
    "first_name": "Christian",
    "last_name": "Kirk",
    "position": "WR",
    "age": 22,
    "team": "ARI",
    "player_id": "4950",
    "my_id": 4950,
    "gp": 12,
    "gs": 7,
    "pts_ppr": 123.5,
    "rec": 43,
    "rec_yd": 590,
    "rec_td": 3,
    "rec_tgt": 68,
    "rush_att": 3,
    "rush_td": 0,
    "rush_yd": 35,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "D.J. Chark": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 17,
    "full_name": "djchark",
    "first_name": "D.J.",
    "last_name": "Chark",
    "position": "WR",
    "age": 23,
    "team": "JAX",
    "player_id": "4951",
    "my_id": 4951,
    "gp": 11,
    "gs": 0,
    "pts_ppr": 29.4,
    "rec": 14,
    "rec_yd": 174,
    "rec_td": 0,
    "rec_tgt": 32,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Sony Michel": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 26,
    "full_name": "sonymichel",
    "first_name": "Sony",
    "last_name": "Michel",
    "position": "RB",
    "age": 24,
    "team": "NE",
    "player_id": "4962",
    "my_id": 4962,
    "gp": 13,
    "gs": 8,
    "pts_ppr": 139.1,
    "rec": 7,
    "rec_yd": 50,
    "rec_td": 0,
    "rec_tgt": 11,
    "rush_att": 209,
    "rush_td": 6,
    "rush_yd": 931,
    "td": 6,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Hayden Hurst": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 81,
    "full_name": "haydenhurst",
    "first_name": "Hayden",
    "last_name": "Hurst",
    "position": "TE",
    "age": 26,
    "team": "BAL",
    "player_id": "4973",
    "my_id": 4973,
    "gp": 12,
    "gs": 0,
    "pts_ppr": 35.3,
    "rec": 13,
    "rec_yd": 163,
    "rec_td": 1,
    "rec_tgt": 23,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Calvin Ridley": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 18,
    "full_name": "calvinridley",
    "first_name": "Calvin",
    "last_name": "Ridley",
    "position": "WR",
    "age": 24,
    "team": "ATL",
    "player_id": "4981",
    "my_id": 4981,
    "gp": 16,
    "gs": 5,
    "pts_ppr": 206.8,
    "rec": 64,
    "rec_yd": 821,
    "rec_td": 10,
    "rec_tgt": 92,
    "rush_att": 6,
    "rush_td": 0,
    "rush_yd": 27,
    "td": 10,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "D.J. Moore": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 12,
    "full_name": "djmoore",
    "first_name": "D.J.",
    "last_name": "Moore",
    "position": "WR",
    "age": 22,
    "team": "CAR",
    "player_id": "4983",
    "my_id": 4983,
    "gp": 16,
    "gs": 10,
    "pts_ppr": 157,
    "rec": 55,
    "rec_yd": 788,
    "rec_td": 2,
    "rec_tgt": 82,
    "rush_att": 13,
    "rush_td": 0,
    "rush_yd": 172,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 3
  },
  "Josh Allen": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 17,
    "full_name": "joshallen",
    "first_name": "Josh",
    "last_name": "Allen",
    "position": "QB",
    "age": 23,
    "team": "BUF",
    "player_id": "4984",
    "my_id": 4984,
    "gp": 12,
    "gs": 11,
    "pts_ppr": 208.06,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 89,
    "rush_td": 8,
    "rush_yd": 631,
    "td": 8,
    "pass_td": 10,
    "pass_int": 12,
    "pass_cmp": 169,
    "pass_att": 320,
    "pass_yd": 2074,
    "pass_inc": 151,
    "fum_lost": 2
  },
  "Rashaad Penny": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 20,
    "full_name": "rashaadpenny",
    "first_name": "Rashaad",
    "last_name": "Penny",
    "position": "RB",
    "age": 23,
    "team": "SEA",
    "player_id": "4985",
    "my_id": 4985,
    "gp": 14,
    "gs": 0,
    "pts_ppr": 70.4,
    "rec": 9,
    "rec_yd": 75,
    "rec_td": 0,
    "rec_tgt": 12,
    "rush_att": 85,
    "rush_td": 2,
    "rush_yd": 419,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Nick Chubb": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 24,
    "full_name": "nickchubb",
    "first_name": "Nick",
    "last_name": "Chubb",
    "position": "RB",
    "age": 23,
    "team": "CLE",
    "player_id": "4988",
    "my_id": 4988,
    "gp": 16,
    "gs": 9,
    "pts_ppr": 194.5,
    "rec": 20,
    "rec_yd": 149,
    "rec_td": 2,
    "rec_tgt": 29,
    "rush_att": 192,
    "rush_td": 8,
    "rush_yd": 996,
    "td": 10,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Dante Pettis": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 18,
    "full_name": "dantepettis",
    "first_name": "Dante",
    "last_name": "Pettis",
    "position": "WR",
    "age": 23,
    "team": "SF",
    "player_id": "4992",
    "my_id": 4992,
    "gp": 12,
    "gs": 7,
    "pts_ppr": 103.5,
    "rec": 27,
    "rec_yd": 467,
    "rec_td": 5,
    "rec_tgt": 45,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": -2,
    "td": 5,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Mike Gesicki": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 88,
    "full_name": "mikegesicki",
    "first_name": "Mike",
    "last_name": "Gesicki",
    "position": "TE",
    "age": 24,
    "team": "MIA",
    "player_id": "4993",
    "my_id": 4993,
    "gp": 16,
    "gs": 6,
    "pts_ppr": 40.2,
    "rec": 22,
    "rec_yd": 202,
    "rec_td": 0,
    "rec_tgt": 32,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Kalen Ballage": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 27,
    "full_name": "kalenballage",
    "first_name": "Kalen",
    "last_name": "Ballage",
    "position": "RB",
    "age": 23,
    "team": "MIA",
    "player_id": "4994",
    "my_id": 4994,
    "gp": 12,
    "gs": 0,
    "pts_ppr": 37.7,
    "rec": 9,
    "rec_yd": 56,
    "rec_td": 0,
    "rec_tgt": 11,
    "rush_att": 36,
    "rush_td": 1,
    "rush_yd": 191,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Ian Thomas": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 80,
    "full_name": "ianthomas",
    "first_name": "Ian",
    "last_name": "Thomas",
    "position": "TE",
    "age": 23,
    "team": "CAR",
    "player_id": "4995",
    "my_id": 4995,
    "gp": 16,
    "gs": 6,
    "pts_ppr": 81.3,
    "rec": 36,
    "rec_yd": 333,
    "rec_td": 2,
    "rec_tgt": 49,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Kyle Lauletta": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 8,
    "full_name": "kylelauletta",
    "first_name": "Kyle",
    "last_name": "Lauletta",
    "position": "QB",
    "age": 24,
    "team": "PHI",
    "player_id": "4996",
    "my_id": 4996,
    "gp": 2,
    "gs": 0,
    "pts_ppr": -2.2,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": -2,
    "td": 0,
    "pass_td": 0,
    "pass_int": 1,
    "pass_cmp": 0,
    "pass_att": 5,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Mark Walton": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 22,
    "full_name": "markwalton",
    "first_name": "Mark",
    "last_name": "Walton",
    "position": "RB",
    "age": 22,
    "team": "MIA",
    "player_id": "4997",
    "my_id": 4997,
    "gp": 14,
    "gs": 0,
    "pts_ppr": 12.5,
    "rec": 5,
    "rec_yd": 41,
    "rec_td": 0,
    "rec_tgt": 8,
    "rush_att": 14,
    "rush_td": 0,
    "rush_yd": 34,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Daesean Hamilton": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 17,
    "full_name": "daeseanhamilton",
    "first_name": "Daesean",
    "last_name": "Hamilton",
    "position": "WR",
    "age": 24,
    "team": "DEN",
    "player_id": "4998",
    "my_id": 4998,
    "gp": 14,
    "gs": 5,
    "pts_ppr": 66.3,
    "rec": 30,
    "rec_yd": 243,
    "rec_td": 2,
    "rec_tgt": 46,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Chase Edmonds": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 29,
    "full_name": "chaseedmonds",
    "first_name": "Chase",
    "last_name": "Edmonds",
    "position": "RB",
    "age": 23,
    "team": "ARI",
    "player_id": "5000",
    "my_id": 5000,
    "gp": 16,
    "gs": 0,
    "pts_ppr": 63.1,
    "rec": 20,
    "rec_yd": 103,
    "rec_td": 0,
    "rec_tgt": 23,
    "rush_att": 60,
    "rush_td": 2,
    "rush_yd": 208,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Dalton Schultz": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 86,
    "full_name": "daltonschultz",
    "first_name": "Dalton",
    "last_name": "Schultz",
    "position": "TE",
    "age": 23,
    "team": "DAL",
    "player_id": "5001",
    "my_id": 5001,
    "gp": 11,
    "gs": 7,
    "pts_ppr": 23.6,
    "rec": 12,
    "rec_yd": 116,
    "rec_td": 0,
    "rec_tgt": 17,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Ito Smith": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 25,
    "full_name": "itosmith",
    "first_name": "Ito",
    "last_name": "Smith",
    "position": "RB",
    "age": 24,
    "team": "ATL",
    "player_id": "5004",
    "my_id": 5004,
    "gp": 14,
    "gs": 0,
    "pts_ppr": 97.7,
    "rec": 27,
    "rec_yd": 152,
    "rec_td": 0,
    "rec_tgt": 32,
    "rush_att": 90,
    "rush_td": 4,
    "rush_yd": 315,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "J'mon Moore": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 82,
    "full_name": "jmonmoore",
    "first_name": "J'mon",
    "last_name": "Moore",
    "position": "WR",
    "age": 24,
    "team": null,
    "player_id": "5006",
    "my_id": 5006,
    "gp": 12,
    "gs": 0,
    "pts_ppr": 1.5,
    "rec": 2,
    "rec_yd": 15,
    "rec_td": 0,
    "rec_tgt": 3,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Keke Coutee": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 16,
    "full_name": "kekecoutee",
    "first_name": "Keke",
    "last_name": "Coutee",
    "position": "WR",
    "age": 22,
    "team": "HOU",
    "player_id": "5007",
    "my_id": 5007,
    "gp": 6,
    "gs": 2,
    "pts_ppr": 62.7,
    "rec": 28,
    "rec_yd": 287,
    "rec_td": 1,
    "rec_tgt": 41,
    "rush_att": 3,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Durham Smythe": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 81,
    "full_name": "durhamsmythe",
    "first_name": "Durham",
    "last_name": "Smythe",
    "position": "TE",
    "age": 24,
    "team": "MIA",
    "player_id": "5008",
    "my_id": 5008,
    "gp": 15,
    "gs": 2,
    "pts_ppr": 11,
    "rec": 6,
    "rec_yd": 50,
    "rec_td": 0,
    "rec_tgt": 11,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Chris Herndon IV": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 89,
    "full_name": "chrisherndoniv",
    "first_name": "Chris",
    "last_name": "Herndon IV",
    "position": "TE",
    "age": 23,
    "team": "NYJ",
    "player_id": "5009",
    "my_id": 5009,
    "gp": 14,
    "gs": 7,
    "pts_ppr": 113.2,
    "rec": 39,
    "rec_yd": 502,
    "rec_td": 4,
    "rec_tgt": 56,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Will Dissly": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 88,
    "full_name": "willdissly",
    "first_name": "Will",
    "last_name": "Dissly",
    "position": "TE",
    "age": 23,
    "team": "SEA",
    "player_id": "5010",
    "my_id": 5010,
    "gp": 4,
    "gs": 4,
    "pts_ppr": 35.6,
    "rec": 8,
    "rec_yd": 156,
    "rec_td": 2,
    "rec_tgt": 14,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Mark Andrews": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 89,
    "full_name": "markandrews",
    "first_name": "Mark",
    "last_name": "Andrews",
    "position": "TE",
    "age": 24,
    "team": "BAL",
    "player_id": "5012",
    "my_id": 5012,
    "gp": 16,
    "gs": 3,
    "pts_ppr": 107.2,
    "rec": 34,
    "rec_yd": 552,
    "rec_td": 3,
    "rec_tgt": 50,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Anthony Miller": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 17,
    "full_name": "anthonymiller",
    "first_name": "Anthony",
    "last_name": "Miller",
    "position": "WR",
    "age": 25,
    "team": "CHI",
    "player_id": "5013",
    "my_id": 5013,
    "gp": 15,
    "gs": 4,
    "pts_ppr": 120.22,
    "rec": 33,
    "rec_yd": 423,
    "rec_td": 7,
    "rec_tgt": 54,
    "rush_att": 6,
    "rush_td": 0,
    "rush_yd": 26,
    "td": 7,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 1,
    "pass_att": 1,
    "pass_yd": 8,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Dallas Goedert": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 88,
    "full_name": "dallasgoedert",
    "first_name": "Dallas",
    "last_name": "Goedert",
    "position": "TE",
    "age": 24,
    "team": "PHI",
    "player_id": "5022",
    "my_id": 5022,
    "gp": 16,
    "gs": 8,
    "pts_ppr": 90.4,
    "rec": 33,
    "rec_yd": 334,
    "rec_td": 4,
    "rec_tgt": 44,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "James Washington": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 13,
    "full_name": "jameswashington",
    "first_name": "James",
    "last_name": "Washington",
    "position": "WR",
    "age": 23,
    "team": "PIT",
    "player_id": "5024",
    "my_id": 5024,
    "gp": 14,
    "gs": 6,
    "pts_ppr": 43.7,
    "rec": 16,
    "rec_yd": 217,
    "rec_td": 1,
    "rec_tgt": 38,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Tre'Quan Smith": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 10,
    "full_name": "trequansmith",
    "first_name": "Tre'Quan",
    "last_name": "Smith",
    "position": "WR",
    "age": 23,
    "team": "NO",
    "player_id": "5026",
    "my_id": 5026,
    "gp": 15,
    "gs": 7,
    "pts_ppr": 100.7,
    "rec": 28,
    "rec_yd": 427,
    "rec_td": 5,
    "rec_tgt": 44,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 5,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jordan Akins": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 88,
    "full_name": "jordanakins",
    "first_name": "Jordan",
    "last_name": "Akins",
    "position": "TE",
    "age": 27,
    "team": "HOU",
    "player_id": "5032",
    "my_id": 5032,
    "gp": 16,
    "gs": 6,
    "pts_ppr": 39.5,
    "rec": 17,
    "rec_yd": 225,
    "rec_td": 0,
    "rec_tgt": 25,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Michael Gallup": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 13,
    "full_name": "michaelgallup",
    "first_name": "Michael",
    "last_name": "Gallup",
    "position": "WR",
    "age": 23,
    "team": "DAL",
    "player_id": "5038",
    "my_id": 5038,
    "gp": 16,
    "gs": 8,
    "pts_ppr": 97.7,
    "rec": 33,
    "rec_yd": 507,
    "rec_td": 2,
    "rec_tgt": 68,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Courtland Sutton": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 14,
    "full_name": "courtlandsutton",
    "first_name": "Courtland",
    "last_name": "Sutton",
    "position": "WR",
    "age": 24,
    "team": "DEN",
    "player_id": "5045",
    "my_id": 5045,
    "gp": 16,
    "gs": 9,
    "pts_ppr": 136.3,
    "rec": 42,
    "rec_yd": 704,
    "rec_td": 4,
    "rec_tgt": 84,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": -1,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Royce Freeman": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 28,
    "full_name": "roycefreeman",
    "first_name": "Royce",
    "last_name": "Freeman",
    "position": "RB",
    "age": 23,
    "team": "DEN",
    "player_id": "5046",
    "my_id": 5046,
    "gp": 14,
    "gs": 8,
    "pts_ppr": 101.3,
    "rec": 14,
    "rec_yd": 72,
    "rec_td": 0,
    "rec_tgt": 20,
    "rush_att": 130,
    "rush_td": 5,
    "rush_yd": 521,
    "td": 5,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Ronald Jones II": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 27,
    "full_name": "ronaldjonesii",
    "first_name": "Ronald",
    "last_name": "Jones II",
    "position": "RB",
    "age": 22,
    "team": "TB",
    "player_id": "5052",
    "my_id": 5052,
    "gp": 9,
    "gs": 0,
    "pts_ppr": 20.7,
    "rec": 7,
    "rec_yd": 33,
    "rec_td": 0,
    "rec_tgt": 9,
    "rush_att": 23,
    "rush_td": 1,
    "rush_yd": 44,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Kerryon Johnson": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 33,
    "full_name": "kerryonjohnson",
    "first_name": "Kerryon",
    "last_name": "Johnson",
    "position": "RB",
    "age": 22,
    "team": "DET",
    "player_id": "5068",
    "my_id": 5068,
    "gp": 10,
    "gs": 7,
    "pts_ppr": 139.4,
    "rec": 32,
    "rec_yd": 213,
    "rec_td": 1,
    "rec_tgt": 39,
    "rush_att": 118,
    "rush_td": 3,
    "rush_yd": 641,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "John Kelly": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 42,
    "full_name": "johnkelly",
    "first_name": "John",
    "last_name": "Kelly",
    "position": "RB",
    "age": 23,
    "team": "LAR",
    "player_id": "5076",
    "my_id": 5076,
    "gp": 4,
    "gs": 0,
    "pts_ppr": 12.1,
    "rec": 2,
    "rec_yd": 27,
    "rec_td": 0,
    "rec_tgt": 3,
    "rush_att": 27,
    "rush_td": 0,
    "rush_yd": 74,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Damion Ratley": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 18,
    "full_name": "damionratley",
    "first_name": "Damion",
    "last_name": "Ratley",
    "position": "WR",
    "age": 24,
    "team": "CLE",
    "player_id": "5080",
    "my_id": 5080,
    "gp": 13,
    "gs": 3,
    "pts_ppr": 27.4,
    "rec": 13,
    "rec_yd": 144,
    "rec_td": 0,
    "rec_tgt": 20,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Marquez Valdes-Scantling": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 83,
    "full_name": "marquezvaldesscantling",
    "first_name": "Marquez",
    "last_name": "Valdes-Scantling",
    "position": "WR",
    "age": 25,
    "team": "GB",
    "player_id": "5086",
    "my_id": 5086,
    "gp": 16,
    "gs": 10,
    "pts_ppr": 111,
    "rec": 38,
    "rec_yd": 581,
    "rec_td": 2,
    "rec_tgt": 72,
    "rush_att": 2,
    "rush_td": 0,
    "rush_yd": 29,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Tyler Conklin": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 83,
    "full_name": "tylerconklin",
    "first_name": "Tyler",
    "last_name": "Conklin",
    "position": "TE",
    "age": 24,
    "team": "MIN",
    "player_id": "5094",
    "my_id": 5094,
    "gp": 16,
    "gs": 0,
    "pts_ppr": 12.7,
    "rec": 5,
    "rec_yd": 77,
    "rec_td": 0,
    "rec_tgt": 7,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Ray-Ray McCloud": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 14,
    "full_name": "rayraymccloud",
    "first_name": "Ray-Ray",
    "last_name": "McCloud",
    "position": "WR",
    "age": 23,
    "team": "CAR",
    "player_id": "5096",
    "my_id": 5096,
    "gp": 10,
    "gs": 1,
    "pts_ppr": 7,
    "rec": 5,
    "rec_yd": 36,
    "rec_td": 0,
    "rec_tgt": 6,
    "rush_att": 2,
    "rush_td": 0,
    "rush_yd": 4,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Jordan Wilkins": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 20,
    "full_name": "jordanwilkins",
    "first_name": "Jordan",
    "last_name": "Wilkins",
    "position": "RB",
    "age": 25,
    "team": "IND",
    "player_id": "5100",
    "my_id": 5100,
    "gp": 16,
    "gs": 3,
    "pts_ppr": 60.1,
    "rec": 16,
    "rec_yd": 85,
    "rec_td": 0,
    "rec_tgt": 17,
    "rush_att": 60,
    "rush_td": 1,
    "rush_yd": 336,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 2
  },
  "Jaylen Samuels": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 38,
    "full_name": "jaylensamuels",
    "first_name": "Jaylen",
    "last_name": "Samuels",
    "position": "RB",
    "age": 23,
    "team": "PIT",
    "player_id": "5107",
    "my_id": 5107,
    "gp": 14,
    "gs": 3,
    "pts_ppr": 89.5,
    "rec": 26,
    "rec_yd": 199,
    "rec_td": 3,
    "rec_tgt": 29,
    "rush_att": 56,
    "rush_td": 0,
    "rush_yd": 256,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Russell Gage": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 83,
    "full_name": "russellgage",
    "first_name": "Russell",
    "last_name": "Gage",
    "position": "WR",
    "age": 23,
    "team": "ATL",
    "player_id": "5110",
    "my_id": 5110,
    "gp": 15,
    "gs": 0,
    "pts_ppr": 12.3,
    "rec": 6,
    "rec_yd": 63,
    "rec_td": 0,
    "rec_tgt": 10,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Javon Wims": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 83,
    "full_name": "javonwims",
    "first_name": "Javon",
    "last_name": "Wims",
    "position": "WR",
    "age": 25,
    "team": "CHI",
    "player_id": "5111",
    "my_id": 5111,
    "gp": 4,
    "gs": 0,
    "pts_ppr": 7.2,
    "rec": 4,
    "rec_yd": 32,
    "rec_td": 0,
    "rec_tgt": 5,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "David Williams": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 40,
    "full_name": "davidwilliams",
    "first_name": "David",
    "last_name": "Williams",
    "position": "RB",
    "age": 25,
    "team": null,
    "player_id": "5115",
    "my_id": 5115,
    "gp": 3,
    "gs": 0,
    "pts_ppr": 3.6,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 8,
    "rush_td": 0,
    "rush_yd": 36,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jordan Thomas": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 83,
    "full_name": "jordanthomas",
    "first_name": "Jordan",
    "last_name": "Thomas",
    "position": "TE",
    "age": 23,
    "team": "HOU",
    "player_id": "5117",
    "my_id": 5117,
    "gp": 16,
    "gs": 10,
    "pts_ppr": 65.5,
    "rec": 20,
    "rec_yd": 215,
    "rec_td": 4,
    "rec_tgt": 27,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Boston Scott": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 38,
    "full_name": "bostonscott",
    "first_name": "Boston",
    "last_name": "Scott",
    "position": "RB",
    "age": 24,
    "team": "PHI",
    "player_id": "5122",
    "my_id": 5122,
    "gp": 1,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Trenton Cannon": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 25,
    "full_name": "trentoncannon",
    "first_name": "Trenton",
    "last_name": "Cannon",
    "position": "RB",
    "age": 25,
    "team": "NYJ",
    "player_id": "5123",
    "my_id": 5123,
    "gp": 16,
    "gs": 0,
    "pts_ppr": 48.7,
    "rec": 17,
    "rec_yd": 144,
    "rec_td": 0,
    "rec_tgt": 25,
    "rush_att": 38,
    "rush_td": 1,
    "rush_yd": 113,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Kyle Allen": {
    "fantasy_positions": [
      "QB"
    ],
    "year": 2018,
    "number": 7,
    "full_name": "kyleallen",
    "first_name": "Kyle",
    "last_name": "Allen",
    "position": "QB",
    "age": 23,
    "team": "CAR",
    "player_id": "5127",
    "my_id": 5127,
    "gp": 2,
    "gs": 1,
    "pts_ppr": 26.54,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 5,
    "rush_td": 1,
    "rush_yd": 19,
    "td": 1,
    "pass_td": 2,
    "pass_int": 0,
    "pass_cmp": 20,
    "pass_att": 31,
    "pass_yd": 266,
    "pass_inc": 11,
    "fum_lost": 0
  },
  "Auden Tate": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 19,
    "full_name": "audentate",
    "first_name": "Auden",
    "last_name": "Tate",
    "position": "WR",
    "age": 22,
    "team": "CIN",
    "player_id": "5130",
    "my_id": 5130,
    "gp": 4,
    "gs": 0,
    "pts_ppr": 7.5,
    "rec": 4,
    "rec_yd": 35,
    "rec_td": 0,
    "rec_tgt": 12,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Justin Jackson": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 22,
    "full_name": "justinjackson",
    "first_name": "Justin",
    "last_name": "Jackson",
    "position": "RB",
    "age": 23,
    "team": "LAC",
    "player_id": "5131",
    "my_id": 5131,
    "gp": 9,
    "gs": 1,
    "pts_ppr": 61.1,
    "rec": 15,
    "rec_yd": 135,
    "rec_td": 0,
    "rec_tgt": 19,
    "rush_att": 50,
    "rush_td": 2,
    "rush_yd": 206,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Keith Kirkwood": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 18,
    "full_name": "keithkirkwood",
    "first_name": "Keith",
    "last_name": "Kirkwood",
    "position": "WR",
    "age": 25,
    "team": "NO",
    "player_id": "5134",
    "my_id": 5134,
    "gp": 8,
    "gs": 1,
    "pts_ppr": 45.9,
    "rec": 13,
    "rec_yd": 209,
    "rec_td": 2,
    "rec_tgt": 21,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Saeed Blacknall": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 80,
    "full_name": "saeedblacknall",
    "first_name": "Saeed",
    "last_name": "Blacknall",
    "position": "WR",
    "age": 23,
    "team": null,
    "player_id": "5135",
    "my_id": 5135,
    "gp": 1,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Josh Adams": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 36,
    "full_name": "joshadams",
    "first_name": "Josh",
    "last_name": "Adams",
    "position": "RB",
    "age": 22,
    "team": "NYJ",
    "player_id": "5136",
    "my_id": 5136,
    "gp": 13,
    "gs": 5,
    "pts_ppr": 81.9,
    "rec": 7,
    "rec_yd": 58,
    "rec_td": 0,
    "rec_tgt": 13,
    "rush_att": 120,
    "rush_td": 3,
    "rush_yd": 511,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Richie James": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 13,
    "full_name": "richiejames",
    "first_name": "Richie",
    "last_name": "James",
    "position": "WR",
    "age": 24,
    "team": "SF",
    "player_id": "5137",
    "my_id": 5137,
    "gp": 13,
    "gs": 2,
    "pts_ppr": 26,
    "rec": 9,
    "rec_yd": 130,
    "rec_td": 1,
    "rec_tgt": 14,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Trey Quinn": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 18,
    "full_name": "treyquinn",
    "first_name": "Trey",
    "last_name": "Quinn",
    "position": "WR",
    "age": 23,
    "team": "WAS",
    "player_id": "5139",
    "my_id": 5139,
    "gp": 3,
    "gs": 2,
    "pts_ppr": 22.5,
    "rec": 9,
    "rec_yd": 75,
    "rec_td": 1,
    "rec_tgt": 10,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Trent Sherfield": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 16,
    "full_name": "trentsherfield",
    "first_name": "Trent",
    "last_name": "Sherfield",
    "position": "WR",
    "age": 23,
    "team": "ARI",
    "player_id": "5154",
    "my_id": 5154,
    "gp": 13,
    "gs": 2,
    "pts_ppr": 46,
    "rec": 19,
    "rec_yd": 210,
    "rec_td": 1,
    "rec_tgt": 28,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Da'mari Scott": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 5,
    "full_name": "damariscott",
    "first_name": "Da'mari",
    "last_name": "Scott",
    "position": "WR",
    "age": 24,
    "team": "NYG",
    "player_id": "5166",
    "my_id": 5166,
    "gp": 3,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Phillip Lindsay": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 30,
    "full_name": "philliplindsay",
    "first_name": "Phillip",
    "last_name": "Lindsay",
    "position": "RB",
    "age": 25,
    "team": "DEN",
    "player_id": "5170",
    "my_id": 5170,
    "gp": 15,
    "gs": 8,
    "pts_ppr": 222.8,
    "rec": 35,
    "rec_yd": 241,
    "rec_td": 1,
    "rec_tgt": 47,
    "rush_att": 192,
    "rush_td": 9,
    "rush_yd": 1037,
    "td": 10,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jawill Davis": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 1,
    "full_name": "jawilldavis",
    "first_name": "Jawill",
    "last_name": "Davis",
    "position": "WR",
    "age": 24,
    "team": null,
    "player_id": "5175",
    "my_id": 5175,
    "gp": 7,
    "gs": 0,
    "pts_ppr": 8,
    "rec": 4,
    "rec_yd": 40,
    "rec_td": 0,
    "rec_tgt": 8,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Allen Lazard": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 13,
    "full_name": "allenlazard",
    "first_name": "Allen",
    "last_name": "Lazard",
    "position": "WR",
    "age": 23,
    "team": "GB",
    "player_id": "5185",
    "my_id": 5185,
    "gp": 1,
    "gs": 0,
    "pts_ppr": 1.7,
    "rec": 1,
    "rec_yd": 7,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Matt Flanagan": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 88,
    "full_name": "mattflanagan",
    "first_name": "Matt",
    "last_name": "Flanagan",
    "position": "TE",
    "age": 24,
    "team": null,
    "player_id": "5194",
    "my_id": 5194,
    "gp": 2,
    "gs": 1,
    "pts_ppr": 2.4,
    "rec": 1,
    "rec_yd": 14,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Mike Boone": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 23,
    "full_name": "mikeboone",
    "first_name": "Mike",
    "last_name": "Boone",
    "position": "RB",
    "age": 24,
    "team": "MIN",
    "player_id": "5209",
    "my_id": 5209,
    "gp": 8,
    "gs": 0,
    "pts_ppr": 6.8,
    "rec": 2,
    "rec_yd": 1,
    "rec_td": 0,
    "rec_tgt": 3,
    "rush_att": 11,
    "rush_td": 0,
    "rush_yd": 47,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Gus Edwards": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 35,
    "full_name": "gusedwards",
    "first_name": "Gus",
    "last_name": "Edwards",
    "position": "RB",
    "age": 24,
    "team": "BAL",
    "player_id": "5248",
    "my_id": 5248,
    "gp": 11,
    "gs": 6,
    "pts_ppr": 89.8,
    "rec": 2,
    "rec_yd": 20,
    "rec_td": 0,
    "rec_tgt": 2,
    "rush_att": 137,
    "rush_td": 2,
    "rush_yd": 718,
    "td": 2,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Robert Foster": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 16,
    "full_name": "robertfoster",
    "first_name": "Robert",
    "last_name": "Foster",
    "position": "WR",
    "age": 25,
    "team": "BUF",
    "player_id": "5250",
    "my_id": 5250,
    "gp": 13,
    "gs": 3,
    "pts_ppr": 99.1,
    "rec": 27,
    "rec_yd": 541,
    "rec_td": 3,
    "rec_tgt": 44,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 3,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jordan Franks": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 88,
    "full_name": "jordanfranks",
    "first_name": "Jordan",
    "last_name": "Franks",
    "position": "TE",
    "age": 23,
    "team": "CIN",
    "player_id": "5253",
    "my_id": 5253,
    "gp": 3,
    "gs": 0,
    "pts_ppr": 5.7,
    "rec": 2,
    "rec_yd": 37,
    "rec_td": 0,
    "rec_tgt": 3,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Vyncint Smith": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 17,
    "full_name": "vyncintsmith",
    "first_name": "Vyncint",
    "last_name": "Smith",
    "position": "WR",
    "age": 23,
    "team": "NYJ",
    "player_id": "5260",
    "my_id": 5260,
    "gp": 7,
    "gs": 1,
    "pts_ppr": 20.1,
    "rec": 5,
    "rec_yd": 91,
    "rec_td": 1,
    "rec_tgt": 10,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Detrez Newsome": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 38,
    "full_name": "detreznewsome",
    "first_name": "Detrez",
    "last_name": "Newsome",
    "position": "RB",
    "age": 25,
    "team": "LAC",
    "player_id": "5266",
    "my_id": 5266,
    "gp": 9,
    "gs": 0,
    "pts_ppr": 8.8,
    "rec": 2,
    "rec_yd": 19,
    "rec_td": 0,
    "rec_tgt": 2,
    "rush_att": 11,
    "rush_td": 0,
    "rush_yd": 49,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "JJ Jones": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 84,
    "full_name": "jjjones",
    "first_name": "JJ",
    "last_name": "Jones",
    "position": "WR",
    "age": 26,
    "team": null,
    "player_id": "5267",
    "my_id": 5267,
    "gp": 4,
    "gs": 0,
    "pts_ppr": -0.7,
    "rec": 1,
    "rec_yd": 3,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Gregory Howell Jr.": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 38,
    "full_name": "gregoryhowelljr",
    "first_name": "Gregory",
    "last_name": "Howell Jr.",
    "position": "RB",
    "age": 23,
    "team": "HOU",
    "player_id": "5271",
    "my_id": 5271,
    "gp": 15,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Roc Thomas": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 35,
    "full_name": "rocthomas",
    "first_name": "Roc",
    "last_name": "Thomas",
    "position": "RB",
    "age": 24,
    "team": null,
    "player_id": "5274",
    "my_id": 5274,
    "gp": 5,
    "gs": 0,
    "pts_ppr": 7.1,
    "rec": 2,
    "rec_yd": 21,
    "rec_td": 0,
    "rec_tgt": 4,
    "rush_att": 8,
    "rush_td": 0,
    "rush_yd": 30,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Deon Yelder": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 82,
    "full_name": "deonyelder",
    "first_name": "Deon",
    "last_name": "Yelder",
    "position": "TE",
    "age": 24,
    "team": "KC",
    "player_id": "5277",
    "my_id": 5277,
    "gp": 3,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Quadree Henderson": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 81,
    "full_name": "quadreehenderson",
    "first_name": "Quadree",
    "last_name": "Henderson",
    "position": "WR",
    "age": 23,
    "team": null,
    "player_id": "5279",
    "my_id": 5279,
    "gp": 5,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jeffery Wilson": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 30,
    "full_name": "jefferywilson",
    "first_name": "Jeffery",
    "last_name": "Wilson",
    "position": "RB",
    "age": 23,
    "team": "SF",
    "player_id": "5284",
    "my_id": 5284,
    "gp": 6,
    "gs": 2,
    "pts_ppr": 44.4,
    "rec": 12,
    "rec_yd": 98,
    "rec_td": 0,
    "rec_tgt": 15,
    "rush_att": 66,
    "rush_td": 0,
    "rush_yd": 266,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 2
  },
  "Ross Dwelley": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 82,
    "full_name": "rossdwelley",
    "first_name": "Ross",
    "last_name": "Dwelley",
    "position": "TE",
    "age": 24,
    "team": "SF",
    "player_id": "5285",
    "my_id": 5285,
    "gp": 10,
    "gs": 0,
    "pts_ppr": 3.4,
    "rec": 2,
    "rec_yd": 14,
    "rec_td": 0,
    "rec_tgt": 2,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Donnie Ernsberger": {
    "fantasy_positions": [
      "TE"
    ],
    "year": 2018,
    "number": 86,
    "full_name": "donnieernsberger",
    "first_name": "Donnie",
    "last_name": "Ernsberger",
    "position": "TE",
    "age": 23,
    "team": null,
    "player_id": "5288",
    "my_id": 5288,
    "gp": 2,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Cameron Batson": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 12,
    "full_name": "cameronbatson",
    "first_name": "Cameron",
    "last_name": "Batson",
    "position": "WR",
    "age": 23,
    "team": "TEN",
    "player_id": "5289",
    "my_id": 5289,
    "gp": 11,
    "gs": 2,
    "pts_ppr": 16.3,
    "rec": 8,
    "rec_yd": 82,
    "rec_td": 0,
    "rec_tgt": 11,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 1,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Deontay Burnett": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 18,
    "full_name": "deontayburnett",
    "first_name": "Deontay",
    "last_name": "Burnett",
    "position": "WR",
    "age": 22,
    "team": null,
    "player_id": "5290",
    "my_id": 5290,
    "gp": 5,
    "gs": 1,
    "pts_ppr": 24.3,
    "rec": 10,
    "rec_yd": 143,
    "rec_td": 0,
    "rec_tgt": 15,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Antonio Callaway": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 11,
    "full_name": "antoniocallaway",
    "first_name": "Antonio",
    "last_name": "Callaway",
    "position": "WR",
    "age": 22,
    "team": "CLE",
    "player_id": "5310",
    "my_id": 5310,
    "gp": 16,
    "gs": 11,
    "pts_ppr": 132.3,
    "rec": 43,
    "rec_yd": 586,
    "rec_td": 5,
    "rec_tgt": 78,
    "rush_att": 2,
    "rush_td": 0,
    "rush_yd": 7,
    "td": 5,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 1
  },
  "Equanimeous St. Brown": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 19,
    "full_name": "equanimeousstbrown",
    "first_name": "Equanimeous",
    "last_name": "St. Brown",
    "position": "WR",
    "age": 23,
    "team": "GB",
    "player_id": "5323",
    "my_id": 5323,
    "gp": 12,
    "gs": 7,
    "pts_ppr": 54.3,
    "rec": 21,
    "rec_yd": 328,
    "rec_td": 0,
    "rec_tgt": 36,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 5,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Tremon Smith": {
    "fantasy_positions": [
      "RB",
      "DB"
    ],
    "year": 2018,
    "number": 27,
    "full_name": "tremonsmith",
    "first_name": "Tremon",
    "last_name": "Smith",
    "position": "RB",
    "age": 23,
    "team": null,
    "player_id": "5328",
    "my_id": 5328,
    "gp": 13,
    "gs": 1,
    "pts_ppr": 5.5,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Nyheim Hines": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 21,
    "full_name": "nyheimhines",
    "first_name": "Nyheim",
    "last_name": "Hines",
    "position": "RB",
    "age": 22,
    "team": "IND",
    "player_id": "5347",
    "my_id": 5347,
    "gp": 16,
    "gs": 4,
    "pts_ppr": 160.9,
    "rec": 63,
    "rec_yd": 425,
    "rec_td": 2,
    "rec_tgt": 81,
    "rush_att": 85,
    "rush_td": 2,
    "rush_yd": 314,
    "td": 4,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Justin Watson": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 17,
    "full_name": "justinwatson",
    "first_name": "Justin",
    "last_name": "Watson",
    "position": "WR",
    "age": 24,
    "team": "TB",
    "player_id": "5374",
    "my_id": 5374,
    "gp": 12,
    "gs": 0,
    "pts_ppr": 1.5,
    "rec": 1,
    "rec_yd": 5,
    "rec_td": 0,
    "rec_tgt": 3,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Jalen Tolliver": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 88,
    "full_name": "jalentolliver",
    "first_name": "Jalen",
    "last_name": "Tolliver",
    "position": "WR",
    "age": 23,
    "team": null,
    "player_id": "5383",
    "my_id": 5383,
    "gp": 3,
    "gs": 1,
    "pts_ppr": 6.7,
    "rec": 3,
    "rec_yd": 37,
    "rec_td": 0,
    "rec_tgt": 6,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Steven Dunbar": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 13,
    "full_name": "stevendunbar",
    "first_name": "Steven",
    "last_name": "Dunbar",
    "position": "WR",
    "age": 23,
    "team": null,
    "player_id": "5391",
    "my_id": 5391,
    "gp": 1,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Shaun Wilson": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 31,
    "full_name": "shaunwilson",
    "first_name": "Shaun",
    "last_name": "Wilson",
    "position": "RB",
    "age": 23,
    "team": "WAS",
    "player_id": "5395",
    "my_id": 5395,
    "gp": 5,
    "gs": 0,
    "pts_ppr": 6.4,
    "rec": 3,
    "rec_yd": 5,
    "rec_td": 0,
    "rec_tgt": 5,
    "rush_att": 6,
    "rush_td": 0,
    "rush_yd": 29,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Cam Sims": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 89,
    "full_name": "camsims",
    "first_name": "Cam",
    "last_name": "Sims",
    "position": "WR",
    "age": 23,
    "team": "WAS",
    "player_id": "5432",
    "my_id": 5432,
    "gp": 1,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "De'Lance Turner": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 47,
    "full_name": "delanceturner",
    "first_name": "De'Lance",
    "last_name": "Turner",
    "position": "RB",
    "age": 24,
    "team": "BAL",
    "player_id": "5464",
    "my_id": 5464,
    "gp": 4,
    "gs": 0,
    "pts_ppr": 4.1,
    "rec": 2,
    "rec_yd": 17,
    "rec_td": 0,
    "rec_tgt": 2,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 4,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Dontrell Hilliard": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 25,
    "full_name": "dontrellhilliard",
    "first_name": "Dontrell",
    "last_name": "Hilliard",
    "position": "RB",
    "age": 24,
    "team": "CLE",
    "player_id": "5536",
    "my_id": 5536,
    "gp": 11,
    "gs": 0,
    "pts_ppr": 17.5,
    "rec": 9,
    "rec_yd": 105,
    "rec_td": 0,
    "rec_tgt": 10,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 1,
    "pass_cmp": 0,
    "pass_att": 1,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Derrick Willies": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 84,
    "full_name": "derrickwillies",
    "first_name": "Derrick",
    "last_name": "Willies",
    "position": "WR",
    "age": 25,
    "team": "CLE",
    "player_id": "5539",
    "my_id": 5539,
    "gp": 5,
    "gs": 0,
    "pts_ppr": 9.1,
    "rec": 3,
    "rec_yd": 61,
    "rec_td": 0,
    "rec_tgt": 5,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Darrel Williams": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 31,
    "full_name": "darrelwilliams",
    "first_name": "Darrel",
    "last_name": "Williams",
    "position": "RB",
    "age": 24,
    "team": "KC",
    "player_id": "5549",
    "my_id": 5549,
    "gp": 4,
    "gs": 0,
    "pts_ppr": 16.1,
    "rec": 3,
    "rec_yd": 27,
    "rec_td": 1,
    "rec_tgt": 3,
    "rush_att": 13,
    "rush_td": 0,
    "rush_yd": 44,
    "td": 1,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Janarion Grant": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 84,
    "full_name": "janariongrant",
    "first_name": "Janarion",
    "last_name": "Grant",
    "position": "WR",
    "age": 25,
    "team": null,
    "player_id": "5567",
    "my_id": 5567,
    "gp": 2,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Chad Beebe": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 12,
    "full_name": "chadbeebe",
    "first_name": "Chad",
    "last_name": "Beebe",
    "position": "WR",
    "age": 25,
    "team": "MIN",
    "player_id": "5570",
    "my_id": 5570,
    "gp": 3,
    "gs": 0,
    "pts_ppr": 7.9,
    "rec": 4,
    "rec_yd": 39,
    "rec_td": 0,
    "rec_tgt": 4,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Keith Ford": {
    "fantasy_positions": [
      "RB"
    ],
    "year": 2018,
    "number": 27,
    "full_name": "keithford",
    "first_name": "Keith",
    "last_name": "Ford",
    "position": "RB",
    "age": 25,
    "team": null,
    "player_id": "5624",
    "my_id": 5624,
    "gp": 2,
    "gs": 1,
    "pts_ppr": 13,
    "rec": 3,
    "rec_yd": 21,
    "rec_td": 0,
    "rec_tgt": 5,
    "rush_att": 21,
    "rush_td": 0,
    "rush_yd": 79,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Cam Phillips": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 87,
    "full_name": "camphillips",
    "first_name": "Cam",
    "last_name": "Phillips",
    "position": "WR",
    "age": 23,
    "team": null,
    "player_id": "5625",
    "my_id": 5625,
    "gp": 2,
    "gs": 0,
    "pts_ppr": 1.9,
    "rec": 1,
    "rec_yd": 9,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Chris Lacy": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 15,
    "full_name": "chrislacy",
    "first_name": "Chris",
    "last_name": "Lacy",
    "position": "WR",
    "age": 23,
    "team": "DET",
    "player_id": "5661",
    "my_id": 5661,
    "gp": 1,
    "gs": 0,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 1,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Nick Deluca": {
    "fantasy_positions": [
      "TE",
      "LB"
    ],
    "year": 2018,
    "number": 58,
    "full_name": "nickdeluca",
    "first_name": "Nick",
    "last_name": "Deluca",
    "position": "TE",
    "age": 24,
    "team": null,
    "player_id": "5670",
    "my_id": 5670,
    "gp": 9,
    "gs": 2,
    "pts_ppr": 0,
    "rec": 0,
    "rec_yd": 0,
    "rec_td": 0,
    "rec_tgt": 0,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Brandon Powell": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 15,
    "full_name": "brandonpowell",
    "first_name": "Brandon",
    "last_name": "Powell",
    "position": "WR",
    "age": 23,
    "team": "ATL",
    "player_id": "5695",
    "my_id": 5695,
    "gp": 6,
    "gs": 1,
    "pts_ppr": 24.3,
    "rec": 11,
    "rec_yd": 129,
    "rec_td": 0,
    "rec_tgt": 17,
    "rush_att": 1,
    "rush_td": 0,
    "rush_yd": 4,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Darvin Kidsy": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 84,
    "full_name": "darvinkidsy",
    "first_name": "Darvin",
    "last_name": "Kidsy",
    "position": "WR",
    "age": 24,
    "team": "WAS",
    "player_id": "5722",
    "my_id": 5722,
    "gp": 1,
    "gs": 0,
    "pts_ppr": 1.8,
    "rec": 1,
    "rec_yd": 8,
    "rec_td": 0,
    "rec_tgt": 2,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Khadarel Hodge": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 12,
    "full_name": "khadarelhodge",
    "first_name": "Khadarel",
    "last_name": "Hodge",
    "position": "WR",
    "age": 24,
    "team": "CLE",
    "player_id": "5773",
    "my_id": 5773,
    "gp": 13,
    "gs": 0,
    "pts_ppr": 3.7,
    "rec": 2,
    "rec_yd": 17,
    "rec_td": 0,
    "rec_tgt": 3,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  },
  "Malik Turner": {
    "fantasy_positions": [
      "WR"
    ],
    "year": 2018,
    "number": 17,
    "full_name": "malikturner",
    "first_name": "Malik",
    "last_name": "Turner",
    "position": "WR",
    "age": 23,
    "team": "SEA",
    "player_id": "5781",
    "my_id": 5781,
    "gp": 6,
    "gs": 0,
    "pts_ppr": 4,
    "rec": 2,
    "rec_yd": 20,
    "rec_td": 0,
    "rec_tgt": 3,
    "rush_att": 0,
    "rush_td": 0,
    "rush_yd": 0,
    "td": 0,
    "pass_td": 0,
    "pass_int": 0,
    "pass_cmp": 0,
    "pass_att": 0,
    "pass_yd": 0,
    "pass_inc": 0,
    "fum_lost": 0
  }
}

module.exports = playersAndStats18;